export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-06-13T12:36:58.375Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "10": "10",
        " - element testowy, zawierający pytania jednokrotnego lub wielokrotnego wyboru.": " - test element containing single or multiple choice questions.",
        " - element zawierający slajdy opisowe, czyli treści podawcze; można określić liczbę slajdów.).": " - element containing descriptive slides, i.e., informational content; you can specify the number of slides.",
        " - główny element grupujący (np. rozdział lub sekcja szkolenia).": " - main grouping element (e.g., chapter or training section).",
        " dodanych w ": " added in ",
        " Elementy do uzupełnienia w tekście zamieszczamy pomiędzy zdefiniowanymi znacznikami %$dowolna_nazwa$%.": " Elements to be completed are placed between the defined tags %$dowolna_name$%.",
        " godz.": " hrs.",
        " opublikowanych": " published",
        " użytkowników.": " users.",
        "-": "-",
        "...": "...",
        "...nie znalazłeś bloku?": "... have you not found the block?",
        "...nie znalazłeś bloku? Dodaj nowy.": "...didn't find a block? Add a new one.",
        "' + file.filename + '": "' + file.filename + '",
        "' + func.name + '": "' + func.name + '",
        "' + option.name + '": "' + option.name + '",
        "{Potwierdzenie przywrócenia": "{Confirmation of restoration",
        "%$ – znacznik otwierający tag": "%$ – tag to start a tag",
        "%0": "%0",
        "%0 z %1": "%0 of %1",
        "%0 znaków": "%0 characters",
        "<Brak nazwy>": "<No name>",
        "${copied ? 'Skopiowano' : 'Kopiuj'}": "${copied ? 'Copied' : 'Copy'}",
        "${el.text}": "${el.text}",
        "${form.variants > 1 ? 'Generuj obrazy' : 'Generuj obraz'}": "${form.variants > 1 ? 'Generate images' : 'Generate image'}",
        "${getCurrentScope().label}": "${getCurrentScope().label}",
        "${item.entityName}": "${item.entityName}",
        "${item.name}": "${item.name}",
        "${item.text}": "${item.text}",
        "${props.inputPlaceholder}": "${props.inputPlaceholder}",
        "${str}": "${str}",
        "${tokenVisibility ? 'Ukryj' : 'Pokaż'} token": "${tokenVisibility ? 'Hide' : 'Show'} token",
        "${widget.name}": "${widget.name}",
        "$% - znacznik zamykający tag": "$% - tag to close a tag",
        "1 godzina": "1 hour",
        "1:1": "1:1",
        "10 minut": "10 minutes",
        "12 godzin": "12 hours",
        "15 minut": "15 minutes",
        "1K tokenów": "1K tokens",
        "1M tokenów": "1M tokens",
        "2 dni": "2 days",
        "2 miesiące": "2 months",
        "2 tygodnie": "2 weeks",
        "24 godziny": "24 hours",
        "3 dni": "3 days",
        "3 godziny": "3 hours",
        "3 miesiące": "3 months",
        "30 minut": "30 minutes",
        "4 dni": "4 days",
        "4:7": "4:7",
        "5 dni": "5 days",
        "5 minut": "5 minutes",
        "6 dni": "6 days",
        "6 godzin": "6 hours",
        "7:4": "7:4",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "To add team members, you have to save the form.",
        "Aby dodawać użytkowników do szkolenia musisz najpierw zapisać formularz.": "To add users to the course, you have to save the form.",
        "Aby dodawać użytkowników do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "To add users to the learning path, you have to save the form.",
        "Aby dodawać użytkowników do terminu musisz najpierw zapisać formularz.": "To add users to the appointment, you must first save the form.",
        "Aby dodawać użytkowników do wydarzenia musisz najpierw zapisać formularz.": "To add users to an event, you must first save the form.",
        "Aby dodawać wydziały musisz najpierw zapisać formularz.": "To add departments, you must first save the form.",
        "Aby dodawać zespół do szkolenia musisz najpierw zapisać formularz.": "To add a team to the course, you have to save the form.",
        "Aby dodawać zespół do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "To add a team to the learning path, you have to save the form.",
        "Aby móc korzystać z czatu, wybierz asystenta z listy i oznacz go jako głównego asystenta panelu.": "To use the chat, select an assistant from the list and mark them as the main panel assistant.",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "To test the validity of the keys, first save the form.",
        "Aby móc zapisać element szkolenia, powinien on posiadać przynajmniej jeden opublikowany slajd.": "To save a course component, it should have at least one published slide.",
        "Aby połączenie z API OpenAI zostało nawiązane, należy podać klucz wygenerowany na stronie producenta i wybrać wersję modelu. Połączenie z API jest sprawdzane przy zapisie formularza.": "To connect to the OpenAI API, it is necessary to provide the key generated on the provider's website and select the model version. The connection to the API is checked when the form is saved.",
        "Aby uzyskać najlepsze rezultaty, zalecamy stosowanie poniższych wskazówek podczas definiowania prompta dla kreatora szkoleń AI.": "For best results, we recommend following the tips below when defining a prompt for the AI training creator.",
        "Aby zobaczyć aktualny podgląd certyfikatu kliknij Zapisz.": "To preview the certificate, click Save.",
        "Adaptive sampling": "Adaptive sampling",
        "Administracja": "Administration",
        "Administracja - Kraje": "Administration - Countries",
        "Administracja - Miasta": "Administration - Cities",
        "Administracja - Role": "Administration - Roles",
        "Administracja - Stanowiska pracy": "Administration - Positions",
        "Administracja - Użytkownicy": "Administration - Users",
        "Administracja - Województwa": "Administration - Voivodships",
        "Administracja - Zespoły": "Administration - Teams",
        "Administratorzy": "Administrators",
        "Adres": "Address",
        "Adres API": "API address",
        "Adres docelowy": "Target address",
        "Adres domenowy": "Domain address",
        "Adres domeny": "Domain address",
        "Adres e-mail potwierdzony": "The email address has been confirmed",
        "Adres email": "Email address",
        "Adres email nadawcy": "Sender's email address",
        "Adres IP": "IP address",
        "Adres IP: %0": "IP address: %0",
        "Adres kanoniczny": "Canonical address",
        "Adres serwera": "Server address",
        "Adres strony": "Website address",
        "Adres url": "Url",
        "Adres URL": "URL",
        "Adres url do pliku wideo": "Url to video file",
        "Adres URL profilu autora.": "URL of the author profile.",
        "Adres URL Webinaru": "Webinar URL",
        "Adres źródłowy": "Source address",
        "Adresy email": "Email addresses",
        "Akcent": "Accent",
        "Akceptacja": "Acceptance",
        "Akceptacja dokumentów": "Document approval",
        "Akceptacja dokumentu": "Document approval",
        "Akceptacja komentarzy": "Accept comments",
        "Akceptacja własnych dokumentów": "Approval of own documents",
        "Akceptacja wszystkich dokumentów": "Approval of all documents",
        "Akceptowalny typ plików": "Acceptable file type",
        "Akceptowany format danych": "Accepted data format",
        "Akceptuj": "Accept",
        "Akcja": "Action",
        "Akcja zakończona niepowodzeniem dla: ": "Action failed for: ",
        "Akcje": "Actions",
        "Akordeon": "Accordion",
        "Aktualizacja definicji": "Definition update",
        "Aktualizacja pkiów Kreatora szkoleń nie powiodła się": "Training Creator file update failed",
        "Aktualizacja wpisu": "Entry update",
        "Aktualizacja wyników szkolenia użytkowników została dodana do kolejki zadań.": "The user course results update has been added to the task queue.",
        "Aktualizacja: {0}": "Update: {0}",
        "Aktualizuj": "Update",
        "Aktualizuj wątek": "Update thread",
        "Aktualna sesja": "Current session",
        "Aktualne hasło": "Current password",
        "Aktualne urządzenie": "Current device",
        "Aktualności": "News",
        "Aktualności ze strony": "Website news",
        "Aktualny": "Current",
        "Aktywna": "Active",
        "Aktywne": "Active",
        "Aktywne kanały komunikacji": "Active communication channels",
        "Aktywne sesje": "Current sessions",
        "Aktywne teraz": "Active now",
        "Aktywne źródła": "Active sources",
        "Aktywni": "Active",
        "Aktywność": "Activity",
        "Aktywny": "Active",
        "Aktywuj AI": "Activate AI",
        "Aktywuj inteligentne usługi oparte o sztuczną inteligencję.": "Activate intelligent services based on artificial intelligence.",
        "Aktywuj tłumaczenia": "Activate translations",
        "Aktywuj zestaw inteligentnych narzędzi": "Activate the set of intelligent tools",
        "Alert": "Alert",
        "Alfabetycznie": "Alphabetically",
        "Alias": "Alias",
        "Alias został przepięty.": "Alias has been switched.",
        "Angielski": "English",
        "Ankieta": "Survey",
        "Ankieta po szkoleniu": "Post-training survey",
        "Ankieta po szkoleniu jest już nieaktualna.": "The post-course survey is no longer current.",
        "Ankieta przed i po szkoleniu": "Survey before and after the course",
        "Ankieta przed szkoleniem": "Pre-training survey",
        "Ankieta przed szkoleniem jest już nieaktualna.": "The pre-course survey is no longer current.",
        "Ankiety": "Surveys",
        "Anonimizuj": "Anonymize",
        "Anonimowy": "Anonymous",
        "Anulowany": "Canceled",
        "Anuluj": "Cancel",
        "Anuluj edycję": "Undo",
        "Anuluj wszystkie wprowadzone zmiany": "Cancel all the changes made",
        "Aplikacja": "Application",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "The application will restart within a maximum of 60 seconds.",
        "Apple iPad": "Apple iPad",
        "Apple iPhone 5": "Apple iPhone 5",
        "Apple iPhone 6": "Apple iPhone 6",
        "Application Insights": "Application Insights",
        "application/json": "application/json",
        "application/x-www-form-urlencoded": "application/x-www-form-urlencoded",
        "Aranżacja": "Arrangement",
        "Aranżacja alternatywna": "Alternative arrangement",
        "Aranżacja domyślna": "Default arrangement",
        "Aranżacja główna": "Main arrangement",
        "Aranżacja utowrzona przez": "Arranged by",
        "Aranżacja została dodana.": "Arrangement has been added.",
        "Aranżacja została opublikowana.": "The arrangement has been published.",
        "Aranżacja została usunięta.": "Arrangement has been deleted.",
        "Aranżacja została zachowana.": "The arrangement has been saved.",
        "Aranżacja została zaktualizowana.": "Arrangement has been updated.",
        "Aranżacje": "Arrangements",
        "Archiwalne elementy szkolenia": "Archived course elements",
        "Archiwizuj": "Archive",
        "Archiwizuj materiał lekcji": "Archive lesson materials",
        "Archiwizuj materiał testu": "Archive test material",
        "Archiwizuj przez maksymalnie (dni)": "Archive for a maximum of (days)",
        "Archiwizuj stronę": "Archive site",
        "Archiwum": "Archive",
        "Artykuł": "Article",
        "Artykuł otwarty": "Open article",
        "Artykuł premium": "Premium article",
        "Artykuł Premium": "Premium Article",
        "Artykuł sponsorowany": "Sponsored article",
        "Artykuły": "Articles",
        "Artykuły ze statusem PRIORYTET": "Articles with PRIORITY status",
        "Asystenci": "Assistants",
        "Asystent": "Assistant",
        "Asystent AI": "AI Assistant",
        "Asystent główny": "Main assistant",
        "Asystent został dodany.": "Assistant has been added.",
        "Asystent został usunięty.": "Assistant has been deleted.",
        "Asystent został zaktualizowany.": "Assistant has been updated.",
        "Asystenta AI": "AI assistant",
        "Audio": "Audio",
        "Audio z biblioteki": "Audio from library",
        "Automatyczna akceptacja": "Auto acceptance",
        "Automatyczna akceptacja komentarzy zalogowanych użytkowników": "Automatic acceptance of comments from logged-in users",
        "Automatyczna akceptacja wszystkich komentarzy": "Automatic acceptance of all comments",
        "Automatyczna publikacja galerii": "Automatic gallery publication",
        "Automatyczne akceptacja wersji po osiągnięciu daty publikacji. Wybrana wersja musi mieć ustawiony status na \"Ukończony\"": "Automatic version acceptance on the publication date. The selected version must be given status \"Completed\"",
        "Automatyczny": "Automatic",
        "Automatyzacja": "Automation",
        "Autor": "Author",
        "Autor nie może zostać usunięty, ponieważ jest przypisany do artykułów": "Author cannot be deleted because they are assigned to articles",
        "Autor spotkania": "Meeting author",
        "Autor szkolenia": "Course author",
        "Autor został dodany.": "Author has been added.",
        "Autor został usunięty.": "Author has been deleted.",
        "Autor został zaktualizowany.": "Author has been updated.",
        "Autor/adres IP": "Author/IP address",
        "Autorzy": "Authors",
        "Autorzy spoza bazy użytkowników": "Authors outside the user database",
        "Azure": "Azure",
        "Azure AD": "Azure AD",
        "Azure AI": "Azure AI",
        "Azure Application Insights": "Azure Application Insights",
        "Azure OpenAI": "Azure OpenAI",
        "Barwa tekstu": "Text color",
        "Barwa tła": "Background color",
        "Basic Auth": "Basic Auth",
        "Baza danych": "Database",
        "Baza danych tego klienta jest nieaktualna.": "This client's database is outdated.",
        "Baza dokumentów": "Document database",
        "Bazowy model danych": "Base data model",
        "Bazy danych": "Database",
        "Bez \"http(s)://\" i \"/\" na końcu.": "No \"http(s)://\" and \"/\" at the end.",
        "Bezpieczeństwo": "Safety",
        "Bezpieczne połączenie SSL": "Secure SSL connection",
        "Bezpieczny adres URL": "Secure URL",
        "Biały": "White",
        "Biblioteka": "Library",
        "Bieżący dokument": "Current document",
        "Blok aktywny": "Active block",
        "Blok unikalny może zostać użyty tylko raz": "Unique block can only be used once",
        "Blok został usunięty.": "The block has been removed.",
        "Blokada konta": "Account blocked",
        "Blokada konta do": "Account lock until",
        "Bloki": "Blocks",
        "Blokowanie kont": "Account blocking",
        "Blokowanie użytkowników": "Block users",
        "Blokowanie użytkowników szkoleń": "Block course users",
        "Błąd": "Error",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "Error 404. The requested resource was not found.",
        "Błąd w kolumnie ${error.columnName} w wierszu ${error.actualRow} - ${error.error}": "Error in column ${error.columnName} in row ${error.actualRow} - ${error.error}",
        "Błędne": "Incorrect",
        "Błędnie określona liczba, sprawdź liczbę opublikowanych materiałów.": "Incorrect number, check the number of published materials.",
        "Błędny": "Invalid",
        "Błędny format adresu e-mail": "Invalid email address format",
        "Błędy": "Errors",
        "Błędy walidacji należy przypisać do \"entry.errors.value\" w postaci tablicy komunikatów.": "Validation errors should be assigned to \"entry.errors.value\" as an array of messages.",
        "Bool": "Bool",
        "brak": "none",
        "Brak": "Lack",
        "Brak artykułów": "No articles",
        "Brak cennika dla wybranego dostawcy.": "No pricing for the selected provider.",
        "Brak danych": "No data",
        "Brak dodanych kolumn": "No columns added",
        "Brak dodanych plików": "No files added",
        "Brak dostępu do szkoleń": "No access to the course",
        "Brak elementów": "No items",
        "Brak etykiety": "No label",
        "Brak kategorii": "No categories",
        "Brak kategorii nadrzędnej": "No parent category",
        "Brak kluczy": "No keys",
        "Brak kolekcji": "No collection",
        "Brak listy regulaminów": "No list of regulations",
        "Brak materiałów": "No materials",
        "Brak modułu": "No module",
        "Brak możliwości zmiany spotkania po utworzeniu terminu.": "No possibility to change the meeting after creating the appointment.",
        "Brak nowych powiadomień.": "No new notifications.",
        "Brak odpowiedzi": "No response",
        "Brak ograniczenia": "No limit",
        "Brak opcji": "No options",
        "Brak opisu": "No description",
        "Brak plików do dodania": "No files to add",
        "Brak powiązania ze szkoleniem": "No link with course",
        "Brak powiązań": "No connection",
        "Brak produktów w kolekcji": "No products in collection",
        "Brak stron": "No pages",
        "Brak strony nadrzędnej": "No parent page",
        "Brak tematu": "No topic",
        "Brak typu zadania": "No task type",
        "Brak uprawnień do zaliczania elementów.": "No privileges to complete items.",
        "Brak wersji": "No version",
        "Brak wyboru": "No choice",
        "brak wyboru...": "no selection...",
        "Brak wybranych autorów": "No selected authors",
        "Brak wyników": "No results",
        "Brak zdefiniowanych ról.": "No defined roles.",
        "Brak zdefiniowanych zespołów.": "No defined teams.",
        "Brakujące tytuły kafelków.": "Missing tile titles.",
        "Bramka SMS": "SMS gateway",
        "Browse files": "Browse files",
        "Browse links": "Browse links",
        "Build": "Build",
        "Cache": "Cache",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "Cache will be stored using Redis server.",
        "Cache po stronie serwera": "Server-side cache",
        "Cache-Control": "Cache-Control",
        "Cechy": "Features",
        "Cel aktywny": "Active goal",
        "Cel został dodany.": "Goal has been added.",
        "cel został usunięty.": "Goal has been deleted.",
        "Cel został zaktualizowany.": "Goal has been updated.",
        "Cele": "Goals",
        "Cena": "Price",
        "Cena brutto": "Gross price",
        "Cena netto": "Net price",
        "Cena netto - aktualna": "Net price - current",
        "Cena netto - najniższa z ostatnich 30 dni": "Net price - lowest in the last 30 days",
        "Cena netto - regularna": "Net price - regular",
        "Cena w dolarach sumy tokenów wejściowych i wyjściowych.": "Price in dollars for the sum of input and output tokens.",
        "Cennik Azure OpenAI": "Azure OpenAI pricing",
        "Cennik AzureAI": "AzureAI pricing",
        "Cennik OpenAI": "OpenAI pricing",
        "Centrum powiadomień": "Notification center",
        "Certyfikat": "Certificate",
        "Certyfikat jest opublikowany": "The certificate is published",
        "Certyfikat nie jest opublikowany": "Certificate is not published",
        "Certyfikat przygotowany jest do formatu A4. Wyświetlany podgląd stanowi jedynie widok roboczy. Docelowy wygląd certyfikatu będzie powiązany z właściwymi danymi szkolenia oraz użytkownika.": "The certificate is prepared in A4 format. The preview displayed is only a draft. The desired appearance of the certificate will be associated with the relevant course and user data.",
        "Certyfikat został dodany.": "The certificate has been added.",
        "Certyfikat został usunięty.": "The certificate has been removed.",
        "Certyfikat został zaktualizowany.": "The certificate has been updated.",
        "Certyfikat-podgląd": "Certificate-preview",
        "Certyfikatów": "Certificates",
        "Certyfikaty": "Certificates",
        "Chat": "Chat",
        "Chcesz przywrócić temat wraz z elementami?": "Want to restore the theme with components?",
        "Chcesz przywrócić ten element?": "Want to restore this component?",
        "Checkbox": "Checkbox",
        "Choices": "Choices",
        "Ciemny": "Dark",
        "Cienka": "Thin",
        "Client ID": "Client ID",
        "Client Secret": "Client Secret",
        "CMS": "CMS",
        "co": "every",
        "Co 10 dni": "Every 10 days",
        "Co 10 minut": "Every 10 minutes",
        "Co 12 godzin": "Every 12 hours",
        "Co 15 minut": "Every 15 minutes",
        "Co 2 godziny": "Every 2 hours",
        "Co 2 minuty": "Every 2 minutes",
        "Co 2 tygodnie": "Every 2 weeks",
        "Co 20 minut": "Every 20 minutes",
        "Co 3 godziny": "Every 3 hours",
        "co 3 miesiące": "every 3 months",
        "Co 3 miesiące": "Every 3 months",
        "co 30 dni": "every 30 days",
        "Co 30 minut": "Every 30 minutes",
        "Co 4 miesiące": "Every 4 months",
        "Co 5 dni": "Every 5 days",
        "Co 5 minut": "Every 5 minutes",
        "Co 6 godzin": "Every 6 hours",
        "co 6 miesięcy": "every 6 months",
        "Co chcesz wygenerować?": "What do you want to generate?",
        "Co drugi dzień": "Every other day",
        "Co drugi miesiąc": "Every other month",
        "Co godzinę": "Every hour",
        "Co miesiąc": "Every month",
        "Co minutę": "Every minute",
        "Co pół roku": "Every half year",
        "co rok": "every year",
        "Co rok": "Every year",
        "Co tydzień": "Every week",
        "Codziennie": "Every day",
        "Connection String": "Connection String",
        "Coś poszło nie tak": "Something went wrong",
        "CRC": "CRC",
        "Created": "Created",
        "Cron": "Cron",
        "Cyfry": "Digits",
        "Cykliczne": "Cyclic",
        "Cykliczność": "Cyclicality",
        "Cytat": "Quote",
        "Cytaty": "Quotes",
        "Czarny": "Black",
        "Czas": "Time",
        "Czas dostępu do szkolenia (liczba dni)": "Training access time (number of days)",
        "Czas dostępu do ścieżki (liczba dni)": "Path access time (number of days)",
        "Czas na realizację szkolenia (liczba dni)": "Time to complete training (number of days)",
        "Czas na realizację ścieżki (liczba dni)": "Time to complete path (number of days)",
        "Czas na slajd": "Time per slide",
        "Czas na stronie": "Time on page",
        "Czas nieaktywności użytkownika po którym zostanie wylogowany z panelu administracyjnego [min": "User inactivity time after which they will be logged out of admin panel [min",
        "Czas pomiędzy": "Time between",
        "Czas rozpoczęcia": "Start time",
        "Czas trwania": "Duration",
        "Czas trwania blokady": "Account blocking time",
        "Czas trwania: %0": "Duration: %0",
        "Czas uruchomienia": "Start time",
        "Czas ważności certyfikatu (liczba dni)": "Certificate validity period (number of days)",
        "Czas zakończenia": "End time",
        "Czat z asystentem": "Chat with assistant",
        "czerwcu": "June",
        "czerwiec": "June",
        "Czerwiec": "June",
        "Czerwony": "Red",
        "Częstotliwość odświeżania": "Refresh rate",
        "Członkowie zespołu": "Team members",
        "Czołówka": "Header",
        "Czołówka została dodana.": "Header has been added.",
        "Czołówka została usunięta.": "Header has been deleted.",
        "Czołówka została zaktualizowana.": "Header has been updated.",
        "Cztery kolumny": "Four columns",
        "Czwartek": "Thursday",
        "Czy aby na pewno chesz przywrócić ustawienia domyślne?": "Are you sure you want to restore default settings?",
        "Czy aby na pewno chesz zrestartować aplikacje?": "Are you sure you want to restart the application?",
        "Czy chcesz wygenerować plan szkolenia?": "Do you want to generate a training plan?",
        "Czy chcesz wygenerować szkolenie na podstawie aktualnego planu?": "Do you want to generate training based on the current plan?",
        "Czy na pewno chcesz ukryć wiadomość?": "Are you sure you want to hide the message?",
        "Czy na pewno chcesz usunąć widget?": "Are you sure you want to delete the widget?",
        "Czy na pewno chcesz wyczyścić pamięć podręczną?": "Are you sure you want to clear the cache?",
        "Czy na pewno chcesz zablokować użytkownika?": "Are you sure you want to block a user?",
        "Czy na pewno chcesz zaktualizować definicje wszystkich dokumentów?": "Are you sure you want to update definitions for all documents?",
        "Czy na pewno chcesz zkopiować szkolenie?": "Are you sure you want to copy the course?",
        "Czy opublikowany": "Whether published",
        "Czy zablokować użytkownika i jego wiadomość?": "Do you want to block the user and messages?",
        "Czytać mogą tylko zalogowani użytkownicy": "Only logged-in users can read it",
        "Dalej": "Next",
        "DALL-E 3": "DALL-E 3",
        "DALLE-3": "DALLE-3",
        "Dane": "Data",
        "Dane formularza są przechowywane w obiekcie Entry.": "The form data is stored in the Entry object.",
        "Dane osobowe": "Personal data",
        "Dane tabelaryczne": "Tabular data",
        "Dane wejściowe": "Input data",
        "Dane wyjściowe": "Output data",
        "Dane z formularza zapisywane anonimowo": "Form data saved anonymously",
        "Dashboard": "Dashboard",
        "Dashboard aktywny": "Active dashboard",
        "Dashboard domyślny": "Default dashboard",
        "Dashboard szkolenia": "Course dashboard",
        "Dashboard został dodany.": "Dashboard has been added.",
        "Dashboard został skopiowany.": "Dashboard has been copied.",
        "Dashboard został usunięty.": "Dashboard has been deleted.",
        "Dashboard został zaktualizowane.": "Dashboard has been updated.",
        "Dashboardy": "Dashboards",
        "Data": "Date",
        "Data akceptacji": "Acceptance date",
        "Data automatycznej akceptacji": "Auto acceptance date",
        "Data dezaktywacji": "Deactivation date",
        "Data do": "Date to",
        "Data dodania": "Adding date",
        "Data i czas": "Date and time",
        "Data informująca o terminie wejścia w życie tego regulaminu.": "The date informing about date of entry into force of these regulations.",
        "Data końcowa": "End date",
        "Data logowania": "Login date",
        "Data modyfikacji": "Modification date",
        "Data modyfikacji do": "Modification date until",
        "Data modyfikacji od": "Modification date from",
        "Data modyfikacji:": "Modification date:",
        "Data od": "Date from",
        "Data odrzucenia": "Rejection date",
        "Data odrzucenia:": "Rejection date:",
        "Data opuszczenia zespołu": "Date of leaving the team",
        "Data ostatniej aktualizacji danych": "Last data update date",
        "Data ostatniej edycji": "Last edit date",
        "Data otrzymania": "Receipt date",
        "Data otrzymania punktów": "Points received date",
        "Data otrzymania punktów do": "Points received date until",
        "Data otrzymania punktów od": "Points received date from",
        "Data publikacji": "Publication date",
        "Data publikacji:": "Publication date:",
        "Data rejestracji": "Registration date",
        "Data rezygnacji": "Resignation date",
        "Data rezygnacji do": "Resignation date until",
        "Data rezygnacji od": "Resignation date from",
        "Data rozpoczęcia": "Start date",
        "Data rozpoczęcia spotkania od": "Meeting start date from",
        "Data subskrypcji": "Subscription date",
        "Data uruchomienia": "Start time",
        "Data uruchomienia (UTC)": "Launch date (UTC)",
        "Data usunięcia": "Deletion date",
        "Data utworzenia": "Creation date",
        "Data utworzenia (do)": "Creation date (to)",
        "Data utworzenia (od)": "Creation date (from)",
        "Data utworzenia aranżacji": "Arrangement creation date",
        "Data utworzenia wersji": "Version creation date",
        "Data utworzenia: ": "Creation date: ",
        "Data uzyskania certyfikatu": "Certificate acquisition date",
        "Data uzyskania do": "Certificate acquisition date until",
        "Data uzyskania od": "Certificate acquisition date from",
        "Data użycia": "Use date",
        "Data wydania": "Release date",
        "Data wygaśnięcia": "Expiration date",
        "Data wylogowania": "Logout date",
        "Data wysłania": "Send date",
        "Data wywołania": "Call date",
        "Data zakończenia": "End date",
        "Data zakończenia zapisów do": "Registration end date until",
        "Data zakończenia zapisów od": "Registration end date from",
        "Data zakończenia zapisów: ": "Registration end date: ",
        "Data zakónczenia spotkania do": "Meeting end date until",
        "Data zaliczenia": "Completion date",
        "Data zalogowania": "Login date",
        "Data zapisania się": "Sign-up date",
        "Data zapisania się do": "Sign-up date until",
        "Data zapisania się od": "Sign-up date from",
        "Data zapisu": "Registration date",
        "Data zapytania": "Query date",
        "Data zdarzenia": "Event date",
        "Data zgłoszenia": "Notification date",
        "Data: %0 | Status: %1": "Date: %0 | Status: %1",
        "DateTime": "DateTime",
        "Daty dostępów dla użytkowników ze ścieżki szkoleniowej są nadrzędne, daty dostępów dodane w szkoleniu nie będą brane pod uwagę.": "Access dates for users in the learning path are parent, access dates added in the course will not be taken into account.",
        "Daty publikacji zostały zaktualizowane.": "The publication dates have been updated.",
        "Debug": "Debug",
        "Dedykowane": "Dedicated",
        "DeepL": "DeepL",
        "Definicja": "Definition",
        "Definicja (JSON)": "Definition (JSON)",
        "Definicja formularza znajduje się w obiekcie Form.": "The form definition is in the Form object.",
        "Definicja szablonu": "Template definition",
        "Definicje zostały zaktualizowane.": "Definitions have been updated.",
        "DELETE: Usunięcie wpisu": "DELETE: Entry deletion",
        "Design Studio": "Design Studio",
        "Diagram": "Diagram",
        "Długi tekst": "Long text",
        "Długość": "Length",
        "Długość [%": "Length [%",
        "Długość czasu przechowywania": "Retention period",
        "Długość geograficzna": "Longitude",
        "Długość historii haseł": "Password history length",
        "Długość treści": "Content length",
        "Długość trwania sesji (min)": "Session duration (min)",
        "Dni": "Days",
        "Dni i godziny": "Days and hours",
        "do": "to",
        "Do": "To",
        "Do akceptacji": "To be accepted",
        "do czasu ręcznego odblokowania": "until manually unlocked",
        "Do poziomu": "To level",
        "Do szkolenia nie przypisano jeszcze żadnych użytkowników.": "No assigned users to the course.",
        "Do szkolenia nie przypisano jeszcze żadnych zespołów.": "No assigned teams to the course.",
        "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych użytkowników.": "No assigned users to the learning path.",
        "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych zespołów.": "No assigned teams to the learning path.",
        "Do terminu nie przypisano jeszcze żadnych użytkowników.": "No users have been assigned to the appointment yet.",
        "Docelowa strona": "Target page",
        "Docs": "Docs",
        "Dodaj": "Add",
        "Dodaj aranżację": "Add arrangement",
        "Dodaj asystenta": "Add assistant",
        "Dodaj autora": "Add author",
        "Dodaj cel": "Add goal",
        "Dodaj certyfikat": "Add certificate",
        "Dodaj czołówkę": "Add header",
        "Dodaj dashboard": "Add dashboard",
        "Dodaj dni": "Add days",
        "Dodaj do zespołu": "Add to team",
        "Dodaj do zestawu": "Add to set",
        "Dodaj dokument": "Add document",
        "Dodaj dział": "Add section",
        "Dodaj element": "Add element",
        "Dodaj endpoint": "Add endpoint",
        "Dodaj etykietę": "Add tag",
        "Dodaj formularz": "Add form",
        "Dodaj funkcję": "Add function",
        "Dodaj galerię": "Add gallery",
        "Dodaj grupę": "Add group",
        "Dodaj jeden lub więcej widgetów, aby uzyskać wgląd w postępy swojego zespołu.": "Add one or more widgets to keep track of your team's progress.",
        "Dodaj kafelek": "Add tile",
        "Dodaj katalog": "Add directory",
        "Dodaj kategorie": "Add category",
        "Dodaj kategorię": "Add category",
        "Dodaj klienta": "Add client",
        "Dodaj kolejne słowo": "Add another word",
        "Dodaj kolejny powód": "Add another reason",
        "Dodaj kolekcję": "Add collection",
        "Dodaj komponent": "Add component",
        "Dodaj lekcję": "Add lesson",
        "Dodaj lekcję SCORM": "Add SCORM lesson",
        "Dodaj lekcję Wideo": "Add Video lesson",
        "Dodaj link": "Add link",
        "Dodaj materiał": "Add material",
        "Dodaj moduł": "Add module",
        "Dodaj mp3": "Add mp3",
        "Dodaj nowa kategorię": "Add new category",
        "Dodaj nową opinie": "Add new review",
        "Dodaj nową wersję dokumentu": "Add new document version",
        "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "Add a new website to start managing your pages.",
        "Dodaj nowy": "Add new",
        "Dodaj nowy folder": "Add new folder",
        "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "Add a new directory to start managing your pages.",
        "Dodaj nowy tag": "Add new tag",
        "Dodaj nowy wątek": "Add new thread",
        "Dodaj obrazek": "Add image",
        "Dodaj odpowiedź": "Add answer",
        "Dodaj odznakę": "Add badge",
        "Dodaj opinię": "Add review",
        "Dodaj paczkę SCORM": "Add SCORM package",
        "Dodaj parametr": "Add parameter",
        "Dodaj plik": "Add file",
        "Dodaj pliki": "Add files",
        "Dodaj pliki asystenta": "Add assistant files",
        "Dodaj podsumowanie": "Add summary",
        "Dodaj powiadomienie zbiorowe": "Add bulk notification",
        "Dodaj pozycję": "Add position",
        "Dodaj produkt": "Add product",
        "Dodaj przekierowanie": "Add redirect",
        "Dodaj punkt": "Add point",
        "Dodaj punkty": "Add points",
        "Dodaj pytanie": "Add question",
        "Dodaj regułe": "Add rule",
        "Dodaj rolę": "Add role",
        "Dodaj rotator": "Add rotator",
        "Dodaj scenariusz": "Add scenario",
        "Dodaj sekcję": "Add section",
        "Dodaj serwer": "Add server",
        "Dodaj shortcode": "Add shortcode",
        "Dodaj slajd": "Add slide",
        "Dodaj slajder": "Add slider",
        "Dodaj słowo": "Add word",
        "Dodaj sposób płatności": "Add payment method",
        "Dodaj spotkanie": "Add meeting",
        "Dodaj stanowisko": "Add position",
        "Dodaj stronę": "Add page",
        "Dodaj stwierdzenie": "Add statement",
        "Dodaj synonimy": "Add synonyms",
        "Dodaj szablon": "Add template",
        "Dodaj szkolenie": "Add course",
        "Dodaj ścieżkę": "Add path",
        "Dodaj temat": "Add topic",
        "Dodaj termin": "Add appointment",
        "Dodaj test": "Add test",
        "Dodaj token": "Add token",
        "Dodaj użytkownika": "Add user",
        "Dodaj wątek": "Add thread",
        "Dodaj webhooka": "Add webhook",
        "Dodaj wideo": "Add video",
        "Dodaj widget": "Add widget",
        "Dodaj wiersz": "Add row",
        "Dodaj witrynę": "Add website",
        "Dodaj wpis": "Add entry",
        "Dodaj wszystkie z kategorii": "Add all categories",
        "Dodaj wydarzenie": "Add event",
        "Dodaj zamówienie": "Add order",
        "Dodaj zastępstwo": "Add replacement",
        "Dodaj zespół": "Add team",
        "Dodaj zestaw": "Add set",
        "Dodaj źródło": "Add source",
        "dodał": "added",
        "dodane i edytowane przeze mnie": "added and edited by me",
        "Dodane pliki z sortowaniem": "Added files with sorting",
        "Dodane przez": "Added by",
        "Dodane przez moje zespoły": "Added by my teams",
        "Dodane przeze mnie": "Added by me",
        "Dodanie": "Adding",
        "Dodanie aktualności": "Add news",
        "Dodanie ankiety": "Add surveys",
        "Dodanie aranżacji": "Adding arrangement",
        "Dodanie artykułu": "Add article",
        "Dodanie asystenta": "Adding assistant",
        "Dodanie autora": "Adding author",
        "Dodanie certyfikatu": "Add certificate",
        "Dodanie czołówki": "Adding header",
        "Dodanie dashboardu": "Adding dashboard",
        "Dodanie dokumentu": "Add document",
        "Dodanie działu": "Add section",
        "Dodanie endpointu": "Adding endpoint",
        "Dodanie etykiety": "Add tag",
        "Dodanie funkcji": "Adding function",
        "Dodanie galerii": "Adding gallery",
        "Dodanie kategorii": "Add category",
        "Dodanie kategorii wydarzenia": "Adding event category",
        "Dodanie klienta": "Add client",
        "Dodanie kolekcji": "Adding collection",
        "Dodanie komponentu": "Adding component",
        "Dodanie lekcji": "Add lesson",
        "Dodanie linku": "Add link",
        "Dodanie modułu": "Adding module",
        "Dodanie opcji płatności": "Adding payment option",
        "Dodanie paczki SCORM": "Add SCORM package",
        "Dodanie pliku": "Adding file",
        "Dodanie poradnika": "Add guide",
        "Dodanie produktu": "Adding product",
        "Dodanie regulaminu": "Add regulations",
        "Dodanie roli": "Add role",
        "Dodanie rotatora": "Adding rotator",
        "Dodanie serwera": "Add server",
        "Dodanie slajdera": "Add slider",
        "Dodanie slajdów": "Add slides",
        "Dodanie spotkania": "Adding meeting",
        "Dodanie stanowiska": "Adding position",
        "Dodanie strony": "Add page",
        "Dodanie szablonu": "Add template",
        "Dodanie szkolenia": "Add course",
        "Dodanie ścieżki szkoleniowej": "Add learning path",
        "Dodanie terminu": "Adding appointment",
        "Dodanie testu": "Add test",
        "Dodanie top tematu": "Adding top topic",
        "Dodanie użytkownika": "Add user",
        "Dodanie webhooka": "Adding webhook",
        "Dodanie wideo": "Adding video",
        "Dodanie witryny": "Add website",
        "Dodanie wydarzenia": "Adding event",
        "Dodanie wyzwalacza jest wymagane.": "Adding trigger is required.",
        "Dodanie zamówienia": "Adding order",
        "Dodanie zastępstwa": "Add replacement",
        "Dodanie zespołu": "Add team",
        "Dodanie zestawu regulaminów": "Add set of regulations",
        "Dodanie źródła": "Add source",
        "Dodanie źródła danych": "Add data source",
        "Dodano za dużo plików (maksymalnie %0).": "Too many files added (maximum %0).",
        "dodany": "added",
        "Dodanych plików %0 (limit wynosi %1).": "Added files %0 (limit is %1).",
        "Dodatki do e-learningu": "E-learning extras",
        "Dodatkowe informacje": "Additional information",
        "Dodatkowe uwagi": "Additional notes",
        "Dodawanie": "Adding",
        "Dodawanie dokumentów": "Adding documents",
        "Dodawanie i edycja własnych dokumentów": "Adding and editing own documents",
        "Dodawanie odznaki": "Adding badge",
        "Dodawanie punktów": "Adding points",
        "Dodawanie wartości dwóch kolumn": "Adding values of two columns",
        "Dokument": "Document",
        "Dokument %0": "Document %0",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "The document has yet not been published anywhere.",
        "Dokument nie ma ustawionej daty publikacji.": "The document does not have a publication date set.",
        "Dokument PDF": "PDF document",
        "Dokument tekstowy": "Text document",
        "Dokument został dodany.": "Document has been added.",
        "Dokument został usunięty.": "The document has been deleted.",
        "Dokument został zaktualizowany.": "The document has been updated.",
        "Dokument_": "Document_",
        "Dokumenty": "Documents",
        "Dołącz stack trace": "Attach stack trace",
        "Dołącz stronę do pliku sitemap.xml": "Add the page to the sitemap file.xml",
        "Dołączanie plików": "Attaching files",
        "Domena": "Domain",
        "Domyślna": "Default",
        "Domyślna wartość": "Default value",
        "Domyślna witryna": "Default site",
        "Domyślne": "Default",
        "Domyślne filtry": "Default filters",
        "Domyślne ustawienie dla witryny": "Default site setting",
        "Domyślnie ukryte": "Hidden by default",
        "Domyślnie widoczne": "Visible by default",
        "Domyślny": "Default",
        "Domyślny poziom logowania": "Default logging level",
        "Domyślny tytuł aktywnej strony": "Default title of the active page",
        "Dopasowanie": "Match",
        "Dopasuj do kategorii": "Match to category",
        "Dopasuj do obrazka": "Match image",
        "Dopuść brak odpowiedzi": "Allow lack of response",
        "Dostawca": "Provider",
        "Dostęp ": "Access",
        "Dostęp do": "Access to",
        "Dostęp do modułu": "Access to module",
        "Dostęp do terminu": "Access to appointment",
        "dostęp indywidualny": "individual access",
        "Dostęp niezdefiniowany": "Undefined access",
        "Dostęp od": "Access from",
        "Dostęp przyznany": "Access granted",
        "Dostęp przyznany przez zespół": "Team-granted access",
        "Dostęp przyznany ręcznie": "Manually-granted access",
        "dostęp z zespołu": "team access",
        "Dostęp zabroniony": "Access denied",
        "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "A new update is available. Please save the work progress and click the \"Update\" button. You can also accept the update by refreshing the browser. Noo update may result in errors.",
        "Dostępne": "Available",
        "Dostępne bloki": "Available blocks",
        "Dostępne dla": "Available for",
        "Dostępne języki": "Available languages",
        "Dostępne moduły": "Available modules",
        "Dostępne są tylko wydarzenia, które mają włączoną opcję \"Wydarzenie dostępne tylko w module spotkań\"": "Only events with the option \"Event available only in the meeting module\" enabled are available",
        "Dostępne wersje językowe.": "Available language versions.",
        "Dostępny do": "Available until",
        "Dostępny limit": "Available limit",
        "Dostępny od": "Available from",
        "Dostępny w sekcjach": "Available in sections",
        "Dostępy": "Available",
        "Dotyczy tylko ikon dodanych w odpowiednim formacie wektorowym SVG": "Only icons added in the appropriate vector format SVG are allowed",
        "Double": "Double",
        "dowolnej wybranej wersji": "any selected version",
        "Dowolny": "Any",
        "Dozwolone rozszerzenia": "Allowed extensions",
        "Dozwolone rozszerzenia plików": "Allowed file extensions",
        "Dozwolone rozszerzenia: %0.": "Allowed extensions: %0.",
        "Dozwolone są tylko małe i duże litery": "Only uppercase and lowercase letters are allowed",
        "Dozwolone są tylko małe litery i znak -": "Only lowercase letters and the '-' character are allowed",
        "Dozwolone typy plików: %0.": "Allowed file types: %0.",
        "Dół": "Bottom",
        "Drugi": "Second",
        "Drugi klucz (MD5)": "Second key (MD5)",
        "Drugie imię": "Middle name",
        "Dsn": "Dsn",
        "Duplikuj": "Duplicate",
        "Duża": "Large",
        "Duże litery": "Uppercase letters",
        "Duży": "Big",
        "Duży układ siatki": "Large grid layout",
        "Dwie kolumny": "Two columns",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "Directive max-age=N indicates that the response remains fresh for N seconds after the response is generated.",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "Directive no-store indicates that any cache of any kind should not store this response.",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "Directive PRIVATE indicates that the response can only be stored in private cache (e.g., browser local cache).",
        "Dyrektywa przechowywania": "Storage directive",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "Directive PUBLIC indicates that the response can be stored in shared cache (e.g., proxy).",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "Directive s-maxage is ignored by private caches and overrides the value specified by the max-age directive for shared caches.",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "Directive s-maxage indicates how long the response remains fresh in shared cache (e.g., proxy).",
        "Dyrektywy zakresu": "Range directives",
        "Dział aktywny": "Active section",
        "Dział nadrzędny": "Parent section",
        "Dział został dodany.": "The section has been added.",
        "Dział został zaktualizowany.": "The section has been updated.",
        "Działania masowe": "Mass activities",
        "Działanie modułu w oparciu o": "Module operation based on",
        "Dzielenie": "Division",
        "Dzienny": "Daily",
        "dzień": "day",
        "Dzień": "Day",
        "dzień (dni)": "day(s)",
        "Dzień miesiąca": "Day of the month",
        "Dzisiaj": "Today",
        "E-learning": "E-Learning",
        "E-mail": "E-mail",
        "Edycja": "Edit",
        "Edycja aktualności": "Edit news",
        "Edycja ankiety": "Edit survey",
        "Edycja aranżacji": "Edit arrangement",
        "Edycja aranżacji dashboardu": "Edit dashboard arrangement",
        "Edycja artykułu": "Edit article",
        "Edycja asystenta": "Assistant edit",
        "Edycja autora": "Author edit",
        "Edycja certyfikatu": "Edit certificate",
        "Edycja czołówki": "Header edit",
        "Edycja dashboardu": "Edit dashboard",
        "Edycja dokumentów": "Document edit",
        "Edycja dokumentu": "Edit document",
        "Edycja działu": "Edit section",
        "Edycja endpointu": "Endpoint edit",
        "Edycja etykiety": "Edit label",
        "Edycja formularza": "Edit form",
        "Edycja funkcji": "Function edit",
        "Edycja galerii": "Gallery edit",
        "Edycja jest obecnie niedostępna, ponieważ trwa proces przetwarzania danych związanych z terminami szkoleń": "Edit is currently unavailable because the data processing related to training appointments is ongoing",
        "Edycja kategorii": "Edit category",
        "Edycja kategorii wydarzenia": "Event category edit",
        "Edycja klienta": "Edit client",
        "Edycja kolekcji": "Edit collection",
        "Edycja komentarza": "Edit comment",
        "Edycja komponentu": "Component edit",
        "Edycja lekcji": "Editing lesson",
        "Edycja linku": "Edit link",
        "Edycja logów": "Edit logs",
        "Edycja modułu": "Module edit",
        "Edycja odznaki": "Badge edit",
        "Edycja opcji płatności": "Edit payment option",
        "Edycja paczek SCORM": "Edit SCORM packages",
        "Edycja pliku": "File edit",
        "Edycja poradnika": "Edit guide",
        "Edycja produktu": "Edit product",
        "Edycja punktów": "Points edit",
        "Edycja regulaminu": "Edit regulations",
        "Edycja roli": "Edit role",
        "Edycja rotatora": "Rotator edit",
        "Edycja scenariusza": "Scenario edit",
        "Edycja serwera": "Edit server",
        "Edycja slajdera": "Edit slider",
        "Edycja slajdów": "Edit slides",
        "Edycja spotkania": "Meeting edit",
        "Edycja stanowiska": "Position edit",
        "Edycja strony": "Edit page",
        "Edycja szablonu": "Edit template",
        "Edycja szkolenia": "Edit course",
        "Edycja ścieżki szkoleniowej": "Edit learning path",
        "Edycja terminu": "Appointment edit",
        "Edycja testu": "Edit test",
        "Edycja top tematu": "Top topic edit",
        "Edycja ustawień": "Edit settings",
        "Edycja użytkownika": "Edit user",
        "Edycja w popupie": "Popup edit",
        "Edycja webhooka": "Webhook edit",
        "Edycja wideo": "Video edit",
        "Edycja witryny": "Edit site",
        "Edycja wszystkich dokumentów": "Edit all documents",
        "Edycja wydarzenia": "Event edit",
        "Edycja zamówienia": "Edit order",
        "Edycja zastępstwa": "Edit substitution",
        "Edycja zespołu": "Edit team",
        "Edycja zestawu regulaminów": "Editi set of regulations",
        "Edycja źródła": "Edit source",
        "Edycja źródła danych": "Edit data source",
        "Edytor": "Editor",
        "Edytor lokalizowany": "Localized editor",
        "Edytowana wersja": "Edited version",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Only templates for enabled and supported channels can be edited.",
        "Edytuj": "Edit",
        "Edytuj blok": "Edit block",
        "Edytuj członka grupy": "Edit group member",
        "Edytuj dashboard": "Edit dashboard",
        "Edytuj datę dostępu": "Edit access date",
        "Edytuj dokument": "Edit document",
        "Edytuj filtr": "Edit filter",
        "Edytuj katalog": "Edit directory",
        "Edytuj kategorie": "Edit category",
        "Edytuj kategorię": "Edit category",
        "Edytuj komentarz": "Edit comment",
        "Edytuj lekcje": "Edit lessons",
        "Edytuj lekcje SCORM": "Edit SCORM lessons",
        "Edytuj lekcje wideo": "Edit video lesson",
        "Edytuj link": "Edit link",
        "Edytuj powiadomienie zbiorowe": "Edit bulk notification",
        "Edytuj punkt": "Edit point",
        "Edytuj rotator": "Edit rotator",
        "Edytuj slajder": "Edit slider",
        "Edytuj stronę": "Edit page",
        "Edytuj szablon": "Edit template",
        "Edytuj tag": "Edit tag",
        "Edytuj temat": "Edit topic",
        "Edytuj test": "Edit test",
        "Edytuj uprawnienia": "Edit permissions",
        "Edytuj użytkownika": "Edit user",
        "Edytuj wątek": "Edit thread",
        "Edytuj wiersz": "Edit row",
        "Edytuj wpis": "Edit post",
        "Edytuj wydarzenie": "Edit event",
        "Edytuj zestaw": "Edit set",
        "Eksport": "Export",
        "Eksport do Excela": "Export to Excel",
        "Eksport dokumentów": "Document export",
        "Eksport użytkowników": "User export",
        "Eksport zamówień": "Order export",
        "ElasticSearch": "ElasticSearch",
        "element": "element",
        "Element": "Element",
        "Element grupujący": "Grouping element",
        "Element jest wymagany": "Element is required",
        "Element nadrzędny": "Parent element",
        "element niewymagany": "component not required",
        "Element opublikowany": "Published element",
        "Element szkolenia rozpoczęty przez użytkowników": "Course component started by users",
        "Element szkolenia ukończony przez użytkowników": "Course component completed by users",
        "element wymagany": "component required",
        "Element wymagany": "Component required",
        "Element został dodany.": "The element has been added.",
        "Element został przywrócony.": "The element has been restored.",
        "Element został usunięty": "Element has been deleted",
        "Element został usunięty.": "The element has been deleted.",
        "Element został zaktualizowany.": "The element has been updated.",
        "elementów": "elements",
        "elementy": "items",
        "Elementy": "Elements",
        "Elementy szkolenia": "Training elements",
        "Elementy szkolenia użytkownika": "User training elements",
        "Elementy szkolenia użytkownika: ${selectedUserData}": "User training elements: ${selectedUserData}",
        "Elementy zostały usunięte.": "Elements have been deleted.",
        "Email": "E-mail",
        "Email potwierdzony": "Email confirmed",
        "Endpoint został dodany.": "Endpoint has been added.",
        "Endpoint został zaktualizowany.": "Endpoint has been updated.",
        "Error - błedy wewnętrze SDK": "Error - internal SDK errors",
        "Eskportuj": "Export",
        "Etap": "Stage",
        "Etykieta": "Tag",
        "Etykieta produktu została dodana.": "Product label has been added.",
        "Etykieta produktu została usunięta.": "Product label has been deleted.",
        "Etykieta produktu została zaktualizowana.": "Product label has been updated.",
        "Etykieta została dodana.": "Label has been added.",
        "Etykieta została usunięta.": "Label has been deleted.",
        "Etykieta została zaktualizowana.": "Label has been updated.",
        "Etykiety": "Tags",
        "Etykiety produktów": "Product labels",
        "Export": "Export",
        "Exportuj do Excela": "Export to Excel",
        "Facebook": "Facebook",
        "Facebook Admins": "Facebook Admins",
        "Facebook Application ID": "Facebook Application ID",
        "Faktura": "Invoice",
        "False": "False",
        "Fatal - błedy krytyczne": "Fatal - critical errors",
        "FavIcona": "Favicon",
        "Film": "Film",
        "Film z multimedia": "Video from multimedia",
        "Film z YouTube": "Video from YouTube",
        "Filmy": "Videos",
        "Filtr dla synchronizacji działów": "Filter for synchronising departments",
        "Filtr dla synchronizacji użytkowników": "Filter for synchronising users",
        "Filtr domyślny": "Default filter",
        "Filtr prywatny": "Private filter",
        "Filtr został usunięty": "Filter has been removed",
        "Filtr został zapisany": "Filter has been saved",
        "Filtrowanie": "Filtering",
        "Filtrowanie listy dokumentów": "Document list filtering",
        "Filtry": "Filters",
        "Firebase": "Firebase",
        "Firebase config": "Firebase config",
        "Folder główny": "Main folder",
        "Folder plików": "File folder",
        "Folder został usunięty.": "The folder has been deleted.",
        "Foldery": "Folders",
        "Format pliku": "File format",
        "Format treści": "Content format",
        "Formatowanie ramki": "Frame formatting",
        "Formularz": "Modules / Contact form",
        "Formularz bazuje na nieaktualnej wersji definicji.": "An outdated version of the definition is used in the form.",
        "Formularz dynamiczny": "Dynamic form",
        "Formularz został dodany.": "The form has been added.",
        "Formularz został skopiowany.": "Form has been copied.",
        "Formularz został utworzony.": "Form has been created.",
        "Formularz został zaakceptowany.": "Form has been approved.",
        "Formularz został zaktualizowany.": "The form has been updated.",
        "Formularze": "Forms",
        "Formuła jest nieprawidłowa": "Formula is invalid",
        "Funkcja została dodana.": "Function has been added.",
        "Funkcja została usunięta.": "Function has been deleted.",
        "Funkcja została zaktualizowana.": "Function has been updated.",
        "Funkcje": "Functions",
        "Funkcje Asystent": "Assistant functions",
        "Funkcje asystenta": "Assistant functions",
        "Funkcje Asystenta": "Assistant functions",
        "Funkcje asystenta AI": "AI assistant functions",
        "Funkcjonalności": "Functionalities",
        "Funkcjonalność AI": "AI functionality",
        "Galeria": "Gallery",
        "Galeria nie jest jeszcze nigdzie opublikowana.": "Gallery is not yet published anywhere.",
        "Galeria nie ma ustawionej daty publikacji.": "Gallery does not have a set publication date.",
        "Galeria zdjęć": "Photo gallery",
        "Galeria zdjęć premium": "Premium photo gallery",
        "Galeria została dodana.": "Gallery has been added.",
        "Galeria została usunięta.": "Gallery has been deleted.",
        "Galeria została zaktualizowana.": "Gallery has been updated.",
        "Generator dynamicznych formularzy włączony": "Dynamic form generator enabled",
        "Generator dynamicznych formularzy wyłączony": "Dynamic form generator disabled",
        "Generator linku": "Link generator",
        "Generator metadanych obrazu włączony": "Image metadata generator enabled",
        "Generator metadanych obrazu wyłączony": "Image metadata generator disabled",
        "Generator metadanych SEO włączony": "SEO metadata generator enabled",
        "Generator metadanych SEO wyłączony": "SEO metadata generator disabled",
        "Generator obrazów AI": "AI image generator",
        "Generator obrazów włączony": "Image generator enabled",
        "Generator obrazów wyłączony": "Image generator disabled",
        "Generowanie formularza zakończone.": "Form generation completed.",
        "Generowanie obrazów": "Image generation",
        "Generowanie obrazów zakończone.": "Image generation completed.",
        "Generowanie planu": "Plan generation",
        "Generowanie planu szkolenia rozpoczęte": "Training plan generation started",
        "Generowanie szkolenia": "Training generation",
        "Generowanie szkolenia zostało rozpoczęte, może to potrwać kilka minut.": "Training generation has started, it may take a few minutes.",
        "Generowanie szkolenia zostało rozpoczęte, może to potrwać kilka minut. Wygenerowane szkolenie znajdziesz na liście szkoleń pod nazwą: ": "Training generation has started, it may take a few minutes. The generated training can be found in the training list under the name: ",
        "Generowanie zdjęcia głównego do szkolenia": "Generating main training image",
        "Generuj": "Generate",
        "Generuj formularz": "Generate form",
        "Generuj metadane": "Generate metadata",
        "Generuj metadane (AI)": "Generate metadata (AI)",
        "Generuj nowy link": "Generate new link",
        "Generuj nowy obraz": "Generate new image",
        "Generuj obraz": "Generate image",
        "Generuj plan": "Generate plan",
        "Generuj plan szkolenia": "Generate training plan",
        "Generuj szkolenie": "Generate training",
        "Generuj treść slajdu": "Generate slide content",
        "Generuj wszystkie metadane": "Generate all metadata",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "GET: Entry list (sorting and pagination)",
        "GET: Pobranie danych": "GET: Data retrieval",
        "GET: Pobranie wpisu": "GET: Entry retrieval",
        "GET: Schemat (definicja formularza)": "GET: Schema (form definition)",
        "Główny asystent panelu": "Main panel assistant",
        "Godziny": "Hours",
        "Google": "Google",
        "Google Nexus 10": "Google Nexus 10",
        "Google Nexus 5": "Google Nexus 5",
        "Google Nexus 7": "Google Nexus 7",
        "Google Translate V2": "Google Translate V2",
        "Góra": "Top",
        "GPT-4 Turbo": "GPT-4 Turbo",
        "GPT-4 Vision": "GPT-4 Vision",
        "GPT-4o": "GPT-4o",
        "GPT-4o mini": "GPT-4o mini",
        "GPT-4o Mini": "GPT-4o Mini",
        "Grafika": "Graphics",
        "Grafika na stronie logowania": "Graphics on login page",
        "Grafika wektorowa": "Vector graphic",
        "Grubość": "Thickness",
        "Grubość ramki": "Frame thickness",
        "grudniu": "December",
        "grudzień": "December",
        "Grudzień": "December",
        "Grupa": "Group",
        "Grywalizacja": "Gamification",
        "Harmonogram": "Schedule",
        "Harmonogram zadań": "Task scheduler",
        "Harmonogram został zmieniony": "Schedule has been changed",
        "Hasło": "Password",
        "Hasło (Klucz ukryty)": "Password (Hidden Key)",
        "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "The password must contain at least one special character, e.g.: ~ @ $ % ^ & *",
        "Hasło użytkownika serwisowego": "Maintenace user password",
        "Hasło zostało zmienione. Zaloguj się ponownie": "The password has been changed. Sign in again",
        "Health": "Health",
        "Hierarchia": "Hierarchy",
        "Hierarchiczny": "Hierarchical",
        "Historia": "History",
        "Historia logowania": "Login history",
        "Historia wygenerowanych treści.": "Generated content hiistory.",
        "Historia zadania": "Task history",
        "Historia zapytań AI": "AI query history",
        "Historia zapytań do AI": "AI query history",
        "Host": "Host",
        "Host dodatkowy": "Secondary host",
        "Host główny": "Main host",
        "i": "and",
        "i posiadających wymagane uprawnienia": "and having the required permissions",
        "Id": "Id",
        "ID": "ID",
        "ID lub typ zadania": "Task ID or type",
        "Id modelu: %0": "Model Id: %0",
        "Id obiektu": "Object ID",
        "ID operacji": "Operation ID",
        "ID procesu": "Process ID",
        "Id punktu płatności (pos_id)": "Payment point ID (pos_id)",
        "Id sesji": "Session Id",
        "Id slajdu": "Slide id",
        "Id wpisu": "Entry ID",
        "ID zadania": "Task ID",
        "Id zapytania": "Query ID",
        "Id zdarzenia": "Event Id",
        "Identity": "Identity",
        "Identyfikator": "Identifier",
        "Identyfikator odpowiedzi.": "Answer ID.",
        "Identyfikator przestrzeni (WorkspaceId)": "Workspace ID",
        "Identyfikator sklepu (domyślnie id sprzedawcy)": "Store identifier (default seller ID)",
        "Identyfikator slajdu": "Slide ID",
        "Identyfikator sprzedawcy": "Seller identifier",
        "Identyfikator wdrożenia": "Deployment ID",
        "Identyfikator zadania": "Task identificator",
        "Identyfikator zapytania": "Inquiry ID",
        "Ikona": "Icon",
        "Ikona wyświetlana jest w postaci kwadratu.": "The icon is displayed in the form of a square.",
        "Ilość elementów: %0": "Number of items: %0",
        "Ilość powtórzeń po wystąpieniu błędu": "Number of retries after error occurrence",
        "Ilość wierszy": "Number of rows",
        "Ilość wyników do odrzucenia": "Number of results to discard",
        "Ilość wyników do pobrania": "Number of results to fetch",
        "Ilość znaków": "Number of characters",
        "Ilość znaków odpowiedzi": "Number of answer characters",
        "Imię": "First name",
        "Imię i nazwisko": "First and Last Name",
        "Imię i Nazwisko": "First name and last name",
        "Imię i nazwisko/nazwa autora": "First and Last Name/Author Name",
        "Import": "Import",
        "Import modułu": "Module import",
        "Import slajdów z PDF": "PDF slides import",
        "Import użytkowników": "User import",
        "Importuj": "Import",
        "Importuj definicję formularza": "Import form definition",
        "Importuj slajdy": "Import slides",
        "Indeks": "Index",
        "Indeks został usunięty.": "The index has been deleted.",
        "Indeksowanie strony": "Page indexing",
        "Indywidualny": "Individual",
        "Indywidualny z terminu spotkań": "Individual from meeting appointment",
        "Info - informacje": "Info - information",
        "Informacja": "Information",
        "Informacja o błędzie": "Error information",
        "Informacja o ciasteczkach": "Information about cookies",
        "Informacje dodatkowe": "Additional information",
        "Inspekcja": "Inspection",
        "Instalacja": "Installation",
        "Instrukcja": "Instruction",
        "Instrukcja modelu (prompt).": "Model instruction (prompt).",
        "Instrukcja warunkowa": "Conditional statement",
        "Int": "Int",
        "Inteligentne narzędzie generujące dynamiczne formularze.": "Intelligent tool for generating dynamic forms.",
        "Inteligentne narzędzie generujące metadane obrazu.": "Intelligent tool for generating image metadata.",
        "Inteligentne narzędzie generujące metadane SEO.": "Intelligent tool for generating SEO metadata.",
        "Inteligentne narzędzie generujące obrazy.": "Intelligent tool for generating images.",
        "Inteligentne narzędzie wskazujące najbardziej trafny wynik wyszukiwania.": "Intelligent tool for indicating the most relevant search result.",
        "Interakcja użytkownika": "User interaction",
        "Interpreter kodu": "Code interpreter",
        "Interpreter kodu umożliwia asystentowi pisanie i uruchamianie kodu. To narzędzie może przetwarzać pliki z różnymi danymi i formatowaniem oraz generować pliki.": "Code interpreter allows the assistant to write and execute code. This tool can process files with various data and formatting and generate files.",
        "ISBN": "ISBN",
        "Jakość": "Quality",
        "Jakość HD": "HD quality",
        "Jakość HD 1024x1024": "HD quality 1024x1024",
        "Jakość HD 1024x1792 i 1792x1024": "HD quality 1024x1792 and 1792x1024",
        "Jakość standardowa": "Standard quality",
        "Jakość standardowa 1024x1024": "Standard quality 1024x1024",
        "Jakość standardowa 1024x1792 i 1792x1024": "Standard quality 1024x1792 and 1792x1024",
        "Jakość wygnerowanego obrazu.": "Generated image quality.",
        "Jasny": "Light",
        "Jasny niebieski": "Light blue",
        "Jedna kolumna": "One column",
        "Jednokrotnego wyboru": "Single choice",
        "Jeszcze nie ma kategorii.": "There are no categories yet.",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "If the user is not on the list, it means that basic data such as First and Last Name is missing. Complete this data in the Users section.",
        "Jeśli pole jest puste to wstawiana automatycznie.": "If the field is empty, the value is inserted automatically.",
        "Jeśli pole jest puste, wówczas używana jest wartość domyślna. W przeciwnym wypadku wartość domyślna jest nadpisywana.": "If the field is left blank, then the default value will be used. If not, the default value will be added.",
        "Język": "Language",
        "Język domyślny": "Default language",
        "Kalendarz": "Calendar",
        "Kalendarz - Kategorie zasobów": "Calendar - Resource Categories",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "The channel is required by default. It is not possible to stop sending a notification through this channel. It is only possible to change the title and content of the message.",
        "kanał wymagany": "required channel",
        "Kanały": "Channels",
        "Kanały komunikacji": "Communication channels",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "Channels supported by the selected notification type",
        "Kanały włączone w ustawieniach aplikacji": "Channels enabled in app settings",
        "Katalog": "Directory",
        "Katalog linków": "Links directory",
        "Katalog został utworzony": "Catalog has been created",
        "Katalog został utworzony.": "The directory has been created.",
        "Kategoria": "Category",
        "Kategoria jest wymagana": "Category is required",
        "Kategoria linku": "Link category",
        "Kategoria materiałów": "Material category",
        "Kategoria materiału": "Material category",
        "Kategoria nadrzędna": "Parent category",
        "Kategoria produktu": "Product category",
        "Kategoria slajdu": "Slide category",
        "Kategoria spotkania": "Meeting category",
        "Kategoria subskrypcji": "Subscription category",
        "Kategoria subskrypcji została dodana.": "Subscription category has been added.",
        "Kategoria subskrypcji została usunięta.": "Subscription category has been deleted.",
        "Kategoria subskrypcji została zaktualizowana.": "Subscription category has been updated.",
        "Kategoria szkolenia": "Course category",
        "Kategoria wydarzenia": "Event category",
        "Kategoria wyszukiwanego materiału": "Category of the searched material",
        "Kategoria została dodana.": "The category has been added.",
        "Kategoria została usunięta.": "The category has been removed.",
        "Kategoria została zaktualizowana.": "The category has been updated.",
        "Kategoria: ": "Category: ",
        "Kategorie": "Categories",
        "Kategorie linków": "Link categories",
        "Kategorie materiałów": "Material categories",
        "Kategorie produktów": "Product categories",
        "Kategorie spotkań": "Meeting categories",
        "Kategorie szkoleń": "Course categories",
        "Kategorie wydarzeń": "Event categories",
        "Kategorię": "Category",
        "Kategorię można opublikować tylko na jednej stronie.": "A category may only be published on one page.",
        "Kategorię subskrypcji": "Subscription category",
        "Key": "Key",
        "Key pair": "Key pair",
        "Klienci": "Clients",
        "Klient aktywny": "Active client",
        "Klient został dodany.": "The client has been added.",
        "Klient został usunięty.": "The client has been deleted.",
        "Klient został zaktualizowany.": "The client has been updated.",
        "Klucz": "Key",
        "Klucz API": "API key",
        "Klucz główny (PrimaryKey)": "Primary Key",
        "Klucz prywatny": "Private key",
        "Klucz publiczny": "Public key",
        "Klucze": "Keys",
        "Klucze są nie prawidłowe.": "Keys are invalid.",
        "Klucze są prawidłowe.": "Keys are valid.",
        "Kobieta": "Woman",
        "Kod bannera (tutaj wklej kod HTML i JS)": "Banner code (paste HTML and JS code here)",
        "Kod Bing Webmaster": "Bing Webmaster Code",
        "Kod Google Webmaster": "Google Webmaster Code",
        "Kod GTM": "GTM code",
        "Kod HTML": "HTML code",
        "Kod pocztowy": "Postal code",
        "Kod walidacji": "Validation code",
        "Kod wertfikacyjny": "Verification code",
        "Kod weryfikacyjny jest nieprawidłowy.": "The verification code is invalid.",
        "Kod źródłowy": "Source code",
        "Kolejka": "Queue",
        "Kolejne pozycje z lewej strony": "Next items on the left",
        "Kolejne pozycje z prawej strony": "Next items on the right",
        "Kolejność zaliczania elementów": "Item completion order",
        "Kolekcja aktywna": "Active collection",
        "Kolekcja promowana": "Promoted collection",
        "Kolekcja została dodana.": "Collection has been added.",
        "Kolekcja została zaktualizowana.": "Collection has been updated.",
        "Kolekcje produktów": "Product collections",
        "Kolor": "Colour",
        "Kolor cyfr": "Digit color",
        "Kolor drugorzędny: %0": "Secondary colour: %0",
        "Kolor icon na panelu z aplikacjami: %0": "Icon color on application panel: %0",
        "Kolor ikony": "Icon color",
        "Kolor podpisów": "Caption color",
        "Kolor podstawowy: %0": "Primary colour: %0",
        "Kolor przewodni obrazu": "Image dominant color",
        "Kolor ramki": "Frame color",
        "Kolor tekstu": "Text color",
        "Kolor tekstu aktywnej pozycji menu: %0": "The text color of the active menu component: %0",
        "Kolor tła": "Background color",
        "Kolor tła panelu z aplikacjami: %0": "Background color on application panel: %0",
        "Kolory zostały przywrócone.": "Colors have been restored.",
        "Kolory zostały zapisane.": "Colors have been saved.",
        "Kolumna": "Column",
        "Kolumny": "Columns",
        "Komentarz %0": "Comment %0",
        "Komentarze": "Comments",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu 'Tekst'.": "Component whose value will be used as the name of the parent item. Only 'Text' type components are available.",
        "Komponent relacyjny": "Relational component",
        "Komponent został dodany.": "Component has been added.",
        "Komponent został usunięty.": "Component has been deleted.",
        "Komponent został zaktualizowany.": "Component has been updated.",
        "Komponent źródłowy": "Source component",
        "Komponenty": "Components",
        "Komunikat": "Message",
        "Komunikat błędu": "Error message",
        "Komunikat mailowy": "E-mail message",
        "Komunikat po niezaliczeniu testu": "Message after test failure",
        "Komunikat po otrzymaniu odznaki": "Message after receiving badge",
        "Komunikat po zaliczeniu testu": "Message after test success",
        "Komunikat walidacji": "Validation message",
        "Konfiguracja": "Settings",
        "Konfiguracja AI": "AI configuration",
        "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "The arrangement configuration is not available because no template definition is provided.",
        "Konfiguracja asystenta": "Assistant configuration",
        "Konfiguracja asystenta ai": "AI assistant configuration",
        "Konfiguracja bloków jest niedostępna ponieważ nie podano definicji szablonu.": "Block configuration is not available because no template definition is provided.",
        "Konfiguracja bloku": "Block configuration",
        "Konfiguracja bloku została zapisana.": "The block configuration has been saved.",
        "Konfiguracja domyślna": "Default configuration",
        "Konfiguracja harmonogramu (czas UTC)": "Schedule configuration (UTC time)",
        "Konfiguracja kolumn tabeli": "Table column configuration",
        "Konfiguracja listy": "List configuration",
        "Konfiguracja logów": "Log configuration",
        "Konfiguracja sekcji jest niedostępna ponieważ nie podano definicji szablonu.": "Section configuration is not available because no template definition is provided.",
        "Konfiguracja stopki oraz logo umieszczanych w wysyłanych powiadomieniach kanałem mailowym. Stopka może być skonfigurowana indywidualnie dla każdej wersji jezykowej, logo jest wspólne dla wszystkich.": "Footer and logo configuration for email notifications. Footer can be configured individually for each language version, logo is shared across all.",
        "Konfiguracja zaawansowana": "Advanced configuration",
        "Konfiguracja zapytania": "Query configuration",
        "Konfiguracja została przywrócona dla reguł i celów": "Configuration has been restored for rules and goals",
        "Konfiguracja została zmieniona.": "Configuration has been changed.",
        "Konfiguruj stronę": "Configure page",
        "Koniec po": "End after",
        "Konsola aplikacji": "Application console",
        "Konsola aplikacji nigdy nie rejestruje logów z poniższych przestrzeni nazw:": "Application console never logs from the following namespaces:",
        "Konta użytkowników": "User accounts",
        "Konta użytkowników zostały odblokowane": "User accounts have been unlocked",
        "Konta użytkowników zostały przypisane do zespołu": "User accounts have been assigned to the team",
        "Konta użytkowników zostały usunięte z systemu": "User accounts have been deleted from the system",
        "Konta użytkowników zostały zablokowane": "User accounts have been locked",
        "Kontakt": "Contact",
        "Kontakty - Typ działania": "Contacts - Activity Type",
        "Kontener plików": "File container",
        "Konto aktywne": "Active account",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "The account will remain inactive until the email address is confirmed",
        "Konto publiczne": "Public account",
        "Konto z dostępem do panelu administracyjnego": "Account with access to admin panel",
        "Konto zanonimizowane": "Account anonymized",
        "Kontrolka": "Control",
        "Kontrolka wyboru (pojedynczy wybór, value jest skrótem pobierającym pierwszy element z tablicy data)": "Selection control (single selection, value is a shortcut fetching the first element from data array)",
        "Kontrolka wyboru (wybór wielokrotny)": "Choice control (multiple choice)",
        "Konwertuj obrazy do formatu WebP": "Convert images to WebP format",
        "Końcowa": "Final",
        "Koordynator": "Coordinator",
        "Koordynatorów": "Coordinators",
        "Koordynowane szkolenia:": "Coordinated courses:",
        "Kopiuj": "Copy",
        "Kopiuj adres": "Copy address",
        "Kopiuj definicję": "Copy definition",
        "Kopiuj pole": "Copy field",
        "Kosz": "Bin",
        "Kraj": "Country",
        "Kreator może też zaproponować własną strukturę szkolenia.": "Creator can also propose their own training structure.",
        "Kreator najlepiej interpretuje pliki w formacie": "Creator interprets files best in format",
        "Kreator szkoleń": "Training Creator",
        "Kreator Szkoleń AI": "AI Training Creator",
        "Krok 1": "Step 1",
        "Krok 2": "Step 2",
        "Krok 3": "Step 3",
        "Krok minut": "Minute step",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "Minute step must be a number between 1 and 60.",
        "Kroki": "Steps",
        "Kropkowana": "Dotted",
        "Krótki opis": "Short description",
        "Krótki tekst": "Short text",
        "Krótki tytuł": "Short title",
        "Książka": "Book",
        "kwiecień": "April",
        "Kwiecień": "April",
        "kwietniu": "April",
        "Laptop 15,6\"": "Laptop 15.6\"",
        "Laptop 15\"": "15\" laptop",
        "Laptop 17\"": "17\" laptop",
        "Ldap": "Ldap",
        "LDAPS (LDAP over SSL)": "LDAPS (LDAP over SSL)",
        "Legenda": "Key",
        "Lekcja": "Lesson",
        "Lekcja do powtórzenia": "Lesson to repeat",
        "Lekcja może zawierać tylko materiały opisowe": "Lesson can only contain descriptive materials",
        "Lekcja może zawierać tylko materiały opisowe lub materiały video": "The lesson can contain only descriptive or video materials",
        "Lekcja SCORM ukryta": "SCORM Lesson Hidden",
        "Lekcja SCORM została dodana.": "The SCORM lesson has been added.",
        "Lekcja SCORM została zaktualizowana.": "The SCORM lesson has been updated.",
        "Lekcja ukryta": "Hidden lesson",
        "Lekcja wideo została dodana.": "The video lesson has been added.",
        "Lekcja wideo została zaktualizowana.": "The video lesson has been updated.",
        "Lekcja została dodana.": "The lesson has been added.",
        "Lekcja została zaktualizowana.": "The lesson has been updated.",
        "Lekcje": "Lessons",
        "Lekcje video": "Video lessons",
        "Lewo": "Left",
        "Lewy panel": "Left panel",
        "Licencja": "License",
        "Liczba": "Number",
        "Liczba artykułów": "Number of articles",
        "Liczba artykułów w kategorii": "Number of articles in category",
        "Liczba całkowita": "Integer",
        "Liczba danych wejściowych podana w tokenach.": "Number of input data provided in tokens.",
        "Liczba danych wyjściowych podana w tokenach.": "Number of output data provided in tokens.",
        "Liczba dni co ile wysyłane jest powiadomienie": "Number of days of how often a notification is sent",
        "Liczba dni do zakończenia szkolenia przy której zostanie wysłane powiadomienie": "Number of days until the end of the course at which the notification will be sent",
        "Liczba dni od jakiej użytkownik otrzyma powiadomienie": "Number of days from which the user will receive a notification",
        "Liczba dostępnych bloków": "Number of available blocks",
        "Liczba dziesiętna": "Decimal",
        "Liczba elementów": "Number of components",
        "Liczba elementów do uzupełnienia": "Number of components to be completed",
        "Liczba kategorii": "Number of categories",
        "Liczba koordynatorów": "Number of coordinators",
        "Liczba koordynowanych szkoleń: %0": "Number of coordinated courses: %0",
        "Liczba miejsc": "Number of places",
        "Liczba odpowiedzi": "Number of answers",
        "Liczba opublikowanych elementów (zakładka Zawartość) musi być większa lub równa ustawionej liczbie wyświetlanych elementów (zakładka Ustawienia)": "Number of published components (Content tab) must be bigger than or equal to the set number of components displayed (Settings tab)",
        "Liczba podejść": "Number of approaches",
        "Liczba podejść nie może być mniejsza niż 0": "Number of attempts cannot be less than 0",
        "Liczba powtórzeń": "Number of repetitions",
        "Liczba produktów": "Number of products",
        "Liczba punktów": "Number of points",
        "Liczba punktów nie może być liczbą ujemną": "Number of points cannot be negative",
        "Liczba pytań": "Number of questions",
        "Liczba pytań w teście": "Number of questions in test",
        "Liczba slajdów w lekcji": "Number of slides in lesson",
        "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "The number of slides visible to the user cannot be greater than the number of slides added in the panel.",
        "Liczba spotkań": "Number of meetings",
        "Liczba szkoleń": "Number of courses",
        "Liczba szkoleń w ścieżce": "Number of courses in the path",
        "Liczba uczestników": "Number of participants",
        "Liczba użytkowników": "Number of users",
        "Liczba użytkowników szkolenia": "Number of training users",
        "Liczba wariantów": "Number of variants",
        "Liczba wydarzeń": "Number of events",
        "Liczba wyników na stronie": "Number of results on the page",
        "Liczba wyświetlanych aktualności": "Number of news updates displayed",
        "Liczba wyświetlanych artykułów": "Number of displayed articles",
        "Liczba wyświetlanych elementów": "Number of elements displayed",
        "Liczba wyświetlanych najnowszych elementów": "Number of recent elements displayed",
        "Liczba wyświetlanych produktów": "Number of displayed products",
        "Liczba wyświetlanych slajdów": "Number of slides displayed",
        "Liczba wyświetlanych tagów": "Number of displayed tags",
        "Liczba wyświetleń": "Number of views",
        "Liczba zaimportowanych użytkowników: ${importInformations.importedAccounts}": "Number of imported users: ${importInformations.importedAccounts}",
        "Liczba zakładek": "Number of tabs",
        "Liczba zapisanych": "Number of registered",
        "Liczba zapisanych osób": "Number of registered people",
        "Liczba zapisanych/Liczba dostępnych miejsc: ": "Number of registered/Number of available places: ",
        "Liczba zgłoszeń:": "Number of requests:",
        "Lider": "Leader",
        "Lider/koordynator dla wszystkich zespołów": "Leader/Coordinator for all teams",
        "Like do komentarzy mogą dodawać tylko zalogowani użytkownicy": "Like to comments can only be added by logged-in users",
        "Limit": "Limit",
        "Limit API": "API limit",
        "Limit czasu (minuty)": "Time limit (minutes)",
        "Limit czasu nie może być mniejszy niż 0 minut": "Time limit cannot be less than 0 minutes",
        "Limit dodanych linków": "Limit of added links",
        "Limit jest potrzebny do poprawnego wyświetlenia statystyk zużycia na stronie głównej panelu. Nie jest powiązany z limitem konta.": "Limit is needed for correct display of usage statistics on the main panel page. It is not linked to the account limit.",
        "Limit miejsc": "Place limit",
        "Limit zgłoszeń": "Request limit",
        "Limit znaków dla niezalogowanych": "Character limit for not logged in users is required",
        "Limit znaków dla zalogowanych": "Character limit for logged-in users is required",
        "Limity": "Limits",
        "Linia": "Line",
        "Linia ciągła": "Solid line",
        "Linia falująca": "Wavy line",
        "Linia kreskowana": "Dashed line",
        "Linia kropkowana": "Dotted line",
        "Linia pozioma": "Horizontal line",
        "linie": "lines",
        "Link": "Link",
        "Link (link zewnętrzny, bez https)": "Link (external link, without https)",
        "Link do strony": "Website link",
        "Link do wybranej strony serwisu": "Link to the selected page of the website",
        "Link do zewnętrznej strony": "Link to external site",
        "Link przycisku": "Button link",
        "Link z serwisu": "Link from service",
        "Link został dodany.": "Link has been added.",
        "Link został skopiowany.": "Link has been copied.",
        "Link został usunięty.": "The link has been removed.",
        "Link został wygenerowany.": "Link has been generated.",
        "Link został zaktualizowany.": "The link has been updated.",
        "lipcu": "July",
        "lipiec": "July",
        "Lipiec": "July",
        "Lista": "List ",
        "Lista artykułów": "List of articles",
        "Lista asystentów": "Assistant list",
        "Lista certyfikatów": "List of certificates",
        "Lista dostępnych zmiennych, które można wykorzystać we wszystkich polach tekstowych:": "List of available variables that can be used in all text fields:",
        "Lista dozwolonych / wykluczonych żądań HTTP": "List of allowed/excluded HTTP requests",
        "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "List of effective user permissions resulting from individual permissions and roles.",
        "Lista elementów": "Item list",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "Item list will be narrowed down only to those related to selected values from marked components.",
        "Lista ID": "ID list",
        "Lista indeksów": "Index list",
        "Lista jest pusta": "The list is empty",
        "Lista komentarzy": "Comments list",
        "Lista koordynatorów": "Coordinators list",
        "Lista linków": "Links list",
        "Lista materiałów do utworzenia szkolenia": "Material list for creating training",
        "Lista możliwości zakończenia czatu. W obecnym stanie model zwraca jedną możliwą odpowiedź.": "A list of ways to end the chat. In its current status, the model returns one possible answer.",
        "Lista paczek SCORM": "SCORM Packages List",
        "Lista plików": "File list",
        "Lista powiadomień zbiorowych": "Bulk notifications list",
        "Lista produktów": "Product list",
        "Lista regulaminów": "Regulation list",
        "Lista rezerwowa": "Reserve list",
        "Lista rozszerzeń oddzielona przecinkami.": "Comma-separated extension list.",
        "Lista rozwijana": "Drop-down list",
        "Lista sortowalna": "Sortable list",
        "Lista spotkań": "Meeting list",
        "Lista szablonów": "Template list",
        "Lista szkoleń": "Course list",
        "Lista ścieżek szkoleniowych": "Learning path list",
        "Lista uczestników": "Participant list",
        "Lista wiadomości (prompt) składających się na dotychczasową konwersację z modelem.": "A list of the messages (prompts) that have made up the conversation with the model so far.",
        "Lista wyboru": "Selection list",
        "Lista wydarzeń": "Events list",
        "Lista zamówień": "Order list",
        "Lista zapisanych": "Registered list",
        "Lista zaufanych adresów IP": "Trusted IP addresses list",
        "Lista zespołów": "Teams list",
        "listopad": "November",
        "Listopad": "November",
        "listopadzie": "November",
        "Listy": "Lists",
        "Litery": "Letters",
        "Litery i cyfry": "Letters and numbers",
        "Log błędu": "Error log",
        "Log z aktywności": "Activity log",
        "Logi": "Logs",
        "Logi aktywności zostały wyczyszczone": "Activity logs cleared",
        "Logi wydajnościowe": "Performance logs",
        "Login": "Login",
        "Logo": "Logo",
        "Logowanie": "Log in",
        "Logowanie zakończyło się niepowodzeniem.": "Login failed.",
        "Logowanie zależności / żądań typu HTTP": "Dependency/HTTP request logging",
        "Loguj wybrane": "Log selected",
        "Lokalizacja": "Location",
        "Lokalizowane": "Localized",
        "Lokalne": "Local",
        "Long": "Long",
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit.": "Lorem ipsum dolor sit amet, consectetur adipisicing elit.",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit.": "Lorem ipsum dolor sit, amet consectetur adipisicing elit.",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quam commodi autem id, veniam, illum temporibus.": "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quam commodi autem id, veniam, illum temporibus.",
        "Losowa kolejność elementów": "Random order of elements",
        "lub dokumenty z wyraźnie opisaną strukturą nagłówków i treści.": "or documents with clearly described header and content structure.",
        "luty": "February",
        "Luty": "February",
        "lutym": "February",
        "Ładowanie elementów...": "Loading elements...",
        "Łączenie treści": "Combining content",
        "maj": "May",
        "Maj": "May",
        "maju": "May",
        "Maksimum": "Maximum",
        "Maksymalna ilość plików": "Maximum number of files",
        "Maksymalna liczba podejść to 500": "Maximum number of attempts is 500",
        "Maksymalna liczba punktów": "Maximum number of points",
        "Maksymalna liczba tokenów": "Maximum number of tokens",
        "Maksymalna limit czasu to 500 minut": "Maximum time limit is 500 minutes",
        "Maksymalna rozdzielość %0x%1px": "Maximum resolution %0x%1px",
        "Maksymalny rozmiar pliku w MB": "Maximum file size in MB",
        "Maksymalny rozmiar pliku: %0MB.": "Maximum file size: %0MB.",
        "Maksymalny rozmiar pojedynczego pliku": "Maximum size of a single file",
        "Mała": "Small",
        "Małe litery": "Lowercase letters",
        "Małe znaki": "Small characters",
        "Mały": "Small",
        "Mały układ siatki": "Small grid layout",
        "Mapa": "Map",
        "Mappingi": "Mappings",
        "marcu": "March",
        "Margines [px": "Margin [px",
        "Markdown": "Markdown",
        "Marketing": "Marketing",
        "marzec": "March",
        "Marzec": "March",
        "Masz niezapisane zmiany w materiałach. Zapisz je lub usuń aby móc zapisać element szkolenia.": "You have made changes to the materials that are unsaved. Save or delete them to save the course component.",
        "Materiał opisowy": "Descriptive material",
        "Materiał wideo": "Video",
        "Materiały szkoleniowe": "Course materials",
        "Max tokens": "Max tokens",
        "Max: 250 znaków": "Max: 250 characters",
        "Mediana": "Median",
        "Messages": "Messages",
        "Metadane": "Metadata",
        "Metoda": "Method",
        "Metoda autentykacji": "Authentication method",
        "Metoda musi zwracać obiekt \"entry.errors\".": "Method must return \"entry.errors\" object.",
        "Mężczyzna": "Man",
        "Miejsca po przecinku": "Decimal points",
        "Miejscowość": "Town",
        "mies.": "month",
        "miesiąc": "month",
        "Miesiąc": "Month",
        "Miesiące": "Months",
        "Miesięcznie": "Monthly",
        "Miesięczny": "Monthly",
        "Migracje": "Migrations",
        "Miniaturka": "Thumbnail",
        "Miniaturka wideo": "Video thumbnail",
        "Miniaturki": "Thumbnails",
        "Minimalna długość hasła": "Minimum password length",
        "Minimalna ilość plików": "Minimum number of files",
        "Minimalny czas oglądania potrzebny do zaliczenia elementu (hh:mm:ss)": "Minimum viewing time required to complete the item (hh:mm:ss)",
        "Minimapa": "Minimap",
        "Minimum": "Minimum",
        "Minuty": "Minutes",
        "Mnożenie": "Multiplication",
        "Model": "Model",
        "Model danych": "Data model",
        "Model danych i cechy można skonfigurować tylko podczas dodawania nowego formularza.": "Data model and features can only be configured when adding a new form.",
        "Model generuje odpowiedź na podstawie podanych przez użytkownika parametrów.": "The model generates a response based on the parameters specified by the user.",
        "Moderacja danych wejściowych": "Input data moderation",
        "Moderacja włączona": "Moderation enabled",
        "Moderacja wyłączona": "Moderation disabled",
        "Moderacjia danych wejściowych jest zalecana.": "Input data moderation is recommended.",
        "Moduł": "Module",
        "Moduł dynamiczny": "Dynamic module",
        "Moduł konfigurowalny": "Configurable module",
        "Moduł płatności": "Payment module",
        "Moduł spotkań": "Meeting module",
        "Moduł został dodany.": "Module has been added.",
        "Moduł został usunięty.": "Module has been deleted.",
        "Moduł został wyeksportowany.": "Module has been exported.",
        "Moduł został zaktualizowany.": "Module has been updated.",
        "Moduły": "Modules",
        "Moduły wyszukiwarki": "Search engine modules",
        "Modyfikacja": "Modification",
        "Modyfikacja dokumentów": "Document modification",
        "Modyfikuj istniejący wątek": "Modify existing thread",
        "Moje dokumenty": "My documents",
        "Moje filtry": "My filters",
        "Moje konto": "My account",
        "Moje pliki": "My files",
        "Moje punkty": "My points",
        "Moje wydarzenia": "My events",
        "Monitor aktywności": "Activity monitor",
        "Monitor kolejek": "Queue monitor",
        "Monitoring": "Monitoring",
        "Monitoruj statystyki .NET": "Monitor .NET statistics",
        "Monitoruj żądania HTTP": "Monitor HTTP requests",
        "Możesz podać nową nazwę pliku.": "You can provide a new file name.",
        "Możesz wybrać maksymalnie ${props.maxFiles} pliki": "You can select up to ${props.maxFiles} files",
        "Możliwość dodawania linków przez użytkownika": "Ability to add links by user",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "The possibility of modifying this section is limited. Inactive fields are synchronized with the external database %0.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "The possibility to modify this account is limited. Inactive fields are synchronized with the external database %0.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "This account has limited modifiability. Inactive fields are synchronized to an external database %0.",
        "Możliwość wielokrotnego wyboru": "Multiple choice",
        "Multimedia": "Multimedia",
        "Multimedia premium": "Premium multimedia",
        "multipart/form-data": "multipart/form-data",
        "Na pewno usunąć": "Are you sure to delete",
        "Na pewno usunąć wybrane elementy?": "Are you sure to delete the selected elements?",
        "Na podstawie dołączonych plików oraz zaproponowanego planu zostanie utworzone szkolenie.": "Based on attached files and proposed plan, training will be created.",
        "Na podstawie dołączonych plików zostanie zaproponowany plan szkolenia.": "Based on attached files, a training plan will be proposed.",
        "Na podstawie informacji zawartych w wybranych plikach zostanie utworzone szkolenie.": "Based on information contained in selected files, training will be created.",
        "Naciśnij enter aby usunąć": "Press enter to delete",
        "Naciśnij enter aby wybrać": "Press enter to select",
        "Nadawanie uprawnień do dokumentów": "Granting privileges to documents",
        "Nadawanie uprawnień do własnych dokumentów": "Granting privileges to own documents",
        "Nadawanie uprawnień do wszystkich dokumentów": "Granting privileges to all documents",
        "Nadawca": "Sender",
        "Nadpisz wersję lekcji": "Overwrite lesson version",
        "Nadpisz wersję lekcji scorm": "Overwrite SCORM lesson version",
        "Nadpisz wersję lekcji wideo": "Overwrite video lesson version",
        "Nadpisz wersję linku": "Overwrite link version",
        "Nadpisz wersję testu": "Overwrite test version",
        "Nagłówek": "Header",
        "Nagłówek dokumentu": "Document header",
        "Nagłówki cache": "Cache headers",
        "Najniższy": "Lowest",
        "Najnowsze": "Recent",
        "Najpierw zapisz wprowadzone zmiany": "Save changes first",
        "Najstarsza wiadomość": "Oldest message",
        "Najwyższy": "Highest",
        "Name": "Name",
        "Narzędzia": "Tools",
        "Narzędzia AI": "AI tools",
        "Narzędzie integruje się z platformą Firebase (powiadomienia push)": "Tool integrates with Firebase platform (push notifications)",
        "Narzędzie integruje się z platformą SMSAPI.pl": "Tool integrates with SMSAPI.pl platform",
        "Następna strona": "Next page",
        "Następny": "Next",
        "Następny krok": "Next step",
        "Nazwa": "Name",
        "Nazwa akcji": "Action name",
        "Nazwa aktywnej strony": "Active page name",
        "Nazwa aliasu": "Alias name",
        "Nazwa aranżacji": "Arrangement name",
        "Nazwa asystenta": "Assistant name",
        "Nazwa bazy danych": "Database name",
        "Nazwa bloku": "Block name",
        "Nazwa certyfikatu": "Certificate name",
        "Nazwa czołówki": "Header name",
        "Nazwa dashboardu": "Dashboard name",
        "Nazwa działu": "Department name",
        "Nazwa elementu": "Item name",
        "Nazwa etapu": "Stage name",
        "Nazwa etykiety": "Label name",
        "Nazwa filtra": "Filter name",
        "Nazwa formularza": "Form name",
        "Nazwa funkcji": "Function name",
        "Nazwa grupy": "Group name",
        "Nazwa indeksu": "Index name",
        "Nazwa jest wymagana": "Name is required",
        "Nazwa katalogu": "Directory name",
        "Nazwa katalogu została zmieniona.": "The directory has been renamed.",
        "Nazwa kategorii": "Category name",
        "Nazwa Kategorii": "Category Name",
        "Nazwa klienta": "Client name",
        "Nazwa kolekcji": "Collection name",
        "Nazwa kolumny": "Column name",
        "Nazwa kolumny z opisem": "Description column name",
        "Nazwa kolumny z wartością": "Column name with value",
        "Nazwa komponentu": "Component name",
        "Nazwa konta (Klucz dostępu)": "Account Name (Access Key)",
        "Nazwa koordynatora": "Coordinator name",
        "Nazwa lekcji": "Lesson name",
        "Nazwa linku": "Link name",
        "Nazwa modelu": "Model name",
        "Nazwa modułu": "Module name",
        "Nazwa musi mieć co najmniej 3 znaki": "Name must have at least 3 characters",
        "Nazwa musi mieć co najmniej 5 znaków": "Name must have at least 5 characters",
        "Nazwa nadawcy": "Sender name",
        "Nazwa narzędzia": "Tool name",
        "Nazwa nie może być dłuższa niż 30 znaków": "Name cannot exceed 30 characters",
        "Nazwa nie może być dłuższy niż 50 znaków": "Name cannot exceed 50 characters",
        "Nazwa odznaki": "Badge name",
        "Nazwa odznaki dla użytkownika": "Badge name for user",
        "Nazwa operacji": "Operation name",
        "Nazwa paczki": "Package name",
        "Nazwa paczki SCORM": "SCORM package name",
        "Nazwa pliku": "File name",
        "Nazwa pliku została zmieniona.": "The file has been renamed.",
        "Nazwa płyty": "Disc name",
        "Nazwa pokoju": "Room name",
        "Nazwa pola": "Field name",
        "Nazwa powiadomienia": "Notification name",
        "Nazwa produktu": "Product name",
        "Nazwa przycisku": "Button name",
        "Nazwa przycisku 'Dalej'": "Button name 'Next'",
        "Nazwa przycisku 'Wstecz'": "Button name 'Back'",
        "Nazwa przycisku 'Wyślij'": "Button name 'Send'",
        "Nazwa roli": "Role name",
        "Nazwa rotatora": "Rotator name",
        "Nazwa scenariusza": "Scenario name",
        "Nazwa sekcji": "Section name",
        "Nazwa sekcji w menu": "Menu section name",
        "Nazwa sekcji...": "Section name...",
        "Nazwa serwera": "Server name",
        "Nazwa slajdera": "Slider name",
        "Nazwa slajdu": "Slide name",
        "Nazwa sposobu płatności": "Payment method name",
        "Nazwa spotkania": "Meeting name",
        "Nazwa spotkania: ": "Meeting name: ",
        "Nazwa stanowiska": "Position name",
        "Nazwa strony": "Page name",
        "Nazwa szablonu": "Template name",
        "Nazwa szkolenia": "Course name",
        "Nazwa ścieżki": "Path name",
        "Nazwa terminu": "Appointment name",
        "Nazwa testu": "Test name",
        "Nazwa typu": "Type name",
        "Nazwa tytułu nie może być dłuższa niż 240 znaków ani krótsza niż 3 znaki.": "The title cannot contain neither more than 240 characters nor less than 3 characters.",
        "Nazwa urządzenia": "Device name",
        "Nazwa użytkownika": "User name",
        "Nazwa użytkownika serwisowego": "Maintenance user name",
        "Nazwa w panelu": "Name in panel",
        "Nazwa wątku": "Thread name",
        "Nazwa webhooka": "Webhook name",
        "Nazwa witryny": "Site name",
        "Nazwa wyświetlana": "Name displayed",
        "Nazwa wyświetlana:": "Name displayed:",
        "Nazwa zadania": "Task name",
        "Nazwa zasobu": "Resource name",
        "Nazwa zespołu": "Team name",
        "Nazwa zestawu": "Set name",
        "Nazwa zmiennej": "Variable name",
        "Nazwa zmiennej jest wymagana": "Variable name is required",
        "Nazwa zmiennej musi być unikalna": "Variable name must be unique",
        "nazwa zmiennej...": "variable name...",
        "Nazwa źródła": "Source name",
        "Nazwa źródła danych": "Data source name",
        "Nazwa:": "Name:",
        "Nazwisko": "Last name",
        "Nazwy wartości": "Value names",
        "nie": "no",
        "Nie": "No",
        "Nie loguj wybranych": "Do not log selected",
        "Nie ma jeszcze żadnych kategorii.": "No categories yet.",
        "Nie masz dostępu do tego modułu": "You do not have access to this module",
        "Nie masz uprawnień do modyfikacji aranżacji.": "You do not have permission to modify the arrangement.",
        "Nie masz uprawnień do panelu administracyjnego.": "You do not have permission to access the administration panel.",
        "Nie masz uprawnień do publikacji aranżacji.": "You don't have permission to publish the arrangement.",
        "Nie masz uprawnień do tego dokumentu": "You do not have privileges for this document",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "You do not have privileges for this view. The view state may have changed, refresh and check or try again later.",
        "Nie możesz dodać tego samego widgetu dwa razy": "You cannot add the same widget twice",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "You cannot modify the profile of the substituted user.",
        "Nie możesz modyfikować uprawnień": "You cannot modify permissions",
        "Nie można tworzyć zapętlonych powiązań.": "Cannot create circular references.",
        "Nie można ustawić dat dostępów dla szkoleń cyklicznych.": "Access dates cannot be set for cyclic training.",
        "Nie można usunąć kategorii do ktorej są przypisane elementy.": "You cannot delete a category to which the elements are assigned.",
        "Nie można usunąć swojego konta.": "You can't delete your account.",
        "Nie można zapisać zmian ponieważ skrypt się nie kompiluje.": "Cannot save changes because script does not compile.",
        "Nie podano": "Not specified",
        "Nie podano nazwy poprzedniego elementu.": "No name is given for the previous element.",
        "Nie podano nazwy poprzedniej kategorii.": "No name is given for the previous category.",
        "Nie podano nazwy tytułu.": "No title name is given.",
        "Nie podano odpowiedzi dla ostatniego elementu.": "No response was given for the last element.",
        "Nie podano opisu.": "No description is given.",
        "Nie podano wymaganej ilości znaków: %0.": "Required number of characters not provided: %0.",
        "Nie podano wymaganej ilości znaków: %0. (%1)": "Required number of characters not provided: %0. (%1)",
        "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "Do not show a short description of the page in search results (NoSnippet)",
        "Nie pokazuj linku do archiwum strony (NoArchive)": "Do not show a link to the archive of the page (NoArchive)",
        "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "Do not show the page as an image source in search results (NoImageIndex)",
        "Nie udało się pobrać kategorii": "Failed to fetch category",
        "Nie udało się pobrać konfiguracji dashboardu": "Failed to fetch dashboard configuration",
        "Nie udało się pobrać listy aranżacji": "Failed to download the arrangement list",
        "Nie udało się pobrać listy bloków": "Failed to download block list",
        "Nie udało się pobrać listy celów": "Failed to fetch goal list",
        "Nie udało się pobrać listy działów": "Failed to download the sections list",
        "Nie udało się pobrać listy etykiet": "Failed to fetch label list",
        "Nie udało się pobrać listy filtrów": "Failed to download filter list",
        "Nie udało się pobrać listy kanałów": "Failed to download channel list",
        "Nie udało się pobrać listy kategorii": "Failed to download category list",
        "Nie udało się pobrać listy kolejek": "Failed to download queue list",
        "Nie udało się pobrać listy modułów": "Failed to download module list",
        "Nie udało się pobrać listy modułów wyszukiwarki": "Failed to fetch search engine module list",
        "Nie udało się pobrać listy powiadomień": "Failed to download notification list",
        "Nie udało się pobrać listy regulaminów": "Failed to fetch regulation list",
        "Nie udało się pobrać listy ról": "Failed to download role list",
        "Nie udało się pobrać listy serwerów baz danych": "Failed to retrieve the database server list",
        "Nie udało się pobrać listy serwerów plików": "Failed to download the file server list",
        "Nie udało się pobrać listy stanowisk": "Failed to fetch position list",
        "Nie udało się pobrać listy stron": "Failed to download the pages list",
        "Nie udało się pobrać listy szablonów": "Failed to download template list",
        "Nie udało się pobrać listy typów materiałów": "Failed to download material type list",
        "Nie udało się pobrać listy typów modeli": "Failed to download the list of model types",
        "Nie udało się pobrać listy wydziałów": "Failed to download the list of sections",
        "Nie udało się pobrać listy zespołów": "Failed to download team list",
        "Nie udało się pobrać powiadomień.": "Failed to download notifications.",
        "Nie udało się pobrać ustawień kont użytkowników": "Failed to download user account settings",
        "Nie udało się pobrać widgetu/ów": "Failed to download widget(s)",
        "Nie udało się usunąć szablonu": "Failed to delete template",
        "Nie udało się wczytać podglądu strony.": "Failed to load the website preview.",
        "Nie udało się wygenerować formularza": "Failed to generate form",
        "Nie udało się wykonać akcji": "Failed to perform action",
        "Nie udało się wysłać pliku": "Failed to send file",
        "Nie udało się zakutalizować plików asystenta": "Failed to update assistant files",
        "Nie udało się załadować elementów": "Failed to load elements",
        "Nie udało się załadować widgetu AI.": "Failed to load AI widget.",
        "Nie udało się zapisać filtra": "Failed to save filter",
        "Nie udało się zapisać ustawień dashboardu": "Failed to save dashboard settings",
        "Nie wszystkie pola zostały wypelnione prawidłowo.": "Not all fields have been filled in correctly.",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "Not all selected items have been transfered. You do not have the required permissions or, if you are moving directories, the destination directory is a subdirectory of the source directory. Directories and files that could not have been transfered remain in the Selected tab.",
        "Nie wybrano ankiety": "Survey not selected",
        "Nie wybrano authora.": "No author selected.",
        "Nie wybrano obrazu.": "No image has been selected.",
        "Nie wybrano paczki.": "No package has been selected.",
        "Nie wybrano plików": "No files selected",
        "Nie wybrano strony": "No page has been selected",
        "Nie wybrano użytkownika.": "No user selected.",
        "Nie wybrano żadnego użytkownika.": "No user has been selected.",
        "Nie wybrano żadnej kategorii": "No category selected",
        "Nie wybrano żadnej kategorii.": "No category has been selected.",
        "Nie wybrano żadnej strony.": "No page has been selected.",
        "nie wymuszaj zmiany hasła": "do not force password change",
        "Nie wypełniono poprzedniego wiersza.": "The previous line was not filled in.",
        "Nie zdefiniowano żadnych ról.": "No roles are defined.",
        "Nie zdefiniowano żadnych sekcji.": "No sections are defined.",
        "Nie znaleziono dostępnych widgetów": "No available widgets found",
        "Nie znaleziono elementu.": "Item not found.",
        "Nie znaleziono filtrów.": "No filters found.",
        "Nie znaleziono formularza.": "Form not found.",
        "Nie znaleziono kolumn.": "No columns found.",
        "Nie znaleziono pasującego widgetu": "No matching widget found",
        "Nie znaleziono pasujących elementów.": "No matching items found.",
        "Nie znaleziono żadnego pola.": "No field found.",
        "Nie znaleziono żadnych elementów": "No elements found",
        "Nie znaleziono żadnych folderów.": "No folders found.",
        "Nie znaleziono żadnych linków.": "No links found.",
        "Nie znaleziono żadnych plików": "No files found",
        "Nie znaleziono żadnych użytkowników.": "No users found.",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Nieaktywne": "Inactive",
        "Nieaktywni": "Inactive",
        "Nieaktywny": "Inactive",
        "Niebieski": "Blue",
        "niedozwolone rozszerzenie pliku (%0)": "file extension not allowed (%0)",
        "Niedozwolone słowa": "Unpermitted words",
        "niedozwolony typ pliku (%0)": "file type not allowed (%0)",
        "Niedziela": "Sunday",
        "Nieobecny": "Absent",
        "Nieopłacone": "Unpaid",
        "Nieopublikowane": "Unpublished",
        "Niepoprawne wyrażenie regularne": "Incorrect regular expression",
        "Niepoprawny format wygenrowanego planu szkolenia": "Invalid format of the generated training plan",
        "Niepotwierdzeni": "Unconfirmed",
        "Nieprawidłowa definicja": "Invalid definition",
        "Nieprawidłowy adres email": "Invalid email address",
        "Nieprawidłowy adres URL": "Invalid URL",
        "Niepromowany": "Not promoted",
        "Nieprzeczytane": "Unread",
        "Niepubliczne": "Non-public",
        "Nierozpoczęli": "Not started",
        "Nierozpoczęty": "Unstarted",
        "Niestandardowy adres": "Non-standard address",
        "Niestandardowy adres strony": "Non-standard page address",
        "Niestandardowy błąd": "Non-standard error",
        "Niestandardowy nagłówek": "Custom header",
        "Nieudane logowania": "Failed logins",
        "Niewidoczne": "Not visible",
        "Niezaliczenie testu jest równoznaczne z potwierdzeniem obecności użytkownika": "Failing the test is equivalent to confirming user attendance",
        "Niezaliczone": "Failed",
        "Niezaliczony": "Not passed",
        "Niezaliczyło": "Did not pass",
        "Nieznane narzędzie": "Unknown tool",
        "Nieznany model": "Unknown model",
        "Nieznany typ pliku": "Unknown file type",
        "Niezrealizowane": "Unfulfilled",
        "Nigdy": "Never",
        "Nikomu nie przydzielono uprawnień": "No one has been granted permissions",
        "Niski": "Low",
        "Niżej": "Below",
        "no-store (wyłącza cache)": "no-store (disables cache)",
        "Nowa data": "New date",
        "Nowe hasło": "New password",
        "Nowe połączenie": "New connection",
        "Nowy materiał": "New material",
        "np. (&(objectClass=organizationalUnit))": "e.g. (&(objectClass=organizationalUnit))",
        "np. (&(objectClass=user)": "e.g. (&(objectClass=user)",
        "np. pl-PL": "e.g. pl-PL",
        "Number": "Number",
        "Numer": "Number",
        "Numer aktywnej strony": "Active page number",
        "Numer budynku": "Building number",
        "Numer domu": "House no",
        "Numer konta": "Account number",
        "Numer mieszkania": "Flat no",
        "Numer sesji": "Session number",
        "Numer telefonu": "Phone number",
        "Numer zamówienia": "Order number",
        "Numerowanie zamówień": "Order numbering",
        "O szkoleniu": "About the training",
        "OAuth2 dla Exchange Online": "OAuth2 for Exchange Online",
        "Obecność": "Attendance",
        "Obecność została potwierdzona.": "Attendance has been confirmed.",
        "Obecny": "Present",
        "Obiekt %0 został %1": "Object %0 has been %1",
        "Object": "Object",
        "Obok siebie": "Next to each other",
        "Obraz": "Image",
        "Obraz został pomyślnie opisany": "Image has been successfully described",
        "Obraz został wycięty.": "The image has been cut out.",
        "Obrazek": "Image",
        "Obrazek wyróżniający": "Featured image",
        "Obsługa progu przez platformę": "Threshold handling by the platform",
        "Obsługiwane formaty plików: txt, md, pdf, docx.": "Supported file formats: txt, md, pdf, docx.",
        "Ocena offline": "Offline rating",
        "Oczekujące": "Pending",
        "Oczekujący na akceptację moderatora": "Awaiting moderator approval",
        "Oczekuje na akceptację": "Awaiting approval",
        "Oczekuje na wysłanie": "To be shipped",
        "Oczekuje na zatwierdzenie": "Awaiting confirmation",
        "od": "from",
        "Od": "From",
        "od %0": "from %0",
        "Od poziomu": "From level",
        "Odbiorca": "Recipient",
        "Odblokuj": "Unblock",
        "Odejmowanie": "Subtraction",
        "Odliczanie daty": "Date countdown",
        "Odnośnik URL": "URL reference",
        "Odpowiedzi": "Responses",
        "Odpowiedzi: %0 na %1": "Answers: %0 out of %1",
        "Odpowiedź": "Answer",
        "Odpowiedź dowolna": "Any answer",
        "Odrzucone": "Rejected",
        "Odrzucone zgody": "Rejected consents",
        "Odrzucony po zgłoszeniach": "Rejected after requests",
        "Odrzuć": "Reject",
        "Odstęp": "Space",
        "Odśwież": "Refresh",
        "Odznacz": "Uncheck",
        "Odznacz wszystkie": "Unselect all",
        "Odznaka została dodana.": "Badge has been added.",
        "Odznaka została zaktualizowana.": "Badge has been updated.",
        "Odznaki": "Badges",
        "Ogólne": "General",
        "Ograniczna wygenerowaną odpowiedź do podanej liczby tokenów.": "Limit the generated response to the specified number of tokens.",
        "Ok": "Ok",
        "Okładka": "Cover",
        "Okładka do video premium": "Premium video cover",
        "Określa miejsce, w którym znajdzie się powiązany artykuł": "Specifies the location of the related article",
        "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "Specifies where you want to add additional items to the path.",
        "Omnitool": "Omnitool",
        "Opcja pozwala na przypisywanie do tej kategorii wydarzeń dodanych przez wszystkich użytkowników": "This option allows you to assign events added by all users to this category",
        "Opcje": "Options",
        "Open Graph": "Open Graph",
        "OpenAI": "OpenAI",
        "OpenAI o1": "OpenAI o1",
        "OpenAI o1-mini": "OpenAI o1-mini",
        "Operacje": "Operations",
        "Operacje wykonane": "Operations performed",
        "Opiekun ścieżki": "Path supervisor",
        "Opinia": "Opinion",
        "Opis": "Description",
        "Opis błędu": "Error description",
        "Opis funkcji": "Function description",
        "Opis i media": "Description and media",
        "Opis kategorii": "Category description",
        "Opis obrazka": "Image description",
        "Opis obrazu": "Image description",
        "Opis sekcji": "Section description",
        "Opis spotkania": "Meeting description",
        "Opis szkolenia": "Course description",
        "Opis witryny": "Site description",
        "Opis zespołu": "Team description",
        "Opis źródła": "Source description",
        "Opisy": "Descriptions",
        "Opisz jaki formularz chcesz wygenerować": "Describe the form you want to generate",
        "Opłacone": "Paid",
        "Opróżnij kategorię": "Empty category",
        "Optymalizuj rozdzielczość obrazów": "Optimize image resolution",
        "Opublikowana": "Published",
        "Opublikowane": "Published",
        "Opublikowane języki": "Published languages",
        "Opublikowane przez:": "Posted by:",
        "Opublikowane wersje językowe.": "Published language versions.",
        "Opublikowany": "Published",
        "Opublikowany na stronach": "Published on pages",
        "Opublikuj": "Publish",
        "Opublikuj autora": "Publish author",
        "Opublikuj materiał": "Publish material",
        "Opublikuj ścieżkę szkoleniową aby móc dodać szkolenia": "Publish a course path to be able to add training courses",
        "Oraz hasło": "And a password",
        "Oraz nowe hasło": "And a new password",
        "Organizacja": "Organization",
        "Organizacja została usunięta.": "Organization has been deleted.",
        "Osoba odpowiedzialna": "Responsible person",
        "Osoba zastępowana": "Person being substituted",
        "Osoba zastępująca": "Substitute",
        "Ostatnia aktywność": "Recent activity",
        "Ostatnia strona": "Last page",
        "Ostatnio aktualizowane": "Recently updated",
        "Ostatnio oglądane": "Recently viewed",
        "Ostrzeżenia": "Warnings",
        "Ostrzeżenie": "Warning",
        "Otwieraj w nowym oknie": "Open in new window",
        "Otwórz": "Open",
        "Otwórz na nowej karcie": "Open in new tab",
        "Otwórz stronę w nowym oknie": "Open the page in a new window",
        "Otwórz w nowym oknie": "Open in a new window",
        "Oznacz": "Mark",
        "Oznacz jako nieprzeczytane": "Mark as unread",
        "Oznacz jako przeczytane": "Mark as read",
        "Oznacz powiadomienia": "Mark notifications",
        "Oznacz wszystkie elementy szkolenia jako zaliczone": "Mark all training elements as completed",
        "Oznacz wszystkie jako przeczytane": "Mark all as read",
        "Oznacz wybrane jako nieprzeczytane": "Mark selected as unread",
        "Oznacz wybrane jako przeczytane": "Mark selected as read",
        "Paczka SCORM została dodana.": "The SCORM package has been added.",
        "Paczka SCORM została zaktualizowana.": "The SCORM package has been updated.",
        "Paczka została usunięta.": "The package has been removed.",
        "Paczki SCORM": "SCORM packages",
        "Paleta kolorów": "Color palette",
        "Paleta przycisków": "Button palette",
        "Pamięć podręczna": "Cache",
        "Pamięć podręczna została wyczyszczona.": "The cache has been cleared.",
        "Parameters": "Parameters",
        "Parametry": "Parameters",
        "Parametry funkcji": "Function parameters",
        "Parametry wejściowe skryptu": "Script input parameters",
        "Parametry, wymagane do wykonania zapytania:": "Parameters required to execute the request:",
        "Pasek": "Bar",
        "Pasek postępu": "Progress bar",
        "PayU": "PayU",
        "październik": "October",
        "Październik": "October",
        "październiku": "October",
        "Pełna strona": "Full page",
        "Pełna treść:": "Full content:",
        "Pełny": "Full",
        "Pełny adres aktywnej strony": "Full address of the active page",
        "Pełny adres wraz z \"http(s)://\".": "Full address including \"http(s)://\".",
        "Pełny ekran": "Full screen",
        "Piątek": "Friday",
        "Pierwiastkowanie wartości kolumny": "Column value square root",
        "Pierwsza strona": "First page",
        "Pierwsza strona z listy jest identyfikowana przez system jako CANONICAL, czyli informuje roboty wyszukiwarki, która ze zduplikowanych stron jest tą z oryginalną treścią.": "The first page from the list is identified by the system as CANONICAL, indicating to search engine bots which of the duplicate pages contains the original content.",
        "Pierwsze zdjęcie w galerii jest zdjęciem głównym": "The first photo in the gallery is the main photo",
        "Pigułki": "Knowledge summaries",
        "Piktogram": "Pictogram",
        "Pionowe": "Vertical",
        "Pionowo": "Vertically",
        "Piosenka": "Song",
        "Pisać mogą tylko zalogowani użytkownicy": "Only logged-in users can write",
        "Plik": "File",
        "Plik audio": "Audio file",
        "Plik binarny": "Binary file",
        "Plik CSS": "CSS file",
        "Plik CSV": "CSV file",
        "Plik DOC": "DOC file",
        "Plik DOCX": "DOCX file",
        "Plik GIF": "GIF file",
        "Plik graficzny": "Graphic file",
        "Plik HTML": "HTML file",
        "Plik jest wysyłany": "The file is being sent",
        "Plik JPEG": "JPEG file",
        "Plik JPG": "JPG file",
        "Plik MP4": "MP4 file",
        "Plik PDF": "PDF file",
        "Plik PNG": "PNG file",
        "Plik skompresowany": "Compressed file",
        "Plik wideo": "Video file",
        "Plik z logami": "Log file",
        "Plik ZIP": "ZIP file",
        "Plik został dodany.": "File has been added.",
        "Plik został pobrany.": "File has been downloaded.",
        "Plik został usunięty.": "File has been deleted.",
        "Plik został wysłany": "The file has been sent",
        "Plik:": "File:",
        "Pliki": "Files",
        "Pliki Asystent": "Assistant Files",
        "Pliki asystenta": "Assistant files",
        "Pliki Asystenta": "Assistant Files",
        "Pliki asystenta AI": "AI Assistant files",
        "Pliki do dodania": "Files to add",
        "Pliki do wysłania: %0": "Files to send: %0",
        "Pliki prywatne": "Private files",
        "Pliki publiczne": "Public files",
        "Pliki współdzielone": "Shared files",
        "Pliki: %0": "Files: %0",
        "Płatności": "Payments",
        "Płeć": "Gender",
        "Płyta z muzyką": "Music CD",
        "po %0 nieudanych próbach logowania": "after %0 unsuccessful login attempts",
        "Po dodaniu szkoleń nie można zmienić publikacji.": "Once a course is added, publications cannot be changed.",
        "Po jednym synonimie w wierszu": "One synonym per line",
        "Po ustawieniu dat dostępów dla użytkowników w ścieżce będą one nadrzędne, daty dostępów dodane w szkoleniu nie będą brane pod uwagę.": "Once access dates are set for users in the path, they will be parent, access dates added in the course will not be taken into account.",
        "Po ustawieniu indywidualnych dat dostępów dla użytkowników będą one nadrzędne, daty dostępów z zespołów nie będą brane pod uwagę.": "Once individual access dates are set for users, they will be parent, access dates from teams will not be taken into account.",
        "Po wybraniu tej opcji konta użytkowników zostaną usunięte z systemu. Czy chcesz kontynuować?": "When you select this option, user accounts are deleted from the system. Do you want to continue?",
        "Po zapisaniu wydarzenia nie można zmienić witryny i wersji językowej": "After saving the event, site and language version cannot be changed",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "When you select this option, individual and role permissions will not be considered.",
        "Po zmianie krótkiego tytułu zmieni się również adres URL.": "When you change the short title, the URL will also be changed.",
        "Pobierz": "Download",
        "Pobierz certyfikat": "Download certificate",
        "Pobierz plik": "Download file",
        "Pobierz raport": "Download report",
        "Pobierz wyniki": "Download results",
        "Pochylenie": "Italic",
        "Początkowa ilość wierszy": "Initial number of rows",
        "Poczta": "Mail",
        "Podaj adres url...": "Enter the url...",
        "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "Provide Facebook user IDs, separated by commas, so they can access to their statistics (Facebook Insights).",
        "Podaj kod weryfikacyjny": "Enter verification code",
        "Podaj liczbę pozycji": "Enter the number of items",
        "Podaj nazwę formularza": "Enter form name",
        "Podaj nazwę scenariusza": "Enter scenario name",
        "Podaj nową nazwę": "Enter a new name",
        "Podaj swój adres email": "Enter your email address",
        "Podaj uwagi do treści, która ma zostać wygenerowana. Przykład: \"Używaj symboli matematycznych\".": "Provide comments about the content that you want to generate. For example: \"Use mathematical symbols.\"",
        "Podana nazwa jest zajęta.": "The name you entered is already taken.",
        "Podana wartość jest nieprawidłowa.": "The provided value is not valid.",
        "Podanie nazwy jest wymagane.": "Name is required.",
        "Podano adres": "Address given",
        "Podano nieprawidłowe dane": "Invalid data provided",
        "Podano nieprawidłowe dane.": "Invalid data provided.",
        "Podano nieprawidłowe dane. (%0)": "Invalid data provided. (%0)",
        "Podany adres e-mail został już dodany": "The provided email address has already been added",
        "Podatek": "Tax",
        "Podążanie za linkami": "Links following",
        "Podczas definiowania szkolenia w prompcie zalecamy używanie następujących terminów:": "When defining training in the prompt, we recommend using the following terms:",
        "Podczas pierszego uruchomienia wymagane jest utworzenie konta głównego administratora.": "On initial startup, you will need to create a main administrator account.",
        "Podczas próby logowania wystąpił problem z zapisem recaptcha. Spróbuj ponownie": "Problem occurred during login attempt with recaptcha. Try again",
        "Podczas przesyłania plików wystąpił nieznany błąd": "Unknown error occurred during file upload",
        "Podejście do elementu zostało zresetowane.": "Approach to the element has been reset.",
        "Podgląd": "Preview",
        "Podgląd formularza": "Form preview",
        "Podgląd listy": "List preview",
        "Podgląd strony": "Page preview",
        "Podgląd tabeli": "Table preview",
        "Podkreślenie": "Highlight",
        "Podlega ocenie": "To be graded",
        "Podpis": "Signature",
        "Podstawowe": "Basic",
        "Podstawowe operacje na datach": "Basic date operations",
        "Podstawowe operacje na liczbach": "Basic digits operations",
        "Podstawowe operacje tekstowe": "Basic text operations",
        "Podstawowe operacje warunkowe": "Basic conditional operations",
        "Podstawowy": "Basic",
        "Podtytuł": "Subtitle",
        "Podwójna": "Double",
        "Podwójna linia ciągła": "Double solid line",
        "Podziedziałek - Piątek": "Monday- Friday",
        "Pogrubienie": "Bold",
        "Pogrubiona": "Bold",
        "Pojedynczy artykuł (strona opisowa)": "Single article (descriptive page)",
        "Pojedynczy formularz": "Single form",
        "Pojedynczy wybór": "Single choice",
        "Pojedyńcza, prosta, ciągła linia": "Single, simple, solid line",
        "Pokaż dla wybranych zespołów lub użytkowników": "Show for selected teams or users",
        "Pokaż etykietę": "Show tag",
        "Pokaż historię": "Show history",
        "Pokaż numery stron": "Show page numbers",
        "Pokaż numery tygodnia na kalendarzu": "Show week numbers on calendar",
        "Pokaż przycisk 'Wyślij'": "Show 'Send' button",
        "Pokaż szczegóły": "Show details",
        "Pokaż tylko moje dokumenty": "Show my documents only",
        "Pokaż tytuł formularza": "Show form title",
        "Pokaż tytuł sekcji": "Show section title",
        "Pokaż tytuł strony": "Show page title",
        "Pokaż tytuły stron": "Show page titles",
        "Pokaż w koncie użytkownika": "Show in user account",
        "Pokaż więcej": "Show more",
        "pokaż więcej...": "show more...",
        "Pokaż wszystkich użytkowników": "Show all users",
        "Pola takie jak \"Nazwa slajdu\", \"Kategoria materiału\", \"Typ materiału\" są uwzględniane przy automatycznym generowaniu treści, dlatego konieczne jest ich wypełnienie.": "Fields such as \"Slide Name\", \"Material Category\", \"Material Type\" are included in the automatic generation of content, so it is necessary to fill them in.",
        "Pole": "Field",
        "Pole \"%0\" jest wymagane.": "Field ''%0'' is required.",
        "Pole \"%0\" jest wymagane. (%1)": "Field \"%0\" is required. (%1)",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "Field ''%0'' does not contain a valid email address.",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "Field ''%0'' does not contain a valid URL address.",
        "Pole \"%0\" wymaga uzupełnienia wszystkich elementów": "Field \"%0\" requires all elements to be completed",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "Field \"%0\" contains an invalid value.",
        "Pole \"%0\" zawiera nieprawidłowy symbol.": "Field \"%0\" contains invalid symbol.",
        "Pole \"Drugie imię\" jest wymagane.": "''Middle name'' is required.",
        "Pole \"Email\" jest wymagane.": "Field \"Email\" is required.",
        "Pole \"Imię\" jest wymagane.": "''Name'' is required.",
        "Pole \"Liczba wyników na stronie\" jest wymagane.": "Field \"Number of results per page\" is required.",
        "Pole \"Moduł dynamiczny\" jest wymagane.": "Field \"Dynamic module\" is required.",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "Field \"Username\" is required.",
        "Pole \"Nazwa\" jest wymagane.": "Field \"Name\" is required.",
        "Pole \"Nazwisko\" jest wymagane.": "''Surname'' is required.",
        "Pole \"Pole\" jest wymagane.": "Field \"Field\" is required.",
        "Pole \"Sekcja modułu\" jest wymagane.": "Field \"Module section\" is required.",
        "Pole \"Szerokość\" jest wymagane.": "Field \"Width\" is required.",
        "Pole \"Typ agregacji\" jest wymagane.": "Field \"Aggregation type\" is required.",
        "Pole \"Tytuł\" jest wymagane.": "''Title'' is required.",
        "Pole \"Wysokość\" jest wymagane.": "Field \"Height\" is required.",
        "Pole jest wymagane": "Field is required",
        "Pole jest wymagane.": "Field is required.",
        "Pole może zawierać jedynie cyfry.": "Field can only contain numbers.",
        "Pole może zawierać jedynie cyfry. (%0)": "Field can only contain digits. (%0)",
        "Pole może zawierać jedynie litery i cyfry.": "This field can contain only letters and numbers.",
        "Pole może zawierać jedynie litery i cyfry. (%0)": "Field can only contain letters and digits. (%0)",
        "Pole może zawierać jedynie litery.": "This field can only contain letters.",
        "Pole może zawierać jedynie litery. (%0)": "Field can only contain letters. (%0)",
        "Pole może zawierać tylko ciało metody walidującej dane w postaci natywnego kodu JavaScript.": "Field can only contain the body of the data validation method in native JavaScript code.",
        "Pole nie może zawierać spacji": "Field cannot contain spaces",
        "Pole skopiowane": "Field copied",
        "Pole tekstowe": "Text field",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "Field type \"%0\" is not allowed in this form.",
        "Pole wymaga podania przynajmniej jednego znaku specjalnego.": "Field requires at least one special character.",
        "Pole wymaga podania przynajmniej jednej cyfry.": "Field requires at least one digit.",
        "Pole wymaga podania przynajmniej jednej dużej litery.": "Field requires at least one uppercase letter.",
        "Pole wymaga podania przynajmniej jednej małej litery.": "Field requires at least one lowercase letter.",
        "Pole wymagane": "Field required",
        "Pole zawiera": "Field contains",
        "Polecane artykuły": "Recommended articles",
        "Polityka prywatności": "Privacy policy",
        "Polski": "Polish",
        "Połącz w pary": "Pair up",
        "Połączenie z API OpenAI jest aktywne.": "Connection to the OpenAI API is active.",
        "Połączenie z API OpenAI jest nieaktywne.": "The connection to the OpenAI API is inactive.",
        "Położenie tekstu w pionie": "Vertical text alignment",
        "Położenie tekstu w poziomie": "Horizontal text alignment",
        "Pomoc": "Help",
        "Poniedziałek": "Monday",
        "Poprawna odpowiedź": "Correct answer",
        "Poprawne": "Correct",
        "Poprawny": "Correct",
        "Poprzedni": "Previous",
        "Poprzednia strona": "Previous page",
        "Popularność": "Popularity",
        "Porównaj %0": "Compare %0",
        "Porównaj z edytowaną wersją": "Compare with edited version",
        "Porównania": "Comparison",
        "Porównanie": "Comparison",
        "Porównywana wersja": "Compared version",
        "Port": "Port",
        "Posiada załączniki": "Containing attachments",
        "Posiadasz niezapisane materiały": "You have unsaved materials",
        "POST: Dowolne wyszukiwanie (Zapytanie AQL)": "POST: Any search (AQL query)",
        "POST: Upload załączników": "POST: Upload attachments",
        "POST: Utworzenie wpisu": "POST: Create entry",
        "POST: Zapisanie zmian": "POST: Save changes",
        "Postęp": "Progress",
        "Postęp (%)": "Progress (%)",
        "Postępy": "Progress",
        "Postępy użytkowników": "User progress",
        "Potwierdzenia": "Confirmations",
        "Potwierdzenie akceptacji": "Confirmation of acceptance",
        "Potwierdzenie archiwizacji": "Archiving confirmation",
        "Potwierdzenie archiwizacji. Archiwizacja tematu spowoduje zarchiwizowanie przypisanych do niego lekcji": "Archiving confirmation. When a topic is archived, the lessons assigned to it are also archived",
        "Potwierdzenie kopiowania": "Copy confirmation",
        "Potwierdzenie przywrócenia": "Confirmation of restoration",
        "Potwierdzenie przywrócenia szkolenia": "Confirmation of course restoration",
        "Potwierdzenie publikacji": "Publication confirmation",
        "Potwierdzenie resetu podejścia do elementu szkolenia": "Confirmation of resetting the approach to the training element",
        "Potwierdzenie resetu podejścia do szkolenia": "Confirmation of resetting the approach to training",
        "Potwierdzenie ukrycia": "Hiding confirmation",
        "Potwierdzenie usunięcia": "Deletion confirmation",
        "Potwierdzenie usunięcia.": "Deletion confirmation.",
        "Potwierdzenie wylogowania użytkownika": "User logout confirmation",
        "Potwierdzenie zatwierdzenia": "Approval confirmation",
        "Potwierdzenie zmiany statusu": "Confirmation of status change",
        "Potwierdź": "Confirm",
        "Potwierdź akceptację": "Confirm acceptance",
        "Potwierdź publikację wersji": "Confirm version publication",
        "Potwierdź usunięcie": "Confirm deletion",
        "Potwierdź usunięcie wybranej wersji aranżacji": "Confirm deletion of the selected arrangement version",
        "Potwierdź wyczyszczenie logów": "Confirm clearing logs",
        "Potwierdź wyłączenie publikacji": "Confirm that you want to disable publication",
        "Potwierdź zapis do aktualnej wersji": "Confirm saving to the current version",
        "Powiadomienia": "Notifications",
        "Powiadomienia mailowe": "Email notifications",
        "Powiadomienia z linkiem rejestracyjnym nie zostaną wysłane, ponieważ ten typ powiadomień nie jest obecnie włączony w platformie.": "Notifications with the registration link will not be sent because this type of notification is currently not enabled on the platform.",
        "Powiadomienia zostały skonfigurowane.": "Notifications have been configured.",
        "Powiadomienie dla administratora chatu o nowych wiadomościach": "Notification to the chat administrator about new messages",
        "Powiadomienie dla użytkownika o nowych wiadomościach na chacie": "Notification to the user about new messages in the chat",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "Notification is required by default. You cannot stop this notification to appear.",
        "Powiadomienie o oczekującym szkoleniu": "Pending course notification",
        "Powiadomienie o zbliżającym się zakończeniu szkolenia": "Notification of the upcoming end of the course",
        "Powiadomienie testowe zostało wysłane.": "Test notification has been sent.",
        "Powiadomienie zbiorowe zostało dodane.": "Bulk notification has been added.",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "Bulk notification has been updated.",
        "Powiązana galeria": "Related gallery",
        "Powiązana kategoria": "Related category",
        "Powiązana kontrolka": "Linked control",
        "Powiązane artykuły": "Related articles",
        "Powiązane galerie": "Related galleries",
        "Powiązane kategorię": "Related categories",
        "Powiązane wideo": "Related video",
        "Powiązane wydziały": "Related departments",
        "Powiązany artykuł": "Related article",
        "Powiązany autor": "Related author",
        "Powiększ": "Zoom in",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "A PRIVATE directive should be added for personalized content for the user, especially for answers received after logging in and considering privileges.",
        "Powód": "Reason",
        "powrót": "return",
        "Powrót": "Back",
        "Powtarzaj co": "Repeat every",
        "Powtórz hasło": "Repeat password",
        "Powtórzenia": "Repetitions",
        "Powtórzone": "Repeated",
        "Powyższe obiekty zawierają tylko właściwości i są pozbawione wszystkich metod.": "The above objects contain only properties and are devoid of all methods.",
        "Poziom dostępu do webhooka": "Webhook access level",
        "Poziom dostępu użytkownika": "User access level",
        "Poziom logowania błedów": "Error logging level",
        "Poziome": "Horizontal",
        "Poziomo": "Horizontally",
        "Poziomy logowania": "Logging levels",
        "Pozostałe": "Others",
        "Pozostałe ustawienia": "Other settings",
        "Pozostało %0 znaków.": "There are %0 characters left.",
        "Pozwól kontynuować na obecnej wersji": "Allow to continue on current version",
        "Pozwól na dodawanie wierszy": "Allow adding rows",
        "Pozwól na sortowanie wierszy": "Allow row sorting",
        "Pozycja": "Position",
        "Pozycja na liście": "Position on list",
        "Pozycje zostały zapisane.": "Positions have been saved.",
        "pół roku": "Half a year",
        "Prawda-Fałsz": "True-False",
        "Prawo": "Right",
        "Prawy panel": "Right panel",
        "Predefiniowane tła panelu z aplikacjami": "Predefined panel backgrounds with applications",
        "Predefiniowane zestawy kolorów": "Predefined color sets",
        "Premiera": "Premiere",
        "Premium": "Premium",
        "Premium otwarty": "Premium open",
        "Prezentacja": "Presentation",
        "Priorytet": "Priority",
        "private (tylko cache przeglądarki)": "private (browser cache only)",
        "Procent": "Percentage",
        "Proces": "Process",
        "Produkcyjne": "Production",
        "Produkt nie został usunięty. Należy do kolekcji:": "Product has not been deleted. Belongs to collection:",
        "Produkt promowany": "Promoted product",
        "Produkt został dodany.": "Product has been added.",
        "Produkt został usunięty.": "Product has been deleted.",
        "Produkt został zaktualizowany.": "Product has been updated.",
        "Produkty": "Products",
        "Profil koordynatora": "Coordinator profile",
        "Profil użytkownika": "Profile",
        "Profil został zaktualizowany.": "The profile has been updated.",
        "Program": "Program",
        "Program szkolenia": "Course program",
        "Projekt": "Project",
        "Prometheus": "Prometheus",
        "Promowany": "Promoted",
        "Proporcje obrazu": "Image proportions",
        "Prosta": "Simple",
        "Proste uprawnienia": "Simple privileges",
        "Protokół OAuth - client_id": "OAuth protocol - client_id",
        "Protokół OAuth - client_secret": "OAuth protocol - client_secret",
        "Próbkowanie": "Sampling",
        "Próg": "Threshold",
        "Próg zaliczenia (%)": "Pass marker (%)",
        "Prywatne": "Private",
        "Prywatny": "Private",
        "Przebudowanie indeksów": "Rebuilding indices",
        "Przebudowanie indeksównnOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.nnNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "Rebuilding indices. This can take from a few seconds to several hours, depending on the size of the indices. Use only if you need to apply changes made to the synonyms or excluded words dictionaries.",
        "Przeciągnij do innej sekcji": "Drag to another section",
        "Przeciągnij do wybranej sekcji": "Drag to the selected section",
        "Przeciągnij i upuść aby posortować pliki": "Drag and drop to sort files",
        "Przeczytane": "Read",
        "Przedrostek": "Prefix",
        "Przedtytuł": "Pre-title",
        "Przeglądanie logów aktywności": "View activity logs",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "The browser you are using does not support PUSH notifications",
        "Przeglądnij logi": "View logs",
        "Przeindeksowanie danych": "Data re-indexing",
        "Przeindeksowanie danychnnOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.nnNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "Re-indexing datannOperation can take from a few seconds to a few hours depending on the amount of data in the database.nnUse only if you notice missing data in the indexes.",
        "Przejdź do kolejnego kroku gdy:": "Proceed to next step when:",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "Go to configuration to enable tools",
        "Przekierowania": "Redirects",
        "Przekierowanie aktywne": "Active redirect",
        "Przekierowanie zostało dodane.": "Redirect has been added.",
        "Przekierowanie zostało usunięte.": "Redirect has been deleted.",
        "Przekierowanie zostało zaktualizowane.": "Redirect has been updated.",
        "Przekreślenie": "Strikethrough",
        "Przekroczono dozwoloną ilość znaków: %0.": "Exceeded allowed number of characters: %0.",
        "Przekroczono dozwoloną ilość znaków: %0. (%1)": "Exceeded allowed number of characters: %0. (%1)",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "allowed file size exceeded (%0 MB)",
        "Przelew tradycyjny": "Traditional transfer",
        "Przelewy24": "Przelewy24",
        "Przełącznik": "Switcher",
        "Przeniesienie wpisu do kosza": "Move entry to bin",
        "Przeniesienie wybranych elementów": "Transfer selected items",
        "przeniesiony do kosza": "moved to bin",
        "Przenieś": "Move",
        "Przenieś do sekcji": "Move to section",
        "Przenieś niżej": "Move lower",
        "Przenieś wyżej": "Move higher",
        "Przenieś${selected.length > 1 ? ' zaznaczone' : ''}": "Move${selected.length > 1 ? ' selected' : ''}",
        "przeniósł do kosza": "moved to bin",
        "Przepisz aktualne stawki za 1000 tokenów z cennika OpenAI.": "Rewrite current rates for 1000 tokens from the OpenAI price list.",
        "Przepisz aktualne stawki za milion tokenów z cennika Azure OpenAI.": "Rewrite current rates for a million tokens from the Azure OpenAI price list.",
        "Przepisz aktualne stawki za milion tokenów z cennika OpenAI.": "Rewrite current rates for a million tokens from the OpenAI price list.",
        "Przepisz aktualne stawki za tysiąc tokenów z cennika Azure OpenAI.": "Rewrite current rates for a thousand tokens from the Azure OpenAI price list.",
        "Przepisz aktualne stawki za tysiąc tokenów z cennika OpenAI.": "Rewrite current rates for a thousand tokens from the OpenAI price list.",
        "Przepisz limit konta OpenAI.": "Rewrite OpenAI account limit.",
        "Przepnij alias": "Switch alias",
        "Przerwany": "Interrupted",
        "Przerywana": "Dashed",
        "Przesuń do góry": "Move up",
        "Przesuń na dół": "Move down",
        "Przesuń w dół": "Move down",
        "Przesyłanie plików powiodło się.": "File upload succeeded.",
        "Przetestuj": "Test",
        "Przetestuj poprawność zapisanych kluczy": "Test the validity of the saved keys",
        "Przetestuj ustawienia poczty": "Test your mail settings",
        "Przetestuj ustawienia Sms": "Test your SMS settings",
        "Przetwarzane": "Processing",
        "przez": "by",
        "Przybliżenie": "Zoom",
        "Przybornik": "Kit",
        "Przycisk \"zobacz wszystkie\" znajdujący się przy bloczku, będzie przekierowywał na wybraną stronę z szkoleniami. Jeśli strona nie zostanie wybrana zostanie on ukryty.": "The \"view all\" button located next to the block will redirect to the selected training page. If no page is selected, it will be hidden.",
        "Przyciski": "Buttons",
        "Przykład": "Example",
        "Przykład:": "Example:",
        "Przykład: domena\\użytkownik": "Example: domain\\user",
        "Przykład: użytkownik@domena": "Example: user@domain",
        "Przykładowa struktura danych": "Sample data structure",
        "Przykładowa struktura do rozbudowy/modyfikacji": "Sample structure for expansion/modification",
        "Przykładowy prompt": "Sample prompt",
        "Przykładowy prompt ": "Sample prompt ",
        "Przykłady": "Examples",
        "Przykłady konfiguracji": "Configuration examples",
        "Przypisanie do zespołu": "Team assignment",
        "Przypisanie ról": "Role assignment",
        "Przypisz użytkowników do terminu spotkania, aby móc ich wyszukać.": "Assign users to the meeting date to be able to search for them.",
        "przypisz wynik etapu...": "assign stage result...",
        "Przypisz zespoły do terminu spotkania, aby móc je wyszukać.": "Assign teams to the meeting date to be able to search for them.",
        "Przypomnienie": "Reminder",
        "Przyrostek": "Suffix",
        "Przywrócenie": "Restoration",
        "Przywrócenie wpisu z kosza": "Restore entry from bin",
        "Przywrócić użytkownika i jego wiadomości?": "Restore the user and their messages?",
        "Przywrócić wiadomość?": "Restore a message?",
        "przywrócił z kosza": "restored from bin",
        "przywrócony z kosza": "restored from bin",
        "Przywróć": "Reload",
        "Przywróć domyślne": "Restore defaults",
        "Przywróć filtr": "Restore filter",
        "Przywróć ustawienia domyślne reguł i celów": "Restore default rules and goals settings",
        "Przywróć użytkownika": "Restore user",
        "Przyznaj dostęp": "Grant access",
        "Przyznawanie punktów": "Point allocation",
        "Pseudonim": "Pseudonym",
        "public (cache przeglądarki i proxy)": "public (browser and proxy cache)",
        "Publiczne": "Public",
        "Publiczne ID:": "Public ID:",
        "Publiczny": "Public",
        "Publikacja": "Publication",
        "Publikacja aranżacji została wyłączona.": "The publication of the arrangement has been disabled.",
        "Publikacja galerii przez użytkownika": "Gallery publication by user",
        "Publikacja i przypisane szkolenia zostały usunięte.": "The publication and assigned courses have been deleted.",
        "Publikacja priorytetowa": "Priority publication",
        "Publikacja zarchiwizowana": "Archived publication",
        "Publikacja została dodana.": "The publication has been added.",
        "Publikacja została usunięta.": "The publication has been deleted.",
        "Publikuj do": "Publish to",
        "Publikuj na stronie": "Publish to page",
        "Publikuj od": "Publish from",
        "Publikuj spotkanie": "Publish meeting",
        "Publikuj szkolenie": "Publish course",
        "Publikuj ścieżkę szkoleniową": "Publish learning path",
        "Publikuj termin": "Publish date",
        "Punkty": "Points",
        "Punkty za ukończenie": "Completion points",
        "Punkty zostały dodane.": "Points have been added.",
        "Punkty zostały zaktualizowane. Zmiana dotyczy tylko nowo zdobytych punktów.": "Points have been updated. The change only applies to newly earned points.",
        "PUT: Aktualizacja wpisu": "PUT: Update entry",
        "Pytania": "Questions",
        "Pytania i odpowiedzi": "Questions & Answers",
        "Pytanie": "Question",
        "Pytanie i odpowiedzi": "Question and answers",
        "Query string": "Query string",
        "Radio": "Radio",
        "Ranga": "Rank",
        "Raporty": "Reports",
        "Raporty certyfikatów": "Certificate reports",
        "Raporty szkoleniowe": "Training reports",
        "Recaptcha": "Recaptcha",
        "ReCaptcha": "ReCaptcha",
        "Redaktor został zaktualizowany.": "Editor has been updated.",
        "Region": "Region",
        "Regulamin wymagany": "Regulations required",
        "Regulamin został dodany.": "Regulations have been added.",
        "Regulamin został zaktualizowany.": "Ragulations have been updated.",
        "Regulaminy": "Regulations",
        "Regularna": "Regular",
        "Reguła": "Rule",
        "Reguła filtracyjna": "Filter rule",
        "Reguła końcowa": "Final rule",
        "Reguła został dodana.": "Rule has been added.",
        "reguła została usunięta.": "Rule has been deleted.",
        "Reguła została zaktualizowana.": "Rule has been updated.",
        "Reguły": "Rules",
        "Rejestr zmian": "Changelog",
        "Rejestracja konta": "Sign-up",
        "Relacyjne": "Relational",
        "Repozytorium plików": "File repository",
        "Request body": "Request body",
        "Reset podejścia do szkolenia": "Reset training approach",
        "Resetowanie podejść": "Reset approaches",
        "Resetowanie podejść użytkowników": "Reset user approaches",
        "Resetuj": "Reset",
        "Resetuj licznik": "Reset counter",
        "Resetuj zmiany": "Reset changes",
        "RESTful API": "RESTful API",
        "Rezultat": "Result",
        "Rezygnacja": "Resignation",
        "Reżyseria": "Direction",
        "Ręczna akceptacja wszystkich komentarzy": "Manually accept all comments",
        "Rocznie": "Yearly",
        "Roczny": "Annual",
        "Rodzaj adresu kanonicznego": "Type of canonical address",
        "Rodzaj odpowiedzi": "Type of response",
        "Rodzaj wydarzenia": "Event type",
        "Rodzaj źródła": "Source type",
        "rok": "year",
        "Rok": "Year",
        "Rola": "Role",
        "Rola aktywna": "Active role",
        "Rola domyślna": "Default role",
        "Rola została dodana.": "The role has been added.",
        "Rola została usunięta.": "The role has been removed.",
        "Rola została zaktualizowana.": "The role has been updated.",
        "Role i uprawnienia": "Roles and permissions",
        "Role użytkownika": "User roles",
        "Role zespołu": "Team roles",
        "Role zostały przypisane": "Roles have been assigned",
        "Root": "Root",
        "Rotator": "Rotator",
        "Rotator został dodany.": "Rotator has been added.",
        "Rotator został usunięty.": "Rotator has been deleted.",
        "Rotator został zaktualizowany.": "Rotator has been updated.",
        "Rotatory opinii": "Opinion rotators",
        "Rozdzielczość": "Resolution",
        "Rozdzielczość obrazu: 1024x1024": "Image resolution: 1024x1024",
        "Rozdzielczość obrazu: 1024x1792 lub 1792x1024": "Image resolution: 1024x1792 or 1792x1024",
        "Rozdzielczość wygnerowanego obrazu.": "Generated image resolution.",
        "Rozmiar": "Size",
        "Rozmiar czcionki": "Font size",
        "Rozmiar okna popup": "Popup window size",
        "Rozmiar pliku": "File size",
        "Rozmiar podawany w bajtach.": "Size provided in bytes.",
        "Rozmiar zdjęcia został zmieniony.": "The image has been resized.",
        "Rozmieść równomiernie": "Spread evenly",
        "Rozpoczęcie spotkania": "Meeting start",
        "Rozpoczęcie szkolenia": "Training start",
        "Rozszerzony - błedy ważne": "Extended - important errors",
        "Rozwijana lista - accordion": "Dropdown list - accordion",
        "Rozwiń do": "Expand to",
        "Równość": "Equality",
        "RSS": "RSS",
        "Satysfakcja": "Satisfaction",
        "Scenariusz": "Scenario",
        "Scenariusz aktywny": "Active scenario",
        "Scenariusz został dodany.": "Scenario has been added.",
        "Scenariusz został usunięty.": "Scenario has been deleted.",
        "Scenariusz został utworzony.": "Scenario has been created.",
        "Scenariusz został zaktualizowany.": "Scenario has been updated.",
        "Scorm": "Scorm",
        "SCORM": "SCORM",
        "Scrollowalne okna popup": "Scrollable popup windows",
        "Secret ID": "Secret ID",
        "Sekcja": "Section",
        "Sekcja %0": "Section %0",
        "Sekcja modułu": "Module section",
        "Sekcja pod artykułem": "Section under the article",
        "Sekcja śródtekstowa": "In-text section",
        "Sekcje": "Sections",
        "Sekcje dla gości": "Guest sections",
        "Sekcje dla zalogowanych": "Sections for logged in",
        "Sekcje i bloki": "Sections and blocks",
        "Sekcje wspólne": "Common sections",
        "Sekundy": "Seconds",
        "Selektor ikony": "Icon selector",
        "Selektor kolorów": "Color selector",
        "SenderId": "SenderId",
        "Sentry": "Sentry",
        "Separator elementów w tytule": "Element separator in title",
        "Seq": "Seq",
        "Serial telewizyjny": "Television series",
        "Serie kresek lub fragmentów linii": "Series of dashes or line fragments",
        "Serie kropek": "Series of dots",
        "Server Side Cache": "Server Side Cache",
        "Serwer bazy danych": "Database server",
        "Serwer dostępny": "Server available",
        "Serwer plików": "File server",
        "Serwer został dodany.": "Server has been added.",
        "Serwer został usunięty.": "Server has been removed.",
        "Serwer został zaktualizowany.": "Server has been updated.",
        "Serwery plików": "File servers",
        "Sesja": "Session",
        "Sesja nr %0": "Session No . %0",
        "Sesja użytkownika": "User's session has expired",
        "Sheduler": "Scheduler",
        "sierpień": "August",
        "Sierpień": "August",
        "sierpniu": "August",
        "Sitemap": "Sitemap",
        "Skala 1-5": "Scale 1-5",
        "Skala odliczania": "Countdown scale",
        "Sklep": "Store",
        "Skopiowano": "Copied",
        "Skopiuj szkolenie": "Copy course",
        "Skrócony opis": "Short description",
        "Skrypt (C#)": "Script (C#)",
        "Skrypty zewnętrzne": "External scripts",
        "Skrypty związane ze zbieraniem danych targetujących, np. Google Tag Manager, Pixel Facebook. Dodawany w górnej części <body> witryny.": "Scripts related to collecting targeting data, e.g., Google Tag Manager, Facebook Pixel. Added at the top of the <body> of the website.",
        "Skrypty związane ze zbieraniem statystyk przez usługi zewnętrzne, np. Analytics, Matomo. Dodawany w górnej części <head> witryny.": "Scripts related to collecting statistics by external services, e.g., Analytics, Matomo. Added at the top of the <head> of the website.",
        "Slajd do powtórzenia": "Slide to repeat",
        "Slajd z materiałów szkoleniowych": "Slide from course materials",
        "Slajd został dodany.": "The slide has been added.",
        "Slajd został usunięty.": "The slide has been deleted.",
        "Slajd został wygenerowany.": "The slide has been generated.",
        "Slajd został zaktualizowany.": "The slide has been updated.",
        "Slajder": "Slider",
        "Slajder został dodany.": "The slider has been added.",
        "Slajder został usunięty.": "The slider has been removed.",
        "Slajder został zaktualizowany.": "The slider has been updated.",
        "Slajdery": "Sliders",
        "Slajdy": "Slides",
        "Slajdy zostały zaimportowane.": "The slides have been imported.",
        "słowa": "words",
        "Słowa kluczowe": "Keywords",
        "Słowa oddzielone przecinkami.": "Words separated by commas.",
        "Słowa wykluczone": "Excluded words",
        "Słownik": "Dictionary",
        "Słownik dowolny": "Any dictionary",
        "Słownik systemowy": "System dictionary",
        "Słowo": "Word",
        "Słowo bazowe": "Base word",
        "Słowo wykluczone": "Excluded word",
        "Słowo zostało dodane.": "Word has been added.",
        "Słowo zostało usunięte.": "Word has been deleted.",
        "Słowo zostało zaktualizowane.": "Word has been updated.",
        "Sobota": "Saturday",
        "Sortowanie": "Sorting",
        "Sortowanie autorów": "Author sorting",
        "Sortowanie kategorii": "Category sorting",
        "Sortuj autorów": "Sort authors",
        "Sortuj kategorie": "Sort categories",
        "Specjalizowane": "Specialized",
        "Specyfikacja": "Specification",
        "Sposób płatności włączony": "Payment method enabled",
        "Sposób płatności został dodany.": "Payment method has been added.",
        "Sposób płatności został usunięty.": "Payment method has been deleted.",
        "Sposób płatności został zaktualizowany.": "Payment method has been updated.",
        "Sposób prezentacji zakładek": "Methodof displaying tabs",
        "Spotkania": "Meetings",
        "Spotkanie": "Meeting",
        "Spotkanie do": "Meeting to",
        "Spotkanie od": "Meeting from",
        "Spotkanie zostało dodane.": "Meeting has been added.",
        "Spotkanie zostało usunięte.": "Meeting has been deleted.",
        "Spotkanie zostało zaktualizowane.": "Meeting has been updated.",
        "Sprawdzenie czy pusty": "Check if empty",
        "Sprawdź poprawność wprowadzonych danych. Po zapisaniu kolumna Zaliczenie testu nie będzie edytowalna, ponieważ zostanie wygenerowany certyfikat. Czy zapisać dane?": "Check the correctness of the entered data. After saving, the Test Completion column will not be editable as a certificate will be generated. Save data?",
        "Stała wartość": "Constant value",
        "Stan": "Satus",
        "Stan powiadomienia": "Notification status",
        "Standard": "Standard",
        "Standard 1.2": "Standard 1.2",
        "Standard 2004": "Standard 2004",
        "Standard nieznany": "Standard unknown",
        "Standardowa strona": "Standard page",
        "Standardowa szczegółowość": "Standard detail",
        "Standardowe uprawnienia": "Standard privileges",
        "Standardowy": "Standard",
        "Stanowiska": "Positions",
        "Stanowisko": "Position",
        "Stanowisko pracy": "Work position",
        "Stanowisko zostało dodane.": "Position has been added.",
        "Stanowisko zostało usunięte.": "Position has been deleted.",
        "Stanowisko zostało zaktualizowane.": "Position has been updated.",
        "Start": "Start",
        "Status": "Status",
        "Status aranżacji został zmieniony.": "Arrangement status has been changed.",
        "Status dokumentu został zmieniony.": "The status of the document has been changed.",
        "Status edytowanej wersji dokumentu": "Status of the edited version of the document",
        "Status galerii został zmieniony.": "Gallery status has been changed.",
        "Status linku został zmieniony.": "The status of the link has been changed.",
        "Status modułu": "Module status",
        "Status paczki został zmieniony.": "The status of the package has been changed.",
        "Status płatności": "Payment status",
        "Status powiadomienia": "Notification status",
        "Status realizacji": "Fulfillment status",
        "Status regulaminu został zmieniony.": "The status of the regulations has been changed.",
        "Status webhooka": "Webhook status",
        "Status wideo został zmieniony.": "Video status has been changed.",
        "Status został zmieniony dla ": "Status has been changed for ",
        "Status żądania": "Request status",
        "Status:": "Status:",
        "Statyczny": "Static",
        "Statystyki wykorzystania tokenów.": "Token usage statistics.",
        "Stopka": "Footer",
        "String": "String",
        "Strona": "Page",
        "Strona %0": "Page %0",
        "Strona błędu": "Error page",
        "Strona docelowa dla 'Czytaj więcej'": "Target page for 'Read more'",
        "Strona docelowa dla 'Kontakt z adminem'": "Target page for 'Contact admin'",
        "Strona docelowa dla 'Pliki cookies'": "Target page for 'Cookies'",
        "Strona docelowa dla 'Polityka prywatności'": "Target page for 'Privacy policy'",
        "Strona dostępna dla wszystkich": "Website available to everyone",
        "Strona dostępna tylko dla zalogowanych użytkowników": "Page available only to logged in users",
        "Strona główna": "Home",
        "Strona lekcji opublikowana": "Lesson page published",
        "Strona lekcji SCORM opublikowana": "SCORM lesson page published",
        "Strona logowania": "Login page",
        "Strona nadrzędna": "Parent page",
        "Strona opublikowana": "Published page",
        "Strona szkolenia ukryta": "Course page hidden",
        "Strona testu opublikowana": "Test page published",
        "Strona ukryta": "Hidden page",
        "Strona z błędem 404": "404 error page",
        "Strona z modułu konto użytkownika": "Page from the user account module",
        "Strona z modułu wyszukiwarki": "Page from the search engine module",
        "Strona została dodana.": "The page has been added.",
        "Strona została usunięta.": "The page has been deleted.",
        "Strona została zaktualizowana.": "The page has been updated.",
        "Strona została zarchiwizowana.": "The page has been archived.",
        "Strony": "Page",
        "Struktura organizacyjna": "Organizational structure",
        "Struktura serwisu": "Site structure",
        "Struktura szkolenia": "Training structure",
        "Studio": "Studio",
        "Stwierdzenia": "Statement",
        "Stwierdzenie": "Statement",
        "styczeń": "January",
        "Styczeń": "January",
        "styczniu": "January",
        "Styl": "Style",
        "Styl obrazu": "Image style",
        "Subskrypcja": "Subscription",
        "Subskrypcja aktywna": "Active subscription",
        "Subskrypcje": "Subscriptions",
        "Sukces": "Success",
        "Suma": "Sum",
        "Suma danych wejściowych i wyjściowych podana w tokenach.": "Sum of input and output data provided in tokens.",
        "Suma tokenów": "Token sum",
        "Suma zużytych tokenów": "Total tokens used",
        "Symbol": "Symbol",
        "Symbol autora": "Author symbol",
        "Symbol jest wymagany": "Symbol is required",
        "Symbol jest zajęty": "Symbol is taken",
        "Symbol klienta": "Customer symbol",
        "Symbol lekcji": "Lesson symbol",
        "Symbol modułu": "Module symbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "A symbol can only consist of lowercase letters, numbers, and a character - ",
        "Symbol musi mieć co najmniej 3 znaki": "Symbol must be at least 3 characters",
        "Symbol musi mieć co najmniej 5 znaków": "Symbol must be at least 5 characters",
        "Symbol nie może być dłuższy niż 10 znaków": "Symbol cannot exceed 10 characters",
        "Symbol nie może być dłuższy niż 20 znaków": "Symbol cannot exceed 20 characters",
        "Symbol strony": "Page symbol",
        "Symbol strony spotkania": "Meeting page symbol",
        "Symbol strony szkolenia": "Course page symbol",
        "Symbol testu": "Test symbol",
        "Symbol w adresie URL": "Symbol in URL",
        "Symbol waluty został zaktualizowany.": "Currency symbol has been updated.",
        "Synchronizuj": "Sync",
        "Synonimy": "Synonyms",
        "Synonimy zostały dodane.": "Synonyms have been added.",
        "Synonimy zostały usunięte.": "Synonyms have been deleted.",
        "Synonimy zostały zaktualizowane.": "Synonyms have been updated.",
        "System": "System",
        "System powiadomień": "Notification system",
        "Szablon": "Template",
        "Szablon graficzny": "Graphic template",
        "Szablon importu": "Import template",
        "Szablon modułu": "Module template",
        "Szablon został dodany.": "The template has been added.",
        "Szablon został usunięty.": "The template has been removed.",
        "Szablon został zaktualizowany.": "The template has been updated.",
        "Szablony": "Templates",
        "Szablony powiadomień": "Notification templates",
        "Szacowana kwota:": "Estimated amount:",
        "Szary": "Grey",
        "Szczegółowość obrazu": "Image detail",
        "Szczegółowy - błedy krytyczne": "Detailed - critical errors",
        "Szczegóły": "Details",
        "Szczegóły asystenta": "Assistant details",
        "Szczegóły elementu": "Element details",
        "Szczegóły kolekcji": "Collection details",
        "Szczegóły pliku": "File details",
        "Szczegóły szkolenia": "Training details",
        "Szczegóły zadania": "Task details",
        "Szczegóły zapytania": "Query details",
        "Szczegóły zdarzenia": "Event details",
        "Szczegóły zdarzenia nr %0": "Details of event number %0",
        "Szerokość": "Width",
        "Szerokość [%": "Width [%",
        "Szerokość geograficzna": "Latitude",
        "Szkic": "Draft",
        "szkolenia": "courses",
        "Szkolenia": "Courses",
        "szkolenie": "course",
        "Szkolenie": "Course",
        "Szkolenie cykliczne": "Cyclic training",
        "Szkolenie jest puste": "Course is empty",
        "Szkolenie może występować tylko w jednej ścieżce. To szkolenie zostało już dodane do ścieżki: {0}": "The course can only occur in one path. This course has already been added to the path: {0}",
        "Szkolenie powinno zawierać 1 temat, 2 lekcje, a w każdej lekcji po 3 slajdy. Po każdej lekcji powinien być test składający się z 2 pytań jednokrotnego wyboru.": "Training should include 1 topic, 2 lessons, and 3 slides per lesson. After each lesson, there should be a test consisting of 2 single-choice questions.",
        "Szkolenie w liczbach": "Training in numbers",
        "Szkolenie zostało dodane.": "Course has been added.",
        "Szkolenie zostało przywrócone.": "Course has been restored.",
        "Szkolenie zostało skopiowane": "Course has been copied",
        "Szkolenie zostało wygenerowane": "Training has been generated",
        "Szkolenie zostało zaktualizowane.": "The course has been updated.",
        "Szkolenie zostało zaliczone. Nie można go edytować.": "Training has been completed. It cannot be edited.",
        "Szkolenie zostało zarchiwizowane.": "Course has been archived.",
        "Szkolenie zostało zarchiwizowane. Aby je wyświetlić, należy przywrócić szkolenie z archiwum.": "The course has been archived. In order to view it, you must restore the course from the archive.",
        "Szkoleniowe": "Training-related",
        "szkoleń": "courses",
        "Szkoleń": "Courses",
        "Sztuczna inteligencja": "Artificial intelligence",
        "Szukaj": "Search",
        "Szukaj we wszystkich wersjach": "Search in all versions",
        "Szukana fraza": "Search term",
        "Szukane słowo": "Search term",
        "Ścieżka": "Path",
        "Ścieżka aktywnej strony": "Path of the active page",
        "Ścieżka cykliczna": "Cyclic path",
        "Ścieżka już jest opublikowana.": "The path is already published.",
        "Ścieżka nawigacyjna": "Navigation path",
        "Ścieżka szkoleniowa": "Learning path",
        "Ścieżka szkoleniowa została dodana.": "The learning path has been added.",
        "Ścieżka szkoleniowa została usunięta.": "The learning path has been removed.",
        "Ścieżka szkoleniowa została zaktualizowana.": "The learning path has been updated.",
        "Ścieżka/strona:": "Path/Page:",
        "Średni": "Average",
        "Średni tekst": "Average text",
        "Średnia": "Average",
        "Środa": "Wednesday",
        "Środek": "Center",
        "Środowisko": "Environment",
        "Ta aranżacja zostanie użyta jeśli nie przypisano żadnej innej aranżacji do strony.": "This arrangement will be used if no other arrangement is assigned to the page.",
        "Ta opcja dodaje użytkownika do wszystkich zespołów z zaznaczoną opcją Lidera i pozwala koordynatorowi widzieć wszystko w profilu koordynatora. Również do nowo utworzonych zespołów będzie  on ustawiał się jako Lider.": "This option adds the user to all teams with the Leader option selected and allows the coordinator to see everything in the coordinator's profile. For newly created teams, they will also be set as Leader.",
        "Ta opcja służy do włączenia lub wyłączenia dziedziczenia w danym polu": "This option enables or disables inheritance in the given field",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "This page is protected by reCAPTCHA and Google.",
        "Tabela": "Table",
        "Tagi": "Tags",
        "tak": "yes",
        "Tak": "Yes",
        "Tak/Nie": "Yes/No",
        "Tekst": "Text",
        "Tekst alternatywny": "Alt text",
        "Tekst do uzupełnienia": "Text to be completed",
        "Tekst lokalizowany": "Localized text",
        "Tekst zastępczy": "Alternative text",
        "Tekstowy / HTML / JS": "Text / HTML / JS",
        "Telefon": "Phone",
        "Temat": "Topic",
        "Tematy": "Topics",
        "Ten dashboard nie zawiera jeszcze żadnych widgetów": "This dashboard does not yet contain any widgets",
        "Ten dashboard nie zawiera żadnych widgetów": "This dashboard contains no widgets",
        "Ten element nie zawiera menu kontekstowego.": "This item does not contain a context menu.",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "This channel provides a possibility to send formatted text.",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "This channel does not provide a possibility to send formatted text.",
        "Ten zespół nie posiada jeszcze żadnych powiązanych wydziałów": "This team does not yet have any related departments",
        "Tenant ID": "Tenant ID",
        "Teraz": "Now",
        "Termin cykliczny": "Recurring term",
        "Termin jednorazowy": "One-time term",
        "Termin posiada test": "Date includes test",
        "Termin spotkania: ": "Meeting date: ",
        "Termin został dodany.": "Date has been added.",
        "Termin został usunięty.": "Date has been deleted.",
        "Termin został zaktualizowany.": "Date has been updated.",
        "Terminy": "Terms",
        "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "You won't be able to add terms to the dictionary until you save the data source.",
        "Test": "Test",
        "Test konfiguracji": "Configuration test",
        "Test nie może zawierać materiałów opisowych i materiałów video": "Test cannot include descriptive materials and video materials",
        "Test ukryty": "Hidden test",
        "Test ustawień": "Settings test",
        "Test ustawień pomyślnie zakończony.": "Settings test successfully completed.",
        "Test został dodany.": "The test has been added.",
        "Test został zaktualizowany.": "The test has been updated.",
        "Testowe": "Test",
        "Testowy adres email": "Tested email address",
        "Testowy numer telefonu": "Test phone number",
        "Testuj": "Test",
        "Testuj zapytanie": "Test query",
        "Testy": "Tests",
        "Tło": "Background",
        "Tło aktywnej zakładki": "Active tab background",
        "Tło certyfikatu": "Certificate background",
        "Tło przycisku": "Button background",
        "Tło strona 2": "Background page 2",
        "Tłumaczenia": "Translations",
        "To pole jest wymagane": "This field is required",
        "To szkolenie znajduje się już w ścieżce szkoleń": "This course is already in the course path",
        "Token": "Token",
        "Token został usunięty.": "Token has been removed.",
        "Tokeny": "Tokens",
        "Tokeny dostępu": "Access tokens",
        "Tokeny wejściowe": "Input tokens",
        "Tokeny wyjściowe": "Output tokens",
        "Top temat został dodany.": "Top topic has been added.",
        "Top temat został usunięty.": "Top topic has been deleted.",
        "Top temat został zaktualizowany.": "Top topic has been updated.",
        "Top tematy": "Top topics",
        "Trace - najwięcej szczegółów": "Trace - most details",
        "Tracing": "Tracing",
        "Treści odpowiedzi są wymagane": "Answers are required",
        "Treści pytań są wymagane": "Questions are required",
        "Treść": "Content",
        "Treść certyfikatu": "Certificate content",
        "Treść instrukcji": "Instruction content",
        "Treść komentarza": "Comment content",
        "Treść nie może być pusta.": "Content cannot be empty.",
        "Treść przycisku": "Button content",
        "Trigger": "Trigger",
        "True": "True",
        "Trwa generowanie formularza": "Form generation in progress",
        "Trwa generowanie obrazów": "Generating images",
        "Trwa generowanie opisu dla wybranego obrazu": "Generating description for the selected image",
        "Trwa generowanie planu szkolenia, może to potrwać kilka minut.": "Generating training plan, this may take a few minutes.",
        "Tryb konserwacji systemu": "System maintenancemMode",
        "Tryb monitorowania aktywności": "Activity monitoring mode",
        "Tryb monitorowania aktywności włączony.": "Activity monitoring mode enabled.",
        "Tryb monitorowania aktywności wyłączony.": "Activity monitoring mode disabled.",
        "Tryb prezentacyjny": "Presentation mode",
        "Tryb wyświetlania": "Display mode",
        "Trzy kolumny": "Three columns",
        "tutaj": "here",
        "Twoje hasło wygasło. Zmień je na nowe.": "Your password has expired. Change it to new one.",
        "Tworzenie dokumentów": "Document creation",
        "Tworzenie szkoleń w kreatorze AI": "Creating training in AI creator",
        "Twój token": "Your token",
        "tydzień": "week",
        "Tydzień": "Week",
        "tydzień (tygodnie) w następującym dniu": "week(s) on the following day",
        "Tygodniowy": "Weekly",
        "Tylko 404": "Only 404",
        "Tylko aktywne": "Only active",
        "Tylko do odczytu": "Read-only",
        "tylko dokumenty wersjonowane": "versioned documents only",
        "Tylko gdy odpowiedź serwera jest 404": "Only when server response is 404",
        "Tylko liderzy": "Only leaders",
        "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "Lowercase letters only, no special characters, numbers, and spaces.",
        "Tylko moje": "Only mine",
        "Tylko priorytetowe": "Priority only",
        "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "Development server only. Do not use in production mode. ",
        "Tylko treść": "Only content",
        "Tylko zalogowani użytkownicy mogą zgłaszać komentarze": "Only logged-in users can report comments",
        "Typ": "Type",
        "Typ agregacji": "Aggregation type",
        "Typ aranżacji": "Arrangement type",
        "Typ autora": "Author type",
        "Typ bannera": "Banner type",
        "Typ elementu": "Element type",
        "Typ konta": "Account type",
        "Typ kontentu": "Content type",
        "Typ linku": "Link type",
        "Typ logowania": "Login type",
        "Typ materiału": "Material type",
        "Typ mime": "Mime type",
        "Typ obiektu": "Object type",
        "Typ obiektu:": "Object type:",
        "Typ obiektu.": "Object type.",
        "Typ pliku": "File type",
        "Typ płatności": "Payment type",
        "Typ pola": "Field type",
        "Typ powiadomienia": "Notification type",
        "Typ rankingu": "Ranking type",
        "Typ serwera": "Server type",
        "Typ slajdu": "Slide type",
        "Typ słownika": "Dictionary type",
        "Typ spotkania": "Meeting type",
        "Typ strony": "Page type",
        "Typ właściwy": "Proper type",
        "Typ zestawu": "Set type",
        "Typ zmiennej": "Variable type",
        "Typ źródła": "Source type",
        "Typ źródła danych": "Data source type",
        "typu \"%0\" o ID \"%1\"": "type \"%0\" with ID \"%1\"",
        "Typy materiałów": "Material types",
        "Tytuł": "Title",
        "Tytuł aktywnej witryny": "Title of the active site",
        "Tytuł formularza jest wymagany": "Form title is required",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "The title of the form cannot be longer than %0 znaków",
        "Tytuł kafelka": "Tile title",
        "Tytuł okładki": "Cover title",
        "Tytuł powiadomienia": "Notification title",
        "Tytuł sekcji": "Section title",
        "Tytuł strony": "Page title",
        "Tytuł witryny": "Site title",
        "Udało się zapisać ustawienia widgetów": "Successfully saved widget settings",
        "Układ": "Arrangement",
        "Układ listy": "List layout",
        "Ukryj": "Hide",
        "Ukryj materiał": "Hide material",
        "Ukryta": "Hidden",
        "Ukryty": "Hidden",
        "Ulica": "Street",
        "Ułożenie": "Arrangement",
        "Umożliwienie sprawdzania odpowiedzi": "Enable checking of responses",
        "Uniksowy znacznik czasu utworzenia zakończenia czatu.": "Unix timestamp of the creation of the end of the chat session.",
        "Upload": "Upload",
        "Uprawnienia": "Permissions",
        "Uprawnienia do dokumentów": "Document privileges",
        "Uprawnienia do szkolenia pochodzą z terminu spotkań.": "Training privileges come from meeting dates.",
        "Uprawnienia użytkownika": "User permissions",
        "Uprawnienia zostały usunięte.": "Privileges have been deleted.",
        "Url": "Url",
        "URL": "URL",
        "Uruchom nagranie automatycznie": "Run recording automatically",
        "Uruchom zadanie": "Run the task",
        "Urządzenie zostało usunięte.": "The device has been removed.",
        "Usage": "Usage",
        "Usługi": "Services",
        "Ustaw domyślny poziom logowania. Logi poniżej tego poziomu nie bądą zbierane niezależnie od pozostałych ustawień.": "Set default logging level. Logs below this level will not be collected regardless of other settings.",
        "Ustaw filtry aby wygenerować raport": "Set filters to generate report",
        "Ustaw kategorię": "Set category",
        "Ustaw kolor po najechaniu myszką": "Set hover color",
        "Ustaw poziomy logów które będą wysyłane do poszczególnych rejestrów.": "Set log levels to be sent to specific registers.",
        "Ustaw poziomy logów które będą zbierane z poszczególnych przestrzeni nazw.": "Set log levels to be collected from specific namespaces.",
        "Ustaw również dla wszystkich podstron": "Set for all subpages as well",
        "Ustaw status": "Set status",
        "Ustaw szerokości proporcjonalnie": "Set widths proportionally",
        "Ustaw w kolejności": "Set in order",
        "Ustawienia": "Settings",
        "Ustawienia domyślne": "Default settings",
        "Ustawienia dostępności": "Accessibility settings",
        "Ustawienia Firebase": "Firebase settings",
        "Ustawienia konta": "Account settings",
        "Ustawienia lini poziomej": "Horizontal line settings",
        "Ustawienia ogólne": "General settings",
        "Ustawienia PayU": "PayU settings",
        "Ustawienia podstawowe": "Basic settings",
        "Ustawienia powiadomień zostały zaktualizowane.": "Your notification settings have been updated.",
        "Ustawienia przelewu tradycyjnego": "Traditional transfer settings",
        "Ustawienia Przelewy24": "Przelewy24 settings",
        "Ustawienia redakcji": "Editorial settings",
        "Ustawienia rotatora": "Rotator settings",
        "Ustawienia sekcji \"%0\"": "Settings of the \"%0\" section",
        "Ustawienia slajdera": "Slider settings",
        "Ustawienia strony": "Page settings",
        "Ustawienia widgetów zostały zapisane": "Widget settings have been saved",
        "ustawienia widgetu": "widget settings",
        "Ustawienia widgetu": "Widget settings",
        "Ustawienia witryny": "Site settings",
        "Ustawienia zaawansowane": "Advanced settings",
        "Ustawienia zakładek": "Tab settings",
        "Ustawienia zostały zaktualizowane.": "The settings have been updated.",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "usunął": "deleted",
        "Usunął": "Deleted",
        "Usunięcie": "Deletion",
        "Usunięcie dokumentu": "Document deletion",
        "Usunięcie formularzannOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!nnCzy na pewno chcesz usunąć wybrany formularz?": "Form deletionnnOperation is irreversible. All related documents will be lost!nnAre you sure you want to delete the selected form?",
        "Usunięcie indeksunnOperacja jest nieodwracalna. Czy na pewno chcesz usunąć wybrany indeks?": "Index deletionnnDeleting an index is irreversible. Are you sure you want to delete the selected index?",
        "Usunięcie wpisu": "Entry removal",
        "Usunięcie wybranych elementów": "Delete selected items",
        "Usunięte": "Deleted",
        "Usunięto wątek.": "Thread has been deleted.",
        "Usunięto wybraną wersję aranżacji.": "Selected arrangement version has been deleted.",
        "usunięty": "deleted",
        "Usuń": "Delete",
        "Usuń artykuł z listy": "Delete article from list",
        "Usuń autora": "Delete author",
        "Usuń blok z sekcji": "Delete a block from a section",
        "Usuń datę": "Delete date",
        "Usuń dział": "Delete department",
        "Usuń element": "Delete item",
        "Usuń filtr": "Delete filter",
        "Usuń grupę": "Delete group",
        "Usuń indeks": "Delete index",
        "Usuń kafelek": "Delete tile",
        "Usuń katalog": "Delete directory",
        "Usuń kategorię": "Delete category",
        "Usuń kolor": "Remove color",
        "Usuń logi gdy wykonywanie scenariusza": "Remove logs when executing scenario",
        "Usuń nie zapisany materiał z lekcji": "Delete unsaved material from the lesson",
        "Usuń nie zapisany materiał z testu": "Delete unsaved material from the test",
        "Usuń obrazek": "Delete image",
        "Usuń odpowiedź": "Delete answer",
        "Usuń opinię": "Delete opinion",
        "Usuń parametr": "Remove parameter",
        "Usuń plik": "Delete file",
        "Usuń plik z listy": "Remove the file from the list",
        "Usuń poprzednie wersje certyfikatu": "Delete previous versions of the certificate",
        "Usuń powiązanie": "Unlink",
        "Usuń powód": "Delete reason",
        "Usuń pozycję": "Delete item",
        "Usuń produkt": "Remove product",
        "Usuń publikację": "Delete a publication",
        "Usuń punkt": "Remove point",
        "Usuń pytanie": "Delete question",
        "Usuń regulamin": "Delete regulations",
        "Usuń sekcję": "Delete section",
        "Usuń slajd": "Delete slide",
        "Usuń słowo": "Delete word",
        "Usuń spacje": "Delete spaces",
        "Usuń stronę": "Delete page",
        "Usuń szkolenie z ścieżki szkoleń": "Delete course from the course path",
        "Usuń tag": "Delete tag",
        "Usuń urządzenie": "Delete device",
        "Usuń urządzenie aby odwołać zapamiętane automatyczne logowanie na swoje konto": "Delete a device to cancel automatic sign-in to your account",
        "Usuń wątek": "Delete thread",
        "Usuń wiersz": "Delete row",
        "Usuń wybraną wersję aranżacji": "Delete selected arrangement version",
        "Usuń wydarzenie": "Remove event",
        "Usuń z terminu": "Delete from date",
        "Usuń z zespołu": "Remove from team",
        "Usuń ze szkolenia": "Remove from the course",
        "Usuń zestaw": "Delete set",
        "Usuń${selected.length > 1 ? ' zaznaczone' : ''}": "Delete${selected.length > 1 ? ' selected' : ''}",
        "Usuwanie dokumentów": "Document deletion",
        "Usuwanie użytkowników": "User deletion",
        "Usuwanie własnych dokumentów": "Deleting own documents",
        "Usuwanie wszystkich dokumentów": "Deleting all documents",
        "Utworzenie wpisu": "Entry creation",
        "Utworzono wątek.": "Thread has been created.",
        "Utworzył": "Author",
        "Utwórz formularz": "Create form",
        "Utwórz grupy": "Create groups",
        "Utwórz katalog": "Create a directory",
        "Utwórz kopię formularza": "Create form copy",
        "Utwórz kopię z": "Create copy from",
        "Utwórz nowy": "Create new",
        "Utwórz nowy wątek": "Create new thread",
        "Utwórz scenariusz": "Create scenario",
        "Utwórz wątek": "Create thread",
        "UWAGA: Brak obsługi TypeScript oraz w kodzie metody nie można robić importów.": "WARNING: No TypeScript support and imports cannot be made in the method code.",
        "Uwzględnij wydziały podrzędne": "Include sub-departments",
        "Uzupełnij dane dotyczące szkolenia": "Fill in the course data",
        "Uzupełnij luki": "Fill in the gaps",
        "Uzupełnij wymagane pola.": "Fill in the required fields.",
        "Użyj domyślnego zapytania SQL": "Use default SQL query",
        "Użyte narzędzie": "Used tool",
        "Użytkownicy": "Users",
        "Użytkownicy mogą zgłaszać komentarze do moderacji": "Users can submit comments for moderation",
        "Użytkownicy w tej roli": "Users in this role",
        "Użytkownik": "User",
        "Użytkownik \"%0\" %1 obiekt %2": "User \"%0\" %1 object %2",
        "Użytkownik i jego wiadomości zostały przywrócone.": "The user and their messages have been restored.",
        "Użytkownik jest liderem zespołu": "User is a team leader",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "User will not receive any notifications.",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "The user cannot log in until the account is active.",
        "Użytkownik nie należy do żadnego zespołu.": "User does not belong to any team.",
        "Użytkownik posiada pełne uprawnienia": "The user has full permissions",
        "Użytkownik usunięty z zespołu": "User removed from team",
        "Użytkownik z bazy": "User from database",
        "Użytkownik z zespołu zostali dodani.": "User from team has been added.",
        "Użytkownik zalogowany": "Logged in user",
        "Użytkownik został dodany do zespołu.": "The user has been added to the team.",
        "Użytkownik został dodany.": "The user has been added.",
        "Użytkownik został przypisany do szkolenia.": "The user has been assigned to the course.",
        "Użytkownik został przypisany do ścieżki szkoleniowej.": "The user has been assigned to a learning path.",
        "Użytkownik został przypisany do terminu.": "User has been assigned to the date.",
        "Użytkownik został usunięty.": "User has been deleted.",
        "Użytkownik został wylogowany.": "The user has been logged out.",
        "Użytkownik został zablokowany, a jego wiadomośći ukryte.": "The user has been blocked and their messages have been hidden.",
        "Użytkownik został zaktualizowany.": "The user has been updated.",
        "Użytkownik został zanonimizowany.": "User has been anonymized.",
        "Użytkownikcy z bazy": "Users from database",
        "Użytkowników": "Users",
        "Użyty Model": "Used Model",
        "Video": "Video",
        "W ciągu ostatniego tygodnia nie dodano nowych użytkowników": "No new users were added in the last week",
        "W ciele metody walidującej dostępne są poniższe zmienne:": "The following variables are available in the validation method body:",
        "W każdy dzień tygodnia": "Every day of the week",
        "W następującym dniu:": "On the following day:",
        "W organizacji nie ma jeszcze żadnych działów.": "There are no sections in the organization yet.",
        "W przypadku braku wartości zostanie wyświetlona nazwa strony.": "If no value is provided, the page name will be displayed.",
        "W przyszłości": "In the future",
        "W trakcie": "In progress",
        "W trakcie weryfikacji": "Under verification",
        "w tym ": "including ",
        "W tym katalogu nie ma jeszcze żadnych stron.": "There are no pages in this directory yet.",
        "W zespole od %0": "In the team from %0",
        "W zespole od %0 do %1": "In the team from %0 to %1",
        "Walidacja": "Validation",
        "Walidacja certyfikatu SSL": "SSL certificate validation",
        "Walidacja danych": "Data validation",
        "Walidacja po stronie API": "API-side validation",
        "Walidacja typów MIME": "MIME type validation",
        "Waluta": "Currency",
        "Warn - ostrzeżenia": "Warn - warnings",
        "Warto stosować przejrzystą hierarchię elementów, ułatwiającą AI interpretację i generowanie treści.": "It is worth using a clear hierarchy of elements to facilitate AI interpretation and content generation.",
        "Wartości od 0 - 1.0 (0 oznacza 0%, a 1 oznacza 100%)": "Values from 0 - 1.0 (0 means 0%, and 1 means 100%)",
        "Wartość": "Value",
        "Wartość 0 oznacza brak limitu": "A value of 0 indicates no limit",
        "Wartość brutto": "Gross value",
        "Wartość domyślna": "Default value",
        "Wartość domyślna oznacza, że użytkownik może zaliczyć element od razu po odtworzeniu zasobu": "Default value means the user can complete the element immediately after playing the resource",
        "Wartość domyślna: (&(objectClass=organizationalUnit))": "Default value: (&(objectClass=organizationalUnit))",
        "Wartość domyślna: (&(objectClass=user)": "Default value: (&(objectClass=user)",
        "Wartość musi być liczbą całkowitą": "The value must be an integer",
        "Wartość musi być liczbą dodatnią": "The value must be a positive number",
        "Wartość musi być liczbą ujemną": "The value must be a negative number",
        "Wartość netto": "Net value",
        "Wartość nie może byc mniejsza niż 0": "Value cannot be less than 0",
        "Wartość tekstowa": "Text value",
        "Wartość zamówienia (brutto)": "Order value (gross)",
        "Wartość zamówienia (netto)": "Order value (net)",
        "Wartość zmiennej": "Variable value",
        "Warunek": "Condition",
        "Warunek nie zostanie spełniony": "Condition will not be met",
        "Warunek zostanie spełniony": "Condition will be met",
        "Warunki korzystania z usług Google": "Google Terms of Service",
        "Warunki logiczne": "Logical conditions",
        "Warunkowo": "Conditionally",
        "Ważne informacje": "Important information",
        "Ważność": "Validity",
        "Wątek": "Thread",
        "Wątek główny": "Main thread",
        "Wątek główny jest kontynuowany automatycznie przez asystenta.": "Main thread is automatically continued by the assistant.",
        "Wątek nie zawiera jeszcze żadnych wiadomości": "Thread does not yet contain any messages",
        "Wątki wiadomości": "Message threads",
        "Wczytywanie danych...": "Loading data...",
        "Webhook": "Webhook",
        "Webhook został dodany.": "Webhook has been added.",
        "Webhook został usunięty.": "Webhook has been deleted.",
        "Webhook został zaktualizowany.": "Webhook has been updated.",
        "Webhooki": "Webhooks",
        "Webinar": "Webinar",
        "Weekend": "Weekend",
        "Wersja API": "API version",
        "Wersja językowa": "Language version",
        "Wersja modelu": "Model version",
        "Wersja modelu GPT.": "GPT model version.",
        "Wersja nieopublikowana": "Unpublished version",
        "Wersja opublikowana": "Published version",
        "Wersja utowrzona przez": "Version created by",
        "Wersje": "Versions",
        "Wersje aranżacji": "Arrangement versions",
        "Wersje dokumentu": "Document versions",
        "wersji zaakceptowanej": "accepted version",
        "Wersjonowany": "Versioned",
        "Wewnętrznie": "Internally",
        "Wiadomości": "Messages",
        "Wiadomość": "Message",
        "Wiadomość testowa została wysłana.": "A test message has been sent.",
        "Wiadomość została przywrócona.": "The message has been restored.",
        "Wiadomość została ukryta.": "The message has been hidden.",
        "Wideo": "Video",
        "Wideo nie jest jeszcze nigdzie opublikowane.": "Video is not yet published anywhere.",
        "Wideo nie ma ustawionej daty publikacji.": "Video does not have a set publication date.",
        "Wideo premium": "Premium video",
        "Wideo z biblioteki": "Video from library",
        "Wideo zewnętrzne (URL)": "External video (URL)",
        "Wideo zostało dodane.": "Video has been added.",
        "Wideo zostało usunięte.": "Video has been deleted.",
        "Wideo zostało zaktualizowane.": "Video has been updated.",
        "Widgety": "Widgets",
        "Widoczna dla wszystkich użytkowników": "Visible to all users",
        "Widoczność": "Visibility",
        "Widoczność konta": "Account visibility",
        "Widoczność modułu w menu": "Module visibility in menu",
        "Widoczność sekcji w menu modułu": "Section visibility in module menu",
        "Widoczny obszar": "Visible area",
        "Widok czołówki - zdjęcie z tytułem": "Front view - photo with title",
        "Wielkość kroku": "Step size",
        "Wielokrotnego wyboru": "Multiple choice",
        "Wielokrotny wybór": "Multiple choice",
        "Wiersz": "Row",
        "Wiersz ${error.actualRow}: błąd w kolumnie ${error.columnName} - ${error.error}": "Row ${error.actualRow}: error in column ${error.columnName} - ${error.error}",
        "Więcej": "More",
        "więcej...": "more...",
        "Więcej...": "More…",
        "Witryna": "Website",
        "Witryna / Wersja językowa": "Website / Language version",
        "Witryna aktywna": "Active site",
        "Witryna domyślna": "Default site",
        "Witryna i język": "Site and language",
        "Witryna internetowa": "Website",
        "Witryna tylko dla zalogowanych użytkowników": "Site for logged-in users only",
        "Witryna została dodana.": "The site has been added.",
        "Witryna została usunięta.": "The site has been removed.",
        "Witryna została zaktualizowana.": "The site has been updated.",
        "Witryny": "Sites",
        "Wklej komponent": "Paste component",
        "Właściwości": "Characteristics",
        "Właściwości szablonu": "Template properties",
        "Właściwość '%0' aktywnego wpisu": "Property '%0' of active entry",
        "Włącz": "Enable",
        "Włącz ankietę": "Enable survey",
        "Włącz anonimizację": "Enable anonymization",
        "Włącz chat": "Enable chat",
        "Włącz formularz kontaktowy": "Enable contact form",
        "Włącz monitorowanie aktywności": "Turn on activity monitoring",
        "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "Enable at least one language version for your site to start managing your pages.",
        "Włącz przyznawanie punktów": "Enable point allocation",
        "Włącz social media": "Enable social media",
        "Włącz system komentarzy": "Enable the comment system",
        "Włącz walidację po stronie API": "Enable API-side validation",
        "Włącza bardzo restrykcyjne sprawdzanie typów MIME dla wysyłanych plików. W przypadku zgłaszania błędów dla plików, których zawartości jesteśmy pewni, należy tą opcję pozostawić nieaktywną.": "Enables very strict MIME type checking for uploaded files. If errors are reported for files whose content is certain, this option should remain inactive.",
        "Włączenie cykliczności spowoduje usunięcie dat dostępu dla użytkowników i zespołów": "Enabling cyclicity will remove access dates for users and teams",
        "Włączenie generowania pliku sitemap.xml dla całej witryny": "Enable sitemap.xml file generation for the website",
        "Włączenie moderacji danych wejściowych jest zalecane.": "Enabling input data moderation is recommended.",
        "Włączenie obsługi cacheu dla witryny": "Enable cache support for the website",
        "Włączenie protokołu SSL dla tej witryny": "Enable SSL for this site",
        "Włączona": "Enabled",
        "Włączone": "Enabled",
        "Włączone (Follow)": "Enabled (Follow)",
        "Włączone (Index)": "Enabled (Index)",
        "Włączony": "Enabled",
        "Województwo": "Province",
        "Wpis do kalendarza został usunięty.": "Calendar entry has been deleted.",
        "Wpis domyślny": "Default entry",
        "Wpis został dodany.": "The post has been added.",
        "Wpis został usunięty": "Entry has been deleted",
        "Wpis został usunięty.": "The post has been deleted.",
        "Wpis został zaakceptowany.": "The post has been accepted.",
        "Wpis został zaktualizowany.": "The post has been updated.",
        "Wpisz adresy po przecinku.": "Enter addresses separated by commas.",
        "Wpisz wiadomość": "Enter message",
        "Wprowadzamy URL do seriwsów które chemy wykluczyć. Dane mogą być odzielone przecinkiem lub być w nowej linii": "Enter URLs of services you want to exclude. Data can be separated by commas or be on a new line",
        "Wprowadzenie zmian w polu \"Wybierz paczkę SCORM\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "If you change the 'Select SCORM package' field, the existing version of the course component cannot be overwritten.",
        "Wprowadzenie zmian w polu \"Źródło\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "If you change the 'Source' field, the existing version of the course component cannot be overwritten.",
        "Wprowadzenie zmian w zakładce \"ZAWARTOŚĆ\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "If you make changes in the \"CONTENT\" field, the existing version of the course component cannot be overwritten.",
        "Wprowadzenie zmiany linku powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "Changing the link causes overwriting the previous version of the training element to be unavailable.",
        "Wprowadzona wartość jest nieprawidłowa": "The value you entered is invalid",
        "Wprowadzona wartość jest za długa": "The value you entered is too long",
        "Wprowadzona wartość jest za krótka": "The value you entered is too short",
        "Wprowadzona wartość jest za niska": "The value you entered is too low",
        "Wprowadzona wartość jest za wysoka": "The value you entered is too high",
        "Wprowadzona wartość nie jest poprawna": "The value you entered is not valid",
        "Wróć do logowania": "Back to login",
        "Wróć do strony głównej": "Back to Home Page",
        "wrzesień": "September",
        "Wrzesień": "September",
        "wrześniu": "September",
        "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "It indicates to search engine robots whether to index the page.",
        "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "It indicates to search engine robots whether to follow the links.",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "Indicates how long the response remains valid in the Redis server memory.",
        "Wstaw cztery kolumny 1/4": "Insert four columns 1/4",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "Insert two columns 1/3 and 2/3",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "Insert two columns 2/3 and 1/3",
        "Wstaw dwie równe kolumny": "Insert two equal columns",
        "Wstaw kontrolkę": "Insert control",
        "Wstaw stronę": "Insert page",
        "Wstaw szablon informacyjny ze zdjęciem": "Insert information template with photo",
        "Wstaw trzy kolumny 1/3": "Insert three columns 1/3",
        "Wstaw z dołu": "Insert from below",
        "Wstaw z góry": "Insert from above",
        "Wstaw z lewej strony": "Insert left",
        "Wstaw z prawej strony": "Insert right",
        "Wstecz": "Back",
        "Wstęp": "Introduction",
        "Wstępne filtrowanie danych": "Initial data filtering",
        "Wszyscy użytkownicy": "All users",
        "Wszystkie": "All",
        "Wszystkie dane osobowe użytkownika znajdujące się w systemie zostaną usunięte!nnCzy na pewno chcesz wykonać akcję??": "All user personal data in the system will be deleted!nnAre you sure you want to proceed??",
        "Wszystkie kategorie": "All categories",
        "Wszystkie typy": "All types",
        "Wszystko": "All",
        "Wtorek": "Tuesday",
        "Wybieranie katalogu jest wymagane": "Selecting a directory is required",
        "wybierz": "select",
        "Wybierz": "Select",
        "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "Select a canonical address from the list or enter it manually.",
        "Wybierz aktywność": "Select activity",
        "Wybierz ankietę": "Select survey",
        "Wybierz ankietę do wypełnienia po szkoleniu": "Select a survey to be completed after the course",
        "Wybierz ankietę do wypełnienia przed szkoleniem": "Select a survey to be completed before the course",
        "Wybierz artykuł": "Select article",
        "wybierz asystenta": "select assistant",
        "Wybierz autora": "Select author",
        "Wybierz blok": "Select block",
        "Wybierz certyfikat": "Select a certificate",
        "Wybierz czołówkę": "Select front view",
        "Wybierz datę": "Select date",
        "Wybierz datę lub wprowadź wartość tekstową": "Select date or enter text value",
        "wybierz długość": "select length",
        "Wybierz długość generowanej treści.": "Select the length of the content to be generated.",
        "Wybierz domyślną kategorię": "Select default category",
        "Wybierz dostępne pliki": "Select available files",
        "Wybierz element": "Select element",
        "Wybierz etykiety produktów": "Select product labels",
        "Wybierz formularz": "Select form",
        "Wybierz formularz zawierający dodatkowe pola dla kont użytkownków": "Select a form with additional user account fields",
        "Wybierz galerię": "Select gallery",
        "Wybierz głównego asystena dla panelu administracyjnego.": "Select main assistant for the admin panel.",
        "Wybierz istniejącego użytkownika": "Select existing user",
        "wybierz katalog": "select directory",
        "Wybierz katalog": "Select a catalog",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "Select the directory to which you want to move the selected components.",
        "Wybierz kategorię": "Select a category",
        "Wybierz kategorię subskrypcji": "Select subscription category",
        "Wybierz link z serwisu": "Select link from service",
        "Wybierz listę regulaminów": "Select list of regulations",
        "wybierz model": "select model",
        "Wybierz nowe pliki z komputera": "Select new files from computer",
        "Wybierz opcję": "Select option",
        "Wybierz paczkę": "Select a package",
        "Wybierz paczkę SCORM": "Select the SCORM package",
        "Wybierz plik": "Select file",
        "Wybierz plik lub katalog": "Select file or directory",
        "Wybierz plik.": "Select file.",
        "Wybierz pliki": "Select files",
        "Wybierz pliki (do {0})": "Select files (to {0})",
        "Wybierz produkt": "Select product",
        "Wybierz przełożonego": "Select supervisor",
        "Wybierz regulamin": "Select regulations",
        "Wybierz rok: ": "Select year: ",
        "Wybierz rozmiar": "Select size",
        "Wybierz sekcję": "Select section",
        "Wybierz serwer": "Select server",
        "Wybierz shortcode": "Select shortcode",
        "Wybierz stronę": "Select page",
        "Wybierz strony": "Select pages",
        "wybierz szablon": "select template",
        "Wybierz szkolenie": "Select course",
        "Wybierz szkolenie ze ścieżki szkoleniowej": "Select training from the training path",
        "Wybierz temat": "Select topic",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Select the notification type to see the available keys.",
        "Wybierz typy pytań z jakich będą tworzone testy": "Select question types for creating tests",
        "Wybierz użytkownika": "Select user",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "Select the users for whom you want to perform actions",
        "Wybierz wątek w którym chcesz prowadzić konwersację.": "Select thread where you want to conduct conversation.",
        "wybierz wersję": "select version",
        "Wybierz wersję": "Select version",
        "Wybierz wideo": "Select video",
        "Wybierz wydarzenie": "Select event",
        "Wybierz wydział": "Select department",
        "Wybierz z listy": "Select from list",
        "Wybierz zaznaczone": "Choose selected",
        "wybierz...": "select...",
        "Wybierz...": "Select...",
        "Wybór": "Choice",
        "Wybór języka": "Select language",
        "Wybór kategorii": "Category selection",
        "Wybór kategorii wydarzeń": "Event category selection",
        "Wybór listy stron": "Selection of the list of pages",
        "Wybór możliwy po zapisaniu zmian w teście.": "Selection possible after saving changes in test.",
        "Wybór strony": "Page selection",
        "Wybór strony przekierowującej": "Redirecting page selection",
        "Wybór+": "Selection+",
        "Wybrana data jest mniejsza niż dozwolona %0.": "Selected date is before the permitted one %0.",
        "Wybrana data jest większa niż dozwolona %0.": "Selected date is above the permitted one %0.",
        "Wybrana ikona powinna być kwadratem": "The selected icon should be a square",
        "Wybrana ikona powinna być kwadratem.": "Selected icon should be a square.",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "Selected number is lesser than allowed %0.",
        "Wybrana liczba jest większa niż dozwolona %0.": "Selected number is greater then allowed %0.",
        "Wybrana wersja slajdu została wygenerowana w nieprawidłowym formacie. Nie można jej wyświetlić.": "The selected version of the slide was created in an invalid format. It can not be displayed.",
        "Wybrane": "Selected",
        "Wybrane dokumenty": "Selected documents",
        "Wybrane elementy zostały przeniesione.": "The selected items have been moved.",
        "Wybrane elementy zostały usunięte.": "The selected items have been removed.",
        "wybrane elementy?": "selected items?",
        "Wybrane kategorie": "Selected categories",
        "Wybrane pliki": "Selected files",
        "Wybrane pliki: {0}": "Selected files: {0}",
        "Wybrane regulaminy:": "Selected regulations:",
        "Wybrane spotkanie nie jest opublikowane": "Selected meeting is not published",
        "Wybrane szkolenie nie jest opublikowane": "Selected training is not published",
        "Wybrane wydarzenie nie jest opublikowane": "Selected event is not published",
        "Wybrane wydarzenie nie ma włączonej opcji \"Wydarzenie dostępne tylko w module spotkań\"": "Selected event does not have the option \"Event available only in the meeting module\" enabled",
        "Wybrane: %0": "Selected: %0",
        "wybranego elementu": "selected item",
        "Wybranie ankiety jest wymagane": "Selecting a survey is required",
        "Wybranie ikony jest wymagane.": "Selecting an icon is required.",
        "Wybranie katalogu jest wymagane": "Selecting a directory is required",
        "Wybranie statusu jest wymagane.": "Selecting status is required.",
        "Wybranie strony jest wymagane": "Selecting a page is required",
        "Wybrano": "Selected",
        "Wybrano %0 użytkowników.": "%0 users have been selected.",
        "Wybrano dostawcę Azure AI.": "Azure AI provider selected.",
        "Wybrano dostawcę Azure OpenAI.": "Azure OpenAI provider selected.",
        "Wybrano dostawcę OpenAI.": "OpenAI provider selected.",
        "Wybrano jednego użytkownika.": "One user has been selected.",
        "Wybrany certyfikat jest już nieaktualny.": "The selected certificate is no longer valid.",
        "Wybrany element został usunięty.": "Selected item has been deleted.",
        "wybrany element?": "selected item?",
        "Wybrany materiał został już dodany do lekcji": "The selected material has already been added to the lesson",
        "Wybrany materiał został już dodany do testu": "Selected material has already been added to the test",
        "Wybrany szablon": "Selected template",
        "Wybrany wydział został już dodany do zespołu.": "Selected department has already been added to the team.",
        "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "The selected character will replace the separator marker | inserted in the title.",
        "wybranych elementów": "selected items",
        "Wybróbuj możliwości AI": "Try AI capabilities",
        "Wyczyszczenie pamięci podręcznej może spowodować usunięcie niezapisanych postępów czasu spędzonego na platformie.": "Clearing the cache may delete unsaved progress of time spent on the platform.",
        "Wyczyść": "Clear",
        "Wyczyść aranżację": "Clear arrangement",
        "Wyczyść pamięć podręczną": "Clear cache",
        "Wyczyść wybór": "Clear selection",
        "Wydarzenie dostępne tylko w module spotkań": "Event available only in the meeting module",
        "Wydarzenie z kalendarza": "Event from calendar",
        "Wydział": "Department",
        "Wydziały": "Departments",
        "Wygenerowana odpowiedź przez model AI.": "Generated response by AI model.",
        "Wygenerowane obrazy": "Generated images",
        "Wygenerowane szkolenie znajdziesz ": "Generated training can be found ",
        "Wygeneruj metadane dla przesyłanych obrazów": "Generate metadata for uploaded images",
        "Wygląd": "Appearance",
        "Wyklucz logowanie zależności": "Exclude dependency logging",
        "Wykonaj": "Do",
        "Wykonawca": "Author",
        "Wykonuje się": "Executing",
        "Wykorzystane": "Used",
        "Wykresy": "Charts",
        "Wyloguj się": "Log out",
        "Wyloguj zalogowanego obecnie użytkownika": "Log off the currently logged in user",
        "Wyłaczone": "Disabled",
        "Wyłącz komentarze": "Disable comments",
        "Wyłącz udostępnij dalej": "Disable share further",
        "Wyłączone (NoFollow)": "Off (NoFollow)",
        "Wyłączone (NoIndex)": "Disabled (NoIndex)",
        "Wyłączone komentarze": "Comments disabled",
        "Wyłączone udostępnianie": "Sharing disabled",
        "Wyłączone wysyłanie powiadomień": "Disabled notification sending",
        "Wyłączony": "Disabled",
        "Wymaga autoryzacji": "Requires authorization",
        "Wymaga potwierdzenia": "Requires confirmation",
        "Wymagaj kolejności zaliczania elementów": "Require element passing order",
        "Wymagaj odpowiedzi, aby przejść dalej": "Require a response to move on",
        "Wymagaj pełnego odsłuchania do zaliczenia": "Require full listening to pass",
        "Wymagaj pełnego odsłuchania/obejrzenia do zaliczenia": "Require full listening/viewing for completion",
        "Wymagaj ponownej akceptacji po zmianach": "Require re-approval after changes",
        "Wymagaj znaków specjalnych w hasłach": "Require special characters in passwords",
        "Wymagane": "Required",
        "Wymagane jest ustawienie minimalnej długości hasła": "Minimum password length is required",
        "Wymagane jest wybranie formularza": "Form must be selected",
        "Wymagane jest wybranie kategorii": "Category must be selected",
        "Wymagane jest wybranie komponentu": "Component selection is required",
        "Wymagane jest wybranie modułu": "Module selection is required",
        "Wymagane jest wybranie sekcji": "A section must be selected",
        "Wymagane jest wybranie wersji językowej": "Language version selection is required",
        "Wymagane jest wybranie witryny": "Site selection is required",
        "Wymagane jest wybranie zestawu regulaminów": "Regulation set selection is required",
        "Wymagane jest wybranie źródła": "Source selection is required",
        "Wymagane jest wybranie źródła danych": "Data source is required",
        "Wymagane znaki": "Required characters",
        "wymagany": "required",
        "Wymagany procent musi zawierać się w przedziale 0-100": "Required percentage must be within the range 0-100",
        "Wymiary": "Dimensions",
        "Wymuś nowe podejście - reset wyniku": "Force another approach - score reset",
        "Wymuś zmianę hasła": "Force password change",
        "Wynik": "Result",
        "Wynik (%)": "Result (%)",
        "Wynik etapu jest wymagany": "Stage result is required",
        "Wynik testu": "Test result",
        "Wyniki": "Results",
        "Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "Test results will always be limited to a maximum of 10 items.",
        "Wyniki_": "Results_",
        "Wypełnij pozycje": "Fill items",
        "Wypełnij treści zakładek": "Fill tab content",
        "Wyrażenia warunkowe": "Conditional expressions",
        "Wyrażenie regularne": "Regular expression",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "Expressions of the form \"/pattern/flag\" are not supported, use pattern values only",
        "Wyrażone zgody": "Consents given",
        "Wysłane": "Sent",
        "Wysoka szczegółowość": "High detail",
        "Wysoki": "High",
        "Wysokość": "Height",
        "Wysokość [px": "Height [px",
        "Wystapił błąd podczas kopiwaniu linku.": "An error occurred while copying the link.",
        "wystąpieniach": "occurrences",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "An error occurred while loading the image. Try again.",
        "Wystąpił błąd podczas próby exportu użytkowników.": "An error occurred while trying to export users.",
        "Wystąpił błąd podczas próby exportu zamówień.": "Error occurred during order export attempt.",
        "Wystąpił błąd podczas próby exportu.": "An error occurred during export attempt.",
        "Wystąpił błąd podczas próby importu definicji modułu.": "An error occurred during module definition import attempt.",
        "Wystąpił błąd podczas próby importu przekierowań.": "An error occurred during redirect import attempt.",
        "Wystąpił błąd podczas próby importu użytkowników.": "An error occurred while trying to import users.",
        "Wystąpił błąd podczas próby pobrania szablonu.": "An error occurred during template download attempt.",
        "Wystąpił błąd podczas próby pobrania szczegółów.": "An error occurred during details download attempt.",
        "Wystąpił błąd podczas przełączania się między wątkami.": "An error occurred while switching between threads.",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "A connection error has occurred. Make sure you are online and try again.",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "A server error occurred while handling the selected operation. Please try again.",
        "Wystąpił błąd. Nie udało się zmienić statusu.": "An error occurred. Failed to change status.",
        "Wystąpił błąd. Spróbuj ponownie później.": "An error has occurred. Please try again later.",
        "Wystąpił nieznany błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Unknown server error occurred while handling selected operation. Try again.",
        "Wystąpił problem podczas przesyłania obrazu.": "Problem occurred while uploading image.",
        "Wystąpił problem z pobraniem certyfikatu": "Problem occurred while fetching certificate",
        "Wystąpił problem z pobraniem wiadomości.": "Problem occurred while fetching messages.",
        "Wystąpił problem z potwierdzeniem obecności": "Problem occurred while confirming attendance",
        "Wystąpił problem z usunieciem wątku.": "Problem occurred while deleting thread.",
        "Wystąpiły błędy podczas zapisywania formularza": "Errors occurred while saving form",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "Form contains errors. Check all form fields.",
        "Wysyłaj dane o użytkowniku": "Send user data",
        "Wysyłaj tym kanałem": "Send through this channel",
        "Wyszukaj": "Search",
        "Wyszukaj (Ctrl+Q)": "Search (Ctrl+Q)",
        "Wyszukaj albo dodaj nową kategorię": "Search or add new category",
        "Wyszukaj albo dodaj nowy tag": "Search for or add a new tag",
        "Wyszukaj autora...": "Search authors...",
        "Wyszukaj blok": "Search blocks",
        "Wyszukaj czołówkę...": "Search front view...",
        "Wyszukaj formularz...": "Search forms...",
        "Wyszukaj kategorię": "Search category",
        "Wyszukaj produkt...": "Search product...",
        "Wyszukaj regulamin...": "Search regulations...",
        "Wyszukaj szkolenie...": "Search training...",
        "Wyszukaj użytkownika": "Search users",
        "wyszukaj użytkownika...": "search users...",
        "Wyszukaj użytkownika...": "Search user...",
        "Wyszukaj widget": "Search widget",
        "Wyszukaj wszędzie": "Search everywhere",
        "Wyszukaj zespół": "Search teams",
        "Wyszukaj...": "Search...",
        "Wyszukiwanie": "Search",
        "Wyszukiwanie plików": "File search",
        "Wyszukiwanie plików umożliwia asystentowi korzystanie z wiedzy z plików. Po przesłaniu pliku asystent automatycznie decyduje, kiedy pobrać treść, na podstawie żądań użytkownika.": "File search allows the assistant to use knowledge from files. After uploading a file, the assistant automatically decides when to fetch content based on user requests.",
        "Wyszukiwanie zwraca tylko zaakceptowane wersje regulaminów": "Search returns only accepted versions of regulations",
        "Wyszukiwany ciąg znaków": "Search set of characters",
        "Wyszukiwarka włączona": "Search engine enabled",
        "Wyszukiwarka wyłączona": "Search engine disabled",
        "Wyślij": "Send",
        "Wyślij do": "Send to",
        "Wyślij kod": "Send the code",
        "Wyślij wiadomość": "Send message",
        "Wyświetl materiały": "View materials",
        "Wyświetl popup z kontynuacją lekcji": "View the popup with the continuation of the lesson",
        "Wyświetl w ulubionych": "Display in favorites",
        "Wyświetlaj artykuł na całą stronę": "Display article on full page",
        "Wyświetlaj listę artykułów z miniaturką zdjęcia": "Display list of articles with photo thumbnail",
        "Wyświetlaj nazwę bloczka": "Display block name",
        "Wyświetlaj opinie z tłem": "Display opinions with background",
        "Wyświetlaj tylko treść": "Display content only",
        "Wyświetlaj tytuł": "Display title",
        "Wyświetlam": "Displaying",
        "Wyświetlanie": "Displaying",
        "Wyświetlanie dokumentów": "Document display",
        "Wyświetlany układ / dane": "Displayed layout / data",
        "Wytnij": "Cut",
        "Wytyczne dla Kreatora szkoleń": "Guidelines for Training Creator",
        "Wytyczne dotyczące tworzenia szkoleń w kreatorze AI": "Guidelines for creating training in AI creator",
        "Wywołanie funkcji": "Function call",
        "Wyzeruj licznik": "Reset counter",
        "Wyzwalacze": "Triggers",
        "Wyżej": "Above",
        "Wzorzec": "Pattern",
        "Wzorzec cyklu": "Cycle pattern",
        "YouTube (ID)": "YouTube (ID)",
        "z maksymalnie 240 znaków": "up to 240 characters",
        "z maksymalnie 580 znaków": "up to 580 characters",
        "Z uprawnieniami": "With privileges",
        "Z uprawnieniami do modułu": "With module privileges",
        "Zaakceptowane": "Accepted",
        "Zaakceptowany": "Accepted",
        "Zaawansowane": "Advanced",
        "Zaawansowane polecenia": "Advanced commands",
        "Zaawansowane uprawnienia": "Advanced privileges",
        "Zaawansowany edytor tekstu": "Advanced text editor",
        "Zabierz dostęp": "Take away access",
        "Zablokowany": "Blocked",
        "Zablokuj": "Block",
        "Zablokuj użytkownika": "Block user",
        "Zachowaj oryginalny format obrazów": "Preserve original image format",
        "zacznij pisać aby wyszukać ankietę...": "start typing to search for a survey...",
        "zacznij pisać aby wyszukać ankiety...": "start typing to search surveys...",
        "zacznij pisać aby wyszukać artykuł...": "start typing to search for an article...",
        "zacznij pisać aby wyszukać autora...": "start typing to search for an author...",
        "zacznij pisać aby wyszukać certyfikat...": "start typing to search for a certificate...",
        "zacznij pisać aby wyszukać galerię...": "start typing to search gallery...",
        "zacznij pisać aby wyszukać kategorię...": "start typing to search for a category...",
        "zacznij pisać aby wyszukać materiał...": "start typing to search for material...",
        "zacznij pisać aby wyszukać paczkę SCORM...": "start typing to search for a SCORM package...",
        "zacznij pisać aby wyszukać produkt...": "start typing to search product...",
        "zacznij pisać aby wyszukać przełożonego...": "start typing to search supervisor...",
        "zacznij pisać aby wyszukać rotator...": "start typing to search rotator...",
        "zacznij pisać aby wyszukać slajder...": "start typing to search for a slider...",
        "zacznij pisać aby wyszukać spotkanie...": "start typing to search meeting...",
        "zacznij pisać aby wyszukać szkolenie...": "start typing to search for a course...",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search for a user...",
        "zacznij pisać aby wyszukać wideo...": "start typing to search video...",
        "zacznij pisać aby wyszukać wydarzenie...": "start typing to search event...",
        "zacznij pisać aby wyszukać wydział...": "start typing to search department...",
        "zacznij pisać aby wyszukać zespół...": "start typing to search for a team...",
        "zacznij pisać aby wyszukać...": "start typing to search...",
        "Zacznij pisać Form lub Entry aby uruchomić podpowiadanie.": "Start typing Form or Entry to trigger suggestions.",
        "Zaczyna sie od": "Starts with",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "Rebuilding the indices has begun.",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "Reindexing data has begun.",
        "Zadanie zostało uruchomione.": "The task has started.",
        "Zadanie zostało włączone": "Task has been enabled",
        "Zadanie zostało wyłączone": "Task has been disabled",
        "Zagrożenie": "Threat",
        "Zaimportowano definicję modułu.": "Module definition imported.",
        "Zaimportowano listę przekierowań.": "Redirect list imported.",
        "Zaimportowano listę użytkowników.": "The list of users has been imported.",
        "Zajawka": "Sneak peek",
        "Zakładka ": "Tab ",
        "Zakładki": "Tabs",
        "Zakolejkowane": "Pending",
        "Zakończ edycje": "Finish edit",
        "Zakończ sesję": "End session",
        "Zakończ sesję aby wylogować użytkownika": "End session to log the user out",
        "Zakończenie spotkania": "Meeting end",
        "Zakończenie szkolenia": "Training end",
        "Zakończenie zapisów": "Registration end",
        "Zakończone": "Completed",
        "Zakończony": "Completed",
        "zakończy się porażką": "will end in failure",
        "zakończy się sukcesem": "will end in success",
        "Zakończyło": "Finished",
        "Zakres": "Range",
        "Zakres cyklu": "Cycle scope",
        "Zakres czasu": "Time range",
        "Zaktualizowano pliki Kreatora szkoleń": "Training Creator files updated",
        "Zaktualizowano wątek.": "Thread updated.",
        "Zaktualizowano.": "Updated.",
        "Zaktualizuj formularz": "Update form",
        "Zaktualizuj najnowszą wersję dokumentu": "Update latest document version",
        "Zalecane wymiary 1605x450": "Recommended dimensions 1605x450",
        "Zależna od kontrolki": "Control dependent",
        "Zaliczenie": "Completion",
        "Zaliczenie testu": "Test completion",
        "Zaliczenie testu jest równoznaczne z potwierdzeniem obecności i wystawieniem certyfikatu dla użytkownika": "Test completion is equivalent to confirming attendance and issuing a certificate for the user",
        "Zaliczone": "Completed",
        "Zaliczono wszystkie elementy szkolenia.": "All training elements completed.",
        "Zaliczono wybrane elementy szkolenia.": "Selected training elements completed.",
        "Zaliczony": "Completed",
        "Zalogowany": "Logged in",
        "Zaloguj się": "Sign In",
        "Zaloguj się na swoje konto": "Log in to your account",
        "Załączniki": "Attachments",
        "Załączniki premium": "Premium attachments",
        "Zamawiający": "Ordering party",
        "Zamiany zostały zapisane.": "The changes have been saved.",
        "Zamknij": "Close",
        "Zamknij i pobierz": "Close and download",
        "Zamówienia": "Orders",
        "Zamówienie": "Order",
        "Zamówienie zostało dodane.": "Order has been added.",
        "Zamówienie zostało zaktualizowane.": "Order has been updated.",
        "Zamykaj wcześniej otwarte pozycje": "Close previously opened items",
        "Zaokraglone rogi [px": "Rounded corners [px",
        "Zaokrąglenie": "Rounding",
        "Zapamiętaj logowanie": "Remember login",
        "Zapamiętane urządzenia": "Remembered devices",
        "Zapis nowej wersji elementu szkolenia": "Saving new version of the course component",
        "Zapis został usunięty": "The record has been deleted",
        "Zapisani": "Registered",
        "Zapisuj do celu": "Save to target",
        "Zapisywanie obrazów zakończone.": "Image saving completed.",
        "Zapisz": "Save",
        "Zapisz aranżację": "Save arrangement",
        "Zapisz filtr": "Save filter",
        "Zapisz i wróć": "Save and return",
        "Zapisz i wyślij": "Save and send",
        "Zapisz i zamknij": "Save and close",
        "Zapisz lekcję": "Save lesson",
        "Zapisz lekcję scorm": "Save SCORM lesson",
        "Zapisz lekcję scorm w nowej wersji": "Save SCORM lesson in new version",
        "Zapisz lekcję w nowej wersji": "Save lesson in new version",
        "Zapisz lekcję wideo": "Save video lesson",
        "Zapisz lekcję wideo w nowej wersji": "Save video lesson in new version",
        "Zapisz link": "Save link",
        "Zapisz link w nowej wersji": "Save link in new version",
        "Zapisz pozycje": "Save positions",
        "Zapisz slajd": "Save slide",
        "Zapisz ścieżkę aby móc ją opublikować.": "Save the path in order to publish it.",
        "Zapisz temat": "Save topic",
        "Zapisz test": "Save test",
        "Zapisz test w nowej wersji": "Save test in new version",
        "Zapisz ustawienia": "Save settings",
        "Zapisz ustawienia widgetów": "Save widget settings",
        "Zapisz widget": "Save widget",
        "Zapisz wybrane": "Save selected",
        "Zapisz zmiany": "Save changes",
        "Zaplanowane": "Scheduled",
        "Zapomniałeś hasła?": "Forgot your password?",
        "Zapytaj asystenta": "Ask assistant",
        "Zapytanie": "Query",
        "Zapytanie SQL do pobrania po ID": "SQL query to fetch by ID",
        "Zapytanie SQL do wyszukiwania": "SQL query for search",
        "Zarchiwizowane": "Archived",
        "Zarządzaj zespołami": "Manage teams",
        "Zarządzanie witrynami": "Manage sites",
        "Zarządzanie zespołami": "Team management",
        "Zasięg": "Range",
        "Zastępstwa": "Substitutions",
        "Zastępstwo": "Add a substitution",
        "Zastępstwo wygasło.": "The substitution has expired.",
        "Zastępstwo wygaśnie za 10 minut.": "The substitution will expire in 10 minutes.",
        "Zastępstwo wygaśnie za 5 minut.": "The substitution will expire in 5 minutes.",
        "Zastępstwo wygaśnie za minutę.": "The substitution will expire in a minute.",
        "Zastępstwo zostało dodane.": "The substitution has been added.",
        "Zastępstwo zostało usunięte.": "The substitution has been removed.",
        "Zastępstwo zostało zaktualizowane.": "The substitution has been updated.",
        "Zastępuje osobę": "Substituting",
        "Zastosuj zmiany w aplikacji": "Apply changes in application",
        "Zatwierdź": "Approve",
        "Zaufane adresy IP": "Trusted IP addresses",
        "Zawartość": "Content",
        "Zawiera": "Contains",
        "Zawiera sekcje": "Contains sections",
        "Zawierające jeden z wybranych tagów": "Containing one of the selected tags",
        "Zawsze": "Always",
        "Zaznacz": "Select",
        "Zaznacz wszystkie": "Select all",
        "Zaznacz/odznacz wszystko": "Select/unselect all",
        "Zbieranie i przechowywanie logów": "Log collection and storage",
        "Zbliżająca się data zakończenia": "Upcoming end date",
        "Zdarzenie": "Event",
        "Zdjęcia": "Photos",
        "Zdjęcie": "Photo",
        "Zdjęcie autora": "Author photo",
        "Zdjęcie dla tabletów": "Photo for tablets",
        "Zdjęcie dla urządzeń mobilnych": "Photo for mobile devices",
        "Zdjęcie główne": "Main photo",
        "Zdjęcie użytkownika": "User's photo",
        "Zdjęcie w tle": "Background photo",
        "Zespoły": "Teams",
        "Zespół": "Team",
        "Zespół aktywny": "Active team",
        "Zespół został dodany.": "The team has been added.",
        "Zespół został przypisany do szkolenia.": "The team was assigned to the course.",
        "Zespół został przypisany do ścieżki szkoleniowej.": "The team has been assigned to a learning path.",
        "Zespół został przypisany do terminu.": "Team has been assigned to the date.",
        "Zespół został usunięty.": "The team has been removed.",
        "Zespół został zaktualizowany.": "The team has been updated.",
        "Zestaw": "Set",
        "Zestaw niestandardowy": "Custom set",
        "Zestaw został dodany.": "The set has been added.",
        "Zestaw został zaktualizowany.": "The set has been updated.",
        "Zewnętrzne skrypty statystyk": "External statistics scripts",
        "Zewnętrzne skrypty targetujące": "External targeting scripts",
        "Zewnętrzny link jest wymagany": "External link is required",
        "Zewnętrzny serwis": "External service",
        "Zgłaszanie komentarzy": "Reporting comments",
        "Zgłoszenia": "Issues",
        "Zgoda": "Consent",
        "Zielony": "Green",
        "Zliczanie": "Counting",
        "Zmiana hasła": "Password change",
        "Zmiana rozmiaru obrazu": "Resize an image",
        "Zmiana ustawień może doprowadzić do utraty dostępu do panelu!nnCzy na pewno chcesz zapisać zmiany??": "Changing settings may result in losing access to the panel!nnAre you sure you want to save changes??",
        "Zmiana wersji elementu nie dotyczy użytkowników z zakończonym szkoleniem": "Component version change does not apply to users who have completed the course",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "Monitoring settings changes require application restart.",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "The changes will not take effect until the indexes have been rebuilt.",
        "Zmiany zostały zapisane.": "Changes have been saved.",
        "Zmiany zostaną zastosowane w aplikacji w przeciągu kikunastu sekund": "Changes will be applied in the application within a few seconds",
        "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "The variable %HEAD_TITLE% can be used in other text boxes.",
        "Zmieniono ustawienia widgetu": "Widget settings changed",
        "Zmienna": "Variable",
        "Zmienna musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "Variable must start with a lowercase letter and can only contain alphanumeric characters",
        "Zmień daty publikacji": "Change publication dates",
        "Zmień hasło": "Change password",
        "Zmień nazwę": "Rename",
        "Zmień nazwę katalogu": "Rename a directory",
        "Zmień nazwę pliku": "Rename a file",
        "Zmień rozmiar": "Resize",
        "Zmień status": "Change status",
        "Zmień status edytowanej wersji": "Change the status of the edited version",
        "Zmień widok": "Change view",
        "Zmniejsz": "Reduce",
        "zmodyfikował": "modified",
        "Zmodyfikował": "Modified by",
        "zmodyfikowany": "modified",
        "Znajdź typ bloku...": "Find block type...",
        "znaki": "characters",
        "Znaki specialne": "Special characters",
        "Zobacz przed opublikowaniem": "View before publishing",
        "Zobacz sesję użytkownika": "View user session",
        "Zobacz szczegóły": "See details",
        "Zobacz szczegóły sesji użytkownika": "View user session details",
        "Zobacz szczegóły zdarzenia": "View event details",
        "Zobacz wszystkie": "See all",
        "Zobacz wszystkie zastępstwa": "View all substitutions",
        "Został przywrócony oryginalny harmonogram": "Original schedule has been restored",
        "został wysłany": "has been sent",
        "Zostaną zaktualizowane definicje wszystkich dokumentów.": "Definitions for all documents will be updated.",
        "Zrealizowane": "Fulfilled",
        "Zresetowano podejście.": "Approach reset.",
        "Zresetuj hasło": "Reset password",
        "zresetuj podejście do elementu szkolenia": "reset approach to training element",
        "Zrestartuj aplikacje": "Restart application",
        "Zrezygnowano z subskrypcji": "Subscription canceled",
        "Zużyte tokeny": "Used tokens",
        "Zwrócony": "Returned",
        "Zwykłe": "Regular",
        "Źródła danych": "Data Sources",
        "Źródła LDAP": "LDAP sources",
        "Źródła logów": "Log sources",
        "Źródło": "Source",
        "Źródło aktywne": "Active source",
        "Źródło danych": "Data source",
        "źródło danych zostało dodane.": "the data source has been added.",
        "Źródło danych zostało zaktualizowane.": "The data source has been updated.",
        "Źródło LDAP zostało dodane.": "An LDAP source has been added.",
        "Źródło LDAP zostało zaktualizowane.": "The LDAP source has been updated.",
        "Źródło URL": "URL source",
        "źródło zostało usunięte.": "the source has been removed.",
        "Źródło zostało usunięte.": "Source has been deleted.",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "No communication channel has been enabled in the notification settings.",
        "Żółty": "Yellow",
        "Żródło danych": "Data source"
    }
};
